/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = T | null | undefined;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format. */
  DateTime: { input: any; output: any; }
  /** An object that links a geometry to properties in order to provide context. */
  GeoJSONFeature: { input: any; output: any; }
  /** A collection of GeoJSON Features. */
  GeoJSONFeatureCollection: { input: any; output: any; }
  /** A GeoJSON Object */
  GeoJSONGeometry: { input: any; output: any; }
  /** GeoJSON Object describing a single geographical LineString. */
  GeoJSONLineString: { input: any; output: any; }
  /** GeoJSON Object describing a single geographical point. */
  GeoJSONPoint: { input: any; output: any; }
  /** GeoJSON Object describing a single geographical Polygon. */
  GeoJSONPolygon: { input: any; output: any; }
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: { input: any; output: any; }
  /** A field whose value conforms with the standard mongodb object ID as described here: https://docs.mongodb.com/manual/reference/method/ObjectId/#ObjectId. Example: 5e5677d71bdc2ae76344968c */
  ObjectID: { input: any; output: any; }
  /** A field whose value conforms to the standard URL format as specified in RFC3986: https://www.ietf.org/rfc/rfc3986.txt. */
  URL: { input: any; output: any; }
  /** A field whose value is a generic Universally Unique Identifier: https://en.wikipedia.org/wiki/Universally_unique_identifier. */
  UUID: { input: any; output: any; }
  /** The `Upload` scalar type represents a file upload. */
  Upload: { input: any; output: any; }
};

export type AccessPointEntity = {
  /** Structured postal address of this entrance/exit, when it has one distinct from the facility. */
  address?: Maybe<Address>;
  /** GPS position of this entrance/exit. */
  location?: Maybe<Scalars['GeoJSONPoint']['output']>;
  /** Maximum vehicle height allowed through this access point, in metres. */
  maxHeight?: Maybe<Scalars['Float']['output']>;
  /** Human-readable label for this entrance/exit. */
  name?: Maybe<Scalars['String']['output']>;
  type: AccessPointType;
  usage?: Maybe<AccessUsage>;
};

export type AccessPointInput = {
  /** Structured postal address of this entrance/exit, when it has one distinct from the facility. */
  address?: InputMaybe<AddressInput>;
  /** GPS position of this entrance/exit. */
  location: Scalars['GeoJSONPoint']['input'];
  /** Maximum vehicle height allowed through this access point, in metres. */
  maxHeight?: InputMaybe<Scalars['Float']['input']>;
  /** Human-readable label for this entrance/exit. */
  name?: InputMaybe<Scalars['String']['input']>;
  type: AccessPointType;
  usage?: InputMaybe<AccessUsage>;
};

/** Whether an access point lets vehicles in, out, or both. */
export enum AccessPointType {
  /** Way in only. */
  Entrance = 'entrance',
  /** Both a way in and a way out. */
  EntranceExit = 'entranceExit',
  /** Way out only. */
  Exit = 'exit'
}

/** Who may use an access point: vehicles, pedestrians, or both. */
export enum AccessUsage {
  Both = 'both',
  Pedestrian = 'pedestrian',
  Vehicle = 'vehicle'
}

export enum Activity {
  /** loading */
  Loading = 'loading',
  /** no loading */
  NoLoading = 'noLoading',
  /** no parking */
  NoParking = 'noParking',
  /** no stopping */
  NoStopping = 'noStopping',
  /** no travel */
  NoTravel = 'noTravel',
  /** no unloading */
  NoUnloading = 'noUnloading',
  /** parking */
  Parking = 'parking',
  /** stopping */
  Stopping = 'stopping',
  /** travel */
  Travel = 'travel',
  /** unloading */
  Unloading = 'unloading'
}

/**
 * A date range for activity queries. `to` must be after `from` and within the
 * supported maximum span.
 */
export type ActivityWindowInput = {
  from: Scalars['DateTime']['input'];
  to: Scalars['DateTime']['input'];
};

export type Address = {
  city: Scalars['String']['output'];
  country: Scalars['String']['output'];
  postalCode: Scalars['String']['output'];
  province?: Maybe<Scalars['String']['output']>;
  streetName: Scalars['String']['output'];
  streetNumber: Scalars['String']['output'];
};

export type AddressInput = {
  city: Scalars['String']['input'];
  country: Scalars['String']['input'];
  postalCode: Scalars['String']['input'];
  province?: InputMaybe<Scalars['String']['input']>;
  streetName: Scalars['String']['input'];
  streetNumber: Scalars['String']['input'];
};

export type AttendanceDay = {
  /** One entry per hour of day, 0-23. */
  byHour: Array<AttendanceHour>;
  /** ISO weekday (Monday = 1 ... Sunday = 7). */
  dayOfWeek: Scalars['Int']['output'];
};

export type AttendanceHour = {
  /** Hour of day in the parking's local time, 0-23. */
  hour: Scalars['Int']['output'];
  /** Typical share of capacity in use during this hour, 0-100; null when nothing was observed. */
  occupancyPct?: Maybe<Scalars['Float']['output']>;
};

export type AttendanceWeekday = {
  /** ISO weekday (Monday = 1 ... Sunday = 7). */
  dayOfWeek: Scalars['Int']['output'];
  /** Typical share of capacity in use across the whole day, 0-100; null when nothing was observed. */
  occupancyPct?: Maybe<Scalars['Float']['output']>;
};

export type Availability = {
  end?: Maybe<Scalars['Float']['output']>;
  geoPoint2d: Array<Scalars['Float']['output']>;
  occupied?: Maybe<Scalars['Boolean']['output']>;
  start?: Maybe<Scalars['Float']['output']>;
  timestamp: Scalars['DateTime']['output'];
  vehicleType?: Maybe<Scalars['Float']['output']>;
};

export type BulkCreateRestrictionsInput = {
  restrictions: Array<CreateRestrictionInput>;
};

export type BulkUpdateRestrictionsInput = {
  restrictions: Array<UpdateRestrictionInput>;
};

export enum CardinalDirection {
  E = 'E',
  N = 'N',
  Ne = 'NE',
  Nw = 'NW',
  S = 'S',
  Se = 'SE',
  Sw = 'SW',
  W = 'W'
}

export type City = {
  /** City Boundaries */
  boundaries?: Maybe<Scalars['GeoJSONGeometry']['output']>;
  /** Other details about the city */
  details?: Maybe<CityDetails>;
  /** Unique city ID */
  id: Scalars['ID']['output'];
  /** Image associated to the city */
  image?: Maybe<Scalars['String']['output']>;
  /** Name of the city */
  name: Scalars['String']['output'];
  /** GeoJSON position of the city */
  position?: Maybe<Array<Scalars['Float']['output']>>;
  /** City ZIP code */
  zipCode?: Maybe<Scalars['String']['output']>;
};

export type CityDetails = {
  /** Country of the city */
  country?: Maybe<Scalars['String']['output']>;
  /** Country code of the city */
  countryCode?: Maybe<Scalars['String']['output']>;
  /** Currency used in the city */
  currency?: Maybe<CurrencyEntity>;
  /** Data Provider details */
  dataProvider?: Maybe<DataProviderDetails>;
  /** Departement of the city */
  departement?: Maybe<Scalars['String']['output']>;
  /** The features city subscribed to */
  options?: Maybe<OptionsEntity>;
  /** OpenStreetMap id */
  osmId?: Maybe<Scalars['Float']['output']>;
  /** State of the city */
  state?: Maybe<Scalars['String']['output']>;
  /** Surface area of the city in km2 */
  surfaceArea?: Maybe<Scalars['Float']['output']>;
  /** Timezone of the city */
  timezone?: Maybe<TimezoneEntity>;
};

export type CityDetailsInput = {
  /** Country of the city */
  country?: InputMaybe<Scalars['String']['input']>;
  /** Country code of the city */
  countryCode?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<CurrencyInput>;
  /** Data provider details */
  dataProvider?: InputMaybe<DataProviderInput>;
  /** Departement of the city */
  departement?: InputMaybe<Scalars['String']['input']>;
  /** Options the city subscribes to */
  options?: InputMaybe<CityOptions>;
  /** OpenStreetMap id */
  osmId?: InputMaybe<Scalars['Float']['input']>;
  /** State of the city */
  state?: InputMaybe<Scalars['String']['input']>;
  /** Surface area of the city in km2 */
  surfaceArea?: InputMaybe<Scalars['Float']['input']>;
  /** Timezone of the city */
  timezone?: InputMaybe<TimezoneInput>;
};

export type CityOptions = {
  /** Is main map curb zones view available for the city */
  curbZones?: InputMaybe<Scalars['Boolean']['input']>;
  /** Configuration of the decree analysis feature */
  decreeAnalysis?: InputMaybe<DecreeAnalysisInput>;
  /** Does the city have live sensor data */
  live?: InputMaybe<Scalars['Boolean']['input']>;
  /** Does city have external map integration */
  mapIntegration?: InputMaybe<Scalars['Boolean']['input']>;
  /** Do we publish the map to the Mobile apps */
  mobileMap?: InputMaybe<Scalars['Boolean']['input']>;
  /** Is the city have offstreet parking enabled */
  offstreet?: InputMaybe<Scalars['Boolean']['input']>;
  /** Is the city have parking payment in app enabled */
  payment?: InputMaybe<Scalars['Boolean']['input']>;
  /** Is the city have on street avaialbility prediction enabled */
  prediction?: InputMaybe<Scalars['Boolean']['input']>;
  /** Waze data feed URL */
  wazeFeedUrl?: InputMaybe<Scalars['String']['input']>;
};

export type CityPaginatedResult = {
  /** Available filters */
  filters?: Maybe<Scalars['JSON']['output']>;
  results: Array<City>;
  /** Total number of items */
  totalCount: Scalars['Int']['output'];
  /** Total number of pages */
  totalPages: Scalars['Int']['output'];
};

export type Color = {
  dashed?: Maybe<Scalars['Boolean']['output']>;
  fillColor?: Maybe<Array<Scalars['Float']['output']>>;
  icon?: Maybe<Scalars['String']['output']>;
  iconColor?: Maybe<IconColor>;
  lineColor?: Maybe<Array<Scalars['Float']['output']>>;
};

export type ColorInput = {
  /** Specify if boder is dashed */
  dashed?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * The fill color of the curbzone
   * Sepcial as an array of 3 or 4 integers between 0 and 255, representing RGB or RGBA values.
   * eg: [255, 0, 0] or [255, 0, 0, 255]
   */
  fillColor?: InputMaybe<Array<Scalars['Float']['input']>>;
  /** Icon to show on the map */
  icon?: InputMaybe<Scalars['String']['input']>;
  /** Icon color to show on the map */
  iconColor?: InputMaybe<IconColor>;
  /**
   * The border color of the curbzone
   * Sepcial as an array of 3 or 4 integers between 0 and 255, representing RGB or RGBA values.
   * eg: [255, 0, 0] or [255, 0, 0, 255]
   */
  lineColor?: InputMaybe<Array<Scalars['Float']['input']>>;
};

export type CreateCityInput = {
  /** City Boundaries */
  boundaries?: InputMaybe<Scalars['GeoJSONGeometry']['input']>;
  /** Other details about the city */
  details?: InputMaybe<CityDetailsInput>;
  /** Image associated to the city */
  image?: InputMaybe<Scalars['String']['input']>;
  /** Name of the city */
  name: Scalars['String']['input'];
  /** GeoJSON position of the city */
  position?: InputMaybe<Array<Scalars['Float']['input']>>;
  /** City ZIP code */
  zipCode: Scalars['String']['input'];
};

export type CreateCurbAreaInput = {
  /** Macaron custom data */
  cityId: Scalars['String']['input'];
  /** The spatial extent of this curb area. */
  geometry: Scalars['GeoJSONPolygon']['input'];
  /** The name of this curb area for reference. */
  name?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
};

export type CreateCurbZoneInput = {
  /** If availability information is present, the timestamp corresponding to the most recent time that availability was computed for this zone. */
  availabilityTime?: InputMaybe<Scalars['DateTime']['input']>;
  /**
   * If availability information is present, an array of numbers containing the lengths (in meters) of all known non-overlapping available spaces within this Curb Zone.
   * In cases where availability is known less precisely, this data MAY be inferred from a model.
   */
  availableSpaceLengths?: InputMaybe<Array<Scalars['Float']['input']>>;
  /** Macaron custom data */
  calculatedArea: Scalars['Float']['input'];
  calculatedSpaces: Scalars['Float']['input'];
  cityId: Scalars['String']['input'];
  /** The name of the cross street at the end of this Curb Zone. */
  crossStreetEndName?: InputMaybe<Scalars['String']['input']>;
  /**
   * The name of the cross street at or before the start of this Curb Zone
   * (which cross street is at the start and end of the location is defined in the same direction as the linear reference for this curb;
   * if no linear reference is provided, start and end SHOULD be oriented such that start comes before end when moving in the direction
   * of travel for the roadway immediately adjacent to the curb.)
   */
  crossStreetStartName?: InputMaybe<Scalars['String']['input']>;
  /**
   * The ID(s) of the Curb Areas that this Curb Zone is a part of.
   * If specified, the areas identified MUST be retrievable through the Curb API and its geographical area MUST contain that of the Curb Zone.
   */
  curbAreaIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** An array of IDs of Policy objects. Together, these define the regulations of this Curb Zone. */
  curbPolicyIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /**
   * The ID(s) of the Curb Spaces that this Curb Zone contains.
   * If specified, the spaces identified MUST be retrievable through the Curb API and its geographical area MUST be contained in this Curb Zone.
   */
  curbSpaceIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  decreeIds?: InputMaybe<Array<Scalars['String']['input']>>;
  editLine: Scalars['GeoJSONFeature']['input'];
  /**
   * The time at which the data for this curb location ceases to be valid (exclusive, see Range Boundaries).
   * If not present, the data will be presumed to be valid indefinitely
   */
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  /**
   * If "true", this curb location takes up the entire width of the roadway (which may be impassible for through traffic when
   * the Curb Zone is being used for parking or loading).
   * This is a common condition for alleyways. If entireRoadway is true, streetSide MUST NOT be present.
   */
  entireRoadway?: InputMaybe<Scalars['Boolean']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  geoPoint2d: Array<Scalars['Float']['input']>;
  /** The spatial extent of this curb zone. A new curbZoneId is required if this geometry changes. */
  geometry: Scalars['GeoJSONPolygon']['input'];
  /**
   * The length, in meters, of the Curb Zone when projected along the street centerline.
   * Note that this is the definitive length of the curb area, and not the edge length of the geographic polygon.
   */
  length?: InputMaybe<Scalars['Float']['input']>;
  /** One or more linear references for this Curb Zone. */
  locationReferences?: InputMaybe<Array<LocationReferenceInput>>;
  /**
   * If "true", this curb location is on the median of a street, rather than its edge.
   * A median is a strip of land separating two roadways within the same street.
   * Note that, for medians, streetSide is interpreted relative to the roadway that the particular curb is on,
   * so the curb along the median of the southern roadway of a divided street would have streetSide of N.
   */
  median?: InputMaybe<Scalars['Boolean']['input']>;
  /** A human-readable name for this Curb Zone that identifies it to end users. */
  name?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  /** The number of demarcated spaces within this Curb Zone. Demarcated spaces may also be specified using Curb Spaces. */
  numSpaces?: InputMaybe<Scalars['Float']['input']>;
  /**
   * The angle in which passenger vehicles in this Curb Zone are meant to park. May take one of the following values:
   *
   * parallel
   * perpendicular
   * angled
   */
  parkingAngle?: InputMaybe<ParkingAngle>;
  /** An array of IDs of previous curb zone objects. They are listed in order with the most recent ones first. */
  prevCurbZoneIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** An array of information about previous policies that have applied to this curb zone. They are listed in order with the most recent ones first. */
  prevPolicies?: InputMaybe<Array<PreviousPolicyInput>>;
  /** The name of the street that this Curb Zone is on. */
  streetName?: InputMaybe<Scalars['String']['input']>;
  streetNumberEnd?: InputMaybe<Scalars['String']['input']>;
  streetNumberStart?: InputMaybe<Scalars['String']['input']>;
  /**
   * The cardinal or subcardinal direction representing the side of the roadway that this curb is on.
   * May be N, NE, E, SE, S, SW, W, or NW.
   * For cities with "grid directions", the side MAY be based on the grid direction rather than the closest true-north compass direction,
   * but MUST NOT be more than 90 degrees away from the true compass direction.
   */
  streetSide?: InputMaybe<CardinalDirection>;
  /** An identifier that can be used to refer to this Curb Zone on physical signage as well as within mobile applications, typically for payment purposes. */
  userZoneId?: InputMaybe<Scalars['String']['input']>;
  /** The width, in meters, that the Curb Zone occupies from the curb to the roadway lane. */
  width?: InputMaybe<Scalars['Float']['input']>;
};

export type CreateOffStreetParkingInput = {
  /** Payment methods accepted at the facility. */
  acceptedPaymentMethods?: InputMaybe<Array<PaymentMethod>>;
  /** Entrances and exits of the facility, each with its own type, position and address. */
  accessPoints?: InputMaybe<Array<AccessPointInput>>;
  /** Who is allowed to use the facility. */
  accessType?: InputMaybe<ParkingAccessType>;
  address: Scalars['String']['input'];
  /** Structured postal address of the facility. */
  addressDetails?: InputMaybe<AddressInput>;
  /** Footprint of the facility building or lot. */
  boundary?: InputMaybe<Scalars['GeoJSONPolygon']['input']>;
  cityId: Scalars['String']['input'];
  externalId?: InputMaybe<Scalars['String']['input']>;
  /** Physical construction of the facility. */
  layout?: InputMaybe<ParkingLayout>;
  /** Number of levels */
  levels?: InputMaybe<Scalars['Float']['input']>;
  location: Scalars['GeoJSONPoint']['input'];
  /** Maximum vehicle height allowed, in metres. */
  maxHeight?: InputMaybe<Scalars['Float']['input']>;
  /** Maximum vehicle length allowed, in metres. */
  maxLength?: InputMaybe<Scalars['Float']['input']>;
  /** Maximum vehicle weight allowed, in tonnes. */
  maxWeight?: InputMaybe<Scalars['Float']['input']>;
  /** Maximum vehicle width allowed, in metres. */
  maxWidth?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  /** If specified, this opening hours of the parking */
  openingHours?: InputMaybe<Array<TimeSpanInput>>;
  /** Name of the company operating the facility. */
  operator?: InputMaybe<Scalars['String']['input']>;
  /** Options of the private parking */
  options?: InputMaybe<OffStreetParkingOptionsInput>;
  /**
   * Legacy free-text secondary entrances. Superseded by `accessPoints`.
   * @deprecated Use `accessPoints`.
   */
  otherAdresses?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Contact phone number for the facility. */
  phone?: InputMaybe<Scalars['String']['input']>;
  pricePerHour?: InputMaybe<Scalars['Float']['input']>;
  /** Legacy free-text construction type. Prefer `layout`. */
  structure?: InputMaybe<Scalars['String']['input']>;
  totalPlaces?: InputMaybe<Scalars['Float']['input']>;
  /** Website of the facility. */
  website?: InputMaybe<Scalars['String']['input']>;
};

export type CreateParkingLotInput = {
  /** The address of this parking lot for reference. */
  address?: InputMaybe<Scalars['String']['input']>;
  /** Macaron custom data */
  cityId: Scalars['String']['input'];
  /** @deprecated Ignored. Zone membership is determined by the parking lot geometry. */
  curbZoneIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** The spatial extent of this curb area. */
  geometry: Scalars['GeoJSONPolygon']['input'];
  /** The name of this parking lot for reference. */
  name?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
};

export type CreateParkingMeterInput = {
  address: AddressInput;
  /** Battery level of the parking meter if available */
  batteryLevel?: InputMaybe<Scalars['Float']['input']>;
  /** Brand of of the parking meter */
  brand: Scalars['String']['input'];
  /** City id */
  cityId: Scalars['String']['input'];
  /** External id */
  externalId?: InputMaybe<Scalars['String']['input']>;
  /** Last maintenance date */
  lastMaintenanceDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Location */
  location: Scalars['GeoJSONPoint']['input'];
  /** Model of the parking meter */
  model: Scalars['String']['input'];
  /** Name */
  name: Scalars['String']['input'];
  /** Operator of the parking meter */
  operator: Scalars['String']['input'];
  /** Options */
  options?: InputMaybe<ParkingMeterOptionsInput>;
  /** Status */
  status?: InputMaybe<Scalars['String']['input']>;
  /** Zone the parking meter operates in */
  zone?: InputMaybe<Scalars['String']['input']>;
};

export type CreatePermanentDecreeInput = {
  /** File to upload */
  attachedFile: Scalars['Upload']['input'];
  /** Decree category */
  category: DecreeCategory;
  /** CityID of decree */
  cityId: Scalars['String']['input'];
  /** Comments of decree */
  comments?: InputMaybe<Scalars['String']['input']>;
  /** Decree's own reference number as written in the document */
  decreeNumber?: InputMaybe<Scalars['String']['input']>;
  /** Image associated to the city */
  done?: InputMaybe<Scalars['Boolean']['input']>;
  /** File name of decree */
  name: Scalars['String']['input'];
  /** Date of decree publication */
  publishedDate: Scalars['DateTime']['input'];
  /** Title of decree */
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CreatePermitDecreeInput = {
  /** File to upload */
  attachedFile: Scalars['Upload']['input'];
  /** Decree category */
  category: DecreeCategory;
  /** CityID of decree */
  cityId: Scalars['String']['input'];
  /** Comments of decree */
  comments?: InputMaybe<Scalars['String']['input']>;
  /** Decree's own reference number as written in the document */
  decreeNumber?: InputMaybe<Scalars['String']['input']>;
  /** Image associated to the city */
  done?: InputMaybe<Scalars['Boolean']['input']>;
  /** End date of the permit */
  endDate: Scalars['DateTime']['input'];
  /** File name of decree */
  name: Scalars['String']['input'];
  /** Name of the petitionner */
  petitionnerName?: InputMaybe<Scalars['String']['input']>;
  /** Date of decree publication */
  publishedDate: Scalars['DateTime']['input'];
  /** Start date of the permit */
  startDate: Scalars['DateTime']['input'];
  /** Title of decree */
  title?: InputMaybe<Scalars['String']['input']>;
  /** Type of permit */
  type: PermitType;
};

export type CreatePolicyInput = {
  category: PolicyCategory;
  cityId: Scalars['String']['input'];
  color?: InputMaybe<ColorInput>;
  /**
   * An array of Data Source Operator IDs that this policy only applies to.
   * IDs come from dataSourceOperators.csv file here in the CDS repo.
   * Read our How to Get a Data Source Operator ID guide.
   */
  dataSourceOperatorId?: InputMaybe<Array<Scalars['UUID']['input']>>;
  name: Scalars['String']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  /**
   * Specifies which other policies this one takes precedence over.
   * If two Policies on the same Curb Zone have overlapping Time Spans and apply to the same user class,
   * the one that applies at a given time is the one with the lowest priority.
   * E.g., a priority of 1 takes precedence over a priority of 3.
   * Two Policies that apply to the same Curb Zone with overlapping Time Spans and equivalent User Class enumerations MUST NOT have the same priority.
   */
  priority: Scalars['Float']['input'];
  /** The rule(s) that this policy applies. If a Policy specifies multiple rules, each rule MUST specify disjoint lists of user classes. */
  rules: Array<PolicyRuleInput>;
  state?: InputMaybe<Scalars['String']['input']>;
  /** If specified, this regulation only applies at the times defined within. */
  timeSpans?: InputMaybe<Array<TimeSpanInput>>;
};

export type CreateRestrictionInput = {
  calculatedSpaces?: InputMaybe<Scalars['Float']['input']>;
  cityId: Scalars['String']['input'];
  curbZoneId?: InputMaybe<Scalars['String']['input']>;
  decreeIds?: InputMaybe<Array<Scalars['String']['input']>>;
  description?: InputMaybe<Scalars['String']['input']>;
  editLine: Scalars['GeoJSONFeature']['input'];
  geoPoint2d: Array<Scalars['Float']['input']>;
  geometry: Scalars['GeoJSONPolygon']['input'];
  /** The length of the restriction in meters. */
  length?: InputMaybe<Scalars['Float']['input']>;
  /** The name of the street that this restriction is on. */
  streetName?: InputMaybe<Scalars['String']['input']>;
  streetNumberEnd?: InputMaybe<Scalars['String']['input']>;
  streetNumberStart?: InputMaybe<Scalars['String']['input']>;
  timeSpans?: InputMaybe<Array<TimeSpanInput>>;
  type?: InputMaybe<RestrictionType>;
  /** The width, in meters, that the Curb Zone occupies from the curb to the roadway lane. */
  width?: InputMaybe<Scalars['Float']['input']>;
};

export type CreateTemporaryDecreeInput = {
  /** File to upload */
  attachedFile: Scalars['Upload']['input'];
  /** Decree category */
  category: DecreeCategory;
  /** CityID of decree */
  cityId: Scalars['String']['input'];
  /** Comments of decree */
  comments?: InputMaybe<Scalars['String']['input']>;
  /** Decree's own reference number as written in the document */
  decreeNumber?: InputMaybe<Scalars['String']['input']>;
  /** Image associated to the city */
  done?: InputMaybe<Scalars['Boolean']['input']>;
  /** File name of decree */
  name: Scalars['String']['input'];
  /** Date of decree publication */
  publishedDate: Scalars['DateTime']['input'];
  /** Title of decree */
  title?: InputMaybe<Scalars['String']['input']>;
  /** Type of restriction */
  type: TemporaryType;
};

export type CreateUrbanFeaturesInput = {
  address: AddressInput;
  cityId: Scalars['String']['input'];
  editLine?: InputMaybe<Scalars['GeoJSONFeature']['input']>;
  geometry: Scalars['GeoJSONGeometry']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  type: UrbanFeatureType;
  width?: InputMaybe<Scalars['Float']['input']>;
};

export type CreateUserReportInput = {
  /** Attached files relative URLs to storage */
  attachedFiles?: InputMaybe<Array<Scalars['Upload']['input']>>;
  /** City ID of the report */
  cityId: Scalars['ObjectID']['input'];
  /** Polygons or points where the report is located */
  features: Scalars['GeoJSONFeatureCollection']['input'];
  /** Notes to explain the report */
  note: Scalars['String']['input'];
};

export type CreateWorkAreaInput = {
  /** Macaron custom data */
  cityId: Scalars['String']['input'];
  done?: InputMaybe<Scalars['Boolean']['input']>;
  /** The spatial extent of this Work Area. */
  geometry: Scalars['GeoJSONPolygon']['input'];
  /** The name of this Work Area for reference. */
  name: Scalars['String']['input'];
};

export type CurbArea = {
  /** Macaron custom data */
  cityId: Scalars['String']['output'];
  /** The ID of this Curb Area. */
  curbAreaId: Scalars['UUID']['output'];
  /** The IDs of all the Curb Zones included within this Curb Area at the requested time. */
  curbZoneIds: Array<Scalars['UUID']['output']>;
  /** An array of Curb Zone objects. */
  curbZones: Array<CurbZone>;
  /** The spatial extent of this curb area. */
  geometry: Scalars['GeoJSONPolygon']['output'];
  /** Unique CurbArea ID, for Macaron usage only */
  id: Scalars['ID']['output'];
  /**
   * The date/time that the properties of ths curb area were last updated.
   * This helps consumers know that some curb objects fields may have changed.
   */
  lastUpdatedDate: Scalars['DateTime']['output'];
  /** The name of this curb area for reference. */
  name?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  /** The date/time that this curb area was first published in this data feed. */
  publishedDate: Scalars['DateTime']['output'];
};

export type CurbZone = {
  /** Live availability of parking spot if available */
  availabilities?: Maybe<Array<Availability>>;
  /** If availability information is present, the timestamp corresponding to the most recent time that availability was computed for this zone. */
  availabilityTime?: Maybe<Scalars['DateTime']['output']>;
  /**
   * If availability information is present, an array of numbers containing the lengths (in meters) of all known non-overlapping available spaces within this Curb Zone.
   * In cases where availability is known less precisely, this data MAY be inferred from a model.
   */
  availableSpaceLengths?: Maybe<Array<Scalars['Float']['output']>>;
  /** Curb Zone area in square meters */
  calculatedArea: Scalars['Float']['output'];
  calculatedSpaces: Scalars['Float']['output'];
  cityId: Scalars['String']['output'];
  /** The name of the cross street at the end of this Curb Zone. */
  crossStreetEndName?: Maybe<Scalars['String']['output']>;
  /**
   * The name of the cross street at or before the start of this Curb Zone
   * (which cross street is at the start and end of the location is defined in the same direction as the linear reference for this curb;
   * if no linear reference is provided, start and end SHOULD be oriented such that start comes before end when moving in the direction
   * of travel for the roadway immediately adjacent to the curb.)
   */
  crossStreetStartName?: Maybe<Scalars['String']['output']>;
  /**
   * The ID(s) of the Curb Areas that this Curb Zone is a part of.
   * If specified, the areas identified MUST be retrievable through the Curb API and its geographical area MUST contain that of the Curb Zone.
   */
  curbAreaIds?: Maybe<Array<Scalars['UUID']['output']>>;
  /** An array of Policy objects. Together, these define the regulations of this Curb Zone. */
  curbPolicies: Array<Policy>;
  /** An array of IDs of Policy objects. Together, these define the regulations of this Curb Zone. */
  curbPolicyIds: Array<Scalars['UUID']['output']>;
  /**
   * The ID(s) of the Curb Spaces that this Curb Zone contains.
   * If specified, the spaces identified MUST be retrievable through the Curb API and its geographical area MUST be contained in this Curb Zone.
   */
  curbSpaceIds?: Maybe<Array<Scalars['UUID']['output']>>;
  /** The ID of this Curb Zone. */
  curbZoneId: Scalars['UUID']['output'];
  decreeIds?: Maybe<Array<Scalars['String']['output']>>;
  /** An array of Decree objects. Together, these define the regulations of this Curb Zone. */
  decrees?: Maybe<Array<PermanentDecree>>;
  editLine: Scalars['GeoJSONFeature']['output'];
  /**
   * The time at which the data for this curb location ceases to be valid (exclusive, see Range Boundaries).
   * If not present, the data will be presumed to be valid indefinitely
   */
  endDate?: Maybe<Scalars['DateTime']['output']>;
  /**
   * If "true", this curb location takes up the entire width of the roadway (which may be impassible for through traffic when
   * the Curb Zone is being used for parking or loading).
   * This is a common condition for alleyways. If entireRoadway is true, streetSide MUST NOT be present.
   */
  entireRoadway?: Maybe<Scalars['Boolean']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  geoPoint2d: Array<Scalars['Float']['output']>;
  /** The spatial extent of this curb zone. A new curbZoneId is required if this geometry changes. */
  geometry: Scalars['GeoJSONPolygon']['output'];
  /** Unique CurbZone ID, for Macaron usage only */
  id: Scalars['ID']['output'];
  /**
   * The date/time that the properties of ths curb zone were last updated.
   * This helps consumers know that some curb objects fields may have changed.
   */
  lastUpdatedDate: Scalars['DateTime']['output'];
  /**
   * The length, in meters, of the Curb Zone when projected along the street centerline.
   * Note that this is the definitive length of the curb area, and not the edge length of the geographic polygon.
   */
  length?: Maybe<Scalars['Float']['output']>;
  /** One or more linear references for this Curb Zone. */
  locationReferences?: Maybe<Array<LocationReference>>;
  /**
   * If "true", this curb location is on the median of a street, rather than its edge.
   * A median is a strip of land separating two roadways within the same street.
   * Note that, for medians, streetSide is interpreted relative to the roadway that the particular curb is on,
   * so the curb along the median of the southern roadway of a divided street would have streetSide of N.
   */
  median?: Maybe<Scalars['Boolean']['output']>;
  /** A human-readable name for this Curb Zone that identifies it to end users. */
  name?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  /** The number of demarcated spaces within this Curb Zone. Demarcated spaces may also be specified using Curb Spaces. */
  numSpaces?: Maybe<Scalars['Float']['output']>;
  /**
   * The angle in which passenger vehicles in this Curb Zone are meant to park. May take one of the following values:
   *
   * parallel
   * perpendicular
   * angled
   */
  parkingAngle?: Maybe<ParkingAngle>;
  /** An array of IDs of previous curb zone objects. They are listed in order with the most recent ones first. */
  prevCurbZoneIds?: Maybe<Array<Scalars['UUID']['output']>>;
  /** An array of information about previous policies that have applied to this curb zone. They are listed in order with the most recent ones first. */
  prevPolicies?: Maybe<Array<PreviousPolicy>>;
  /** The date/time that this curb zone was first published in this data feed. */
  publishedDate: Scalars['DateTime']['output'];
  /**
   * The earliest time that the data for this curb location is known to be valid (inclusive, see Range Boundaries).
   * This could be the date on which the data was collected, for instance. This MUST never change for a given id.
   */
  startDate: Scalars['DateTime']['output'];
  /** The name of the street that this Curb Zone is on. */
  streetName?: Maybe<Scalars['String']['output']>;
  streetNumberEnd?: Maybe<Scalars['String']['output']>;
  streetNumberStart?: Maybe<Scalars['String']['output']>;
  /**
   * The cardinal or subcardinal direction representing the side of the roadway that this curb is on.
   * May be N, NE, E, SE, S, SW, W, or NW.
   * For cities with "grid directions", the side MAY be based on the grid direction rather than the closest true-north compass direction,
   * but MUST NOT be more than 90 degrees away from the true compass direction.
   */
  streetSide?: Maybe<CardinalDirection>;
  /** Macaron custom data */
  updates?: Maybe<Array<Update>>;
  /** An identifier that can be used to refer to this Curb Zone on physical signage as well as within mobile applications, typically for payment purposes. */
  userZoneId?: Maybe<Scalars['String']['output']>;
  /** The width, in meters, that the Curb Zone occupies from the curb to the roadway lane. */
  width?: Maybe<Scalars['Float']['output']>;
};

/**
 * Per-contributor tally of the calculated parking spaces a user has drawn
 * within a requested date range. Only zones that still exist are counted —
 * zones that were drawn and later removed are excluded — so the figure
 * reflects real delivered output.
 */
export type CurbZoneDrawActivity = {
  byDay: Array<CurbZoneDrawActivityDay>;
  calculatedSpaces: Scalars['Float']['output'];
  userId: Scalars['String']['output'];
};

export type CurbZoneDrawActivityCity = {
  calculatedSpaces: Scalars['Float']['output'];
  cityId: Scalars['String']['output'];
};

export type CurbZoneDrawActivityDay = {
  calculatedSpaces: Scalars['Float']['output'];
  day: Scalars['DateTime']['output'];
};

/**
 * Draw activity for the requested range, plus the same figures for a
 * comparison range when one is supplied, for period-over-period deltas.
 */
export type CurbZoneDrawActivityPeriods = {
  current: CurbZoneDrawActivityWindow;
  previous?: Maybe<CurbZoneDrawActivityWindow>;
};

/**
 * Draw activity within one requested range: per-contributor tallies plus the
 * calculated spaces drawn in each city. Only zones that still exist are counted.
 */
export type CurbZoneDrawActivityWindow = {
  byCity: Array<CurbZoneDrawActivityCity>;
  contributors: Array<CurbZoneDrawActivity>;
};

export type CurbZoneWithTimelines = {
  /** Live availability of parking spot if available */
  availabilities?: Maybe<Array<Availability>>;
  /** If availability information is present, the timestamp corresponding to the most recent time that availability was computed for this zone. */
  availabilityTime?: Maybe<Scalars['DateTime']['output']>;
  /**
   * If availability information is present, an array of numbers containing the lengths (in meters) of all known non-overlapping available spaces within this Curb Zone.
   * In cases where availability is known less precisely, this data MAY be inferred from a model.
   */
  availableSpaceLengths?: Maybe<Array<Scalars['Float']['output']>>;
  /** Curb Zone area in square meters */
  calculatedArea: Scalars['Float']['output'];
  calculatedSpaces: Scalars['Float']['output'];
  cityId: Scalars['String']['output'];
  /** The name of the cross street at the end of this Curb Zone. */
  crossStreetEndName?: Maybe<Scalars['String']['output']>;
  /**
   * The name of the cross street at or before the start of this Curb Zone
   * (which cross street is at the start and end of the location is defined in the same direction as the linear reference for this curb;
   * if no linear reference is provided, start and end SHOULD be oriented such that start comes before end when moving in the direction
   * of travel for the roadway immediately adjacent to the curb.)
   */
  crossStreetStartName?: Maybe<Scalars['String']['output']>;
  /**
   * The ID(s) of the Curb Areas that this Curb Zone is a part of.
   * If specified, the areas identified MUST be retrievable through the Curb API and its geographical area MUST contain that of the Curb Zone.
   */
  curbAreaIds?: Maybe<Array<Scalars['UUID']['output']>>;
  /** An array of Policy objects. Together, these define the regulations of this Curb Zone. */
  curbPolicies: Array<Policy>;
  /** An array of IDs of Policy objects. Together, these define the regulations of this Curb Zone. */
  curbPolicyIds: Array<Scalars['UUID']['output']>;
  /**
   * The ID(s) of the Curb Spaces that this Curb Zone contains.
   * If specified, the spaces identified MUST be retrievable through the Curb API and its geographical area MUST be contained in this Curb Zone.
   */
  curbSpaceIds?: Maybe<Array<Scalars['UUID']['output']>>;
  /** The ID of this Curb Zone. */
  curbZoneId: Scalars['UUID']['output'];
  decreeIds?: Maybe<Array<Scalars['String']['output']>>;
  /** An array of Decree objects. Together, these define the regulations of this Curb Zone. */
  decrees?: Maybe<Array<PermanentDecree>>;
  editLine: Scalars['GeoJSONFeature']['output'];
  /**
   * The time at which the data for this curb location ceases to be valid (exclusive, see Range Boundaries).
   * If not present, the data will be presumed to be valid indefinitely
   */
  endDate?: Maybe<Scalars['DateTime']['output']>;
  /**
   * If "true", this curb location takes up the entire width of the roadway (which may be impassible for through traffic when
   * the Curb Zone is being used for parking or loading).
   * This is a common condition for alleyways. If entireRoadway is true, streetSide MUST NOT be present.
   */
  entireRoadway?: Maybe<Scalars['Boolean']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  geoPoint2d: Array<Scalars['Float']['output']>;
  /** The spatial extent of this curb zone. A new curbZoneId is required if this geometry changes. */
  geometry: Scalars['GeoJSONPolygon']['output'];
  /** Unique CurbZone ID, for Macaron usage only */
  id: Scalars['ID']['output'];
  /**
   * The date/time that the properties of ths curb zone were last updated.
   * This helps consumers know that some curb objects fields may have changed.
   */
  lastUpdatedDate: Scalars['DateTime']['output'];
  /**
   * The length, in meters, of the Curb Zone when projected along the street centerline.
   * Note that this is the definitive length of the curb area, and not the edge length of the geographic polygon.
   */
  length?: Maybe<Scalars['Float']['output']>;
  /** One or more linear references for this Curb Zone. */
  locationReferences?: Maybe<Array<LocationReference>>;
  /**
   * If "true", this curb location is on the median of a street, rather than its edge.
   * A median is a strip of land separating two roadways within the same street.
   * Note that, for medians, streetSide is interpreted relative to the roadway that the particular curb is on,
   * so the curb along the median of the southern roadway of a divided street would have streetSide of N.
   */
  median?: Maybe<Scalars['Boolean']['output']>;
  /** A human-readable name for this Curb Zone that identifies it to end users. */
  name?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  /** The number of demarcated spaces within this Curb Zone. Demarcated spaces may also be specified using Curb Spaces. */
  numSpaces?: Maybe<Scalars['Float']['output']>;
  /**
   * The angle in which passenger vehicles in this Curb Zone are meant to park. May take one of the following values:
   *
   * parallel
   * perpendicular
   * angled
   */
  parkingAngle?: Maybe<ParkingAngle>;
  policiesTimelines: Array<MonthTimeline>;
  /** An array of IDs of previous curb zone objects. They are listed in order with the most recent ones first. */
  prevCurbZoneIds?: Maybe<Array<Scalars['UUID']['output']>>;
  /** An array of information about previous policies that have applied to this curb zone. They are listed in order with the most recent ones first. */
  prevPolicies?: Maybe<Array<PreviousPolicy>>;
  /** The date/time that this curb zone was first published in this data feed. */
  publishedDate: Scalars['DateTime']['output'];
  /**
   * The earliest time that the data for this curb location is known to be valid (inclusive, see Range Boundaries).
   * This could be the date on which the data was collected, for instance. This MUST never change for a given id.
   */
  startDate: Scalars['DateTime']['output'];
  /** The name of the street that this Curb Zone is on. */
  streetName?: Maybe<Scalars['String']['output']>;
  streetNumberEnd?: Maybe<Scalars['String']['output']>;
  streetNumberStart?: Maybe<Scalars['String']['output']>;
  /**
   * The cardinal or subcardinal direction representing the side of the roadway that this curb is on.
   * May be N, NE, E, SE, S, SW, W, or NW.
   * For cities with "grid directions", the side MAY be based on the grid direction rather than the closest true-north compass direction,
   * but MUST NOT be more than 90 degrees away from the true compass direction.
   */
  streetSide?: Maybe<CardinalDirection>;
  /** Macaron custom data */
  updates?: Maybe<Array<Update>>;
  /** An identifier that can be used to refer to this Curb Zone on physical signage as well as within mobile applications, typically for payment purposes. */
  userZoneId?: Maybe<Scalars['String']['output']>;
  /** The width, in meters, that the Curb Zone occupies from the curb to the roadway lane. */
  width?: Maybe<Scalars['Float']['output']>;
};

export type CurrencyEntity = {
  code: Scalars['String']['output'];
  symbol?: Maybe<Scalars['String']['output']>;
};

export type CurrencyInput = {
  code: Scalars['String']['input'];
  symbol?: InputMaybe<Scalars['String']['input']>;
};

export type DataProviderDetails = {
  /** Sensors ids deployed in the city */
  deviceIds?: Maybe<Array<Scalars['String']['output']>>;
  /** The name of the provider of the sensors data */
  name?: Maybe<Scalars['String']['output']>;
};

export type DataProviderInput = {
  deviceIds?: InputMaybe<Array<Scalars['String']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type DateRangeInput = {
  from: Scalars['DateTime']['input'];
  to: Scalars['DateTime']['input'];
};

export type DayTimeline = {
  daysOfMonth: Array<Scalars['Float']['output']>;
  daysOfWeek: Array<Scalars['String']['output']>;
  daysOfWeekDisplay: Scalars['String']['output'];
  segments: Array<TimelineSegment>;
};

export enum DaysOfWeek {
  Fri = 'fri',
  Mon = 'mon',
  Sat = 'sat',
  Sun = 'sun',
  Thu = 'thu',
  Tue = 'tue',
  Wed = 'wed'
}

export type Decree = IDecree & {
  /** True if decree has been analyzed by the AI */
  analyzed?: Maybe<Scalars['Boolean']['output']>;
  /** Decree category */
  category: DecreeCategory;
  /** CityID of decree */
  cityId: Scalars['String']['output'];
  /** Comments of decree */
  comments?: Maybe<Scalars['String']['output']>;
  /** Created at */
  createdAt: Scalars['DateTime']['output'];
  /** Decree's own reference number as written in the document */
  decreeNumber?: Maybe<Scalars['String']['output']>;
  /** Image associated to the city */
  done: Scalars['Boolean']['output'];
  /** Unique city ID */
  id: Scalars['ID']['output'];
  /** Name of decree */
  name: Scalars['String']['output'];
  /** Public URL of the decree */
  publicUrl?: Maybe<Scalars['String']['output']>;
  /** Date of decree publication */
  publishedDate?: Maybe<Scalars['DateTime']['output']>;
  restrictionInstructions?: Maybe<Array<RestrictionInstruction>>;
  /** Short summary of the decree for display */
  summary?: Maybe<DecreeSummary>;
  /** Title of decree */
  title?: Maybe<Scalars['String']['output']>;
};

/**
 * Decrees added within a requested date range, broken down by the person who
 * added them, by category, by type, by city, and by period. Only decrees that
 * still exist are counted. Decrees added without a known contributor are
 * excluded from the per-contributor breakdown and surfaced as
 * `unattributedCount`. Decrees whose category is not yet known are counted
 * under the `unknown` category, and those whose type is not yet known under
 * the `unknown` type.
 */
export type DecreeActivity = {
  /**
   * Number of decrees in the range that have been analyzed. Decrees whose
   * analysis status is not yet known count as not analyzed.
   */
  analyzedCount: Scalars['Int']['output'];
  byCategory: Array<DecreeActivityCategory>;
  byCity: Array<DecreeActivityCity>;
  byContributor: Array<DecreeActivityContributor>;
  byDay: Array<DecreeActivityDay>;
  byType: Array<DecreeActivityType>;
  /** Number of decrees in the range marked as done. */
  doneCount: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  unattributedCount: Scalars['Int']['output'];
};

export type DecreeActivityCategory = {
  category: Scalars['String']['output'];
  count: Scalars['Int']['output'];
};

export type DecreeActivityCity = {
  cityId: Scalars['String']['output'];
  count: Scalars['Int']['output'];
};

export type DecreeActivityContributor = {
  count: Scalars['Int']['output'];
  userId: Scalars['String']['output'];
};

export type DecreeActivityDay = {
  count: Scalars['Int']['output'];
  /**
   * Bucket label for the period. A calendar day for ranges up to a month,
   * otherwise an ISO year-week.
   */
  day: Scalars['String']['output'];
};

/**
 * Decree activity for the requested range, plus the same figures for a
 * comparison range when one is supplied, for period-over-period deltas.
 */
export type DecreeActivityPeriods = {
  current: DecreeActivity;
  previous?: Maybe<DecreeActivity>;
};

export type DecreeActivityType = {
  category: Scalars['String']['output'];
  count: Scalars['Int']['output'];
  type: Scalars['String']['output'];
};

export type DecreeAnalysisEntity = {
  /** Email address or domain the city sends its decrees from. eg: ville-courbevoie.fr */
  emailFrom?: Maybe<Scalars['String']['output']>;
  /** Dedicated email address that receives the city decrees. eg: courbevoie@macaron.ai */
  emailTo?: Maybe<Scalars['String']['output']>;
  /** Is the decree analysis feature enabled for the city */
  enabled?: Maybe<Scalars['Boolean']['output']>;
  /** URL-friendly identifier of the city used for its decree documents. eg: champigny-sur-marne */
  slug?: Maybe<Scalars['String']['output']>;
};

export type DecreeAnalysisInput = {
  /** Email address or domain the city sends its decrees from. eg: ville-courbevoie.fr */
  emailFrom?: InputMaybe<Scalars['String']['input']>;
  /** Dedicated email address that receives the city decrees. eg: courbevoie@macaron.ai */
  emailTo?: InputMaybe<Scalars['String']['input']>;
  /** Is the decree analysis feature enabled for the city */
  enabled: Scalars['Boolean']['input'];
};

export enum DecreeCategory {
  /** Not Related */
  NotRelated = 'notRelated',
  /** Permanent */
  Permanent = 'permanent',
  /** Permit */
  Permit = 'permit',
  /** Temporary */
  Temporary = 'temporary',
  /** Unknown */
  Unknown = 'unknown'
}

export type DecreeStats = {
  data?: Maybe<Array<DecreeStatsData>>;
  granularity: Scalars['String']['output'];
};

export type DecreeStatsData = {
  count: Scalars['Float']['output'];
  date: Scalars['String']['output'];
  /** @deprecated Renamed to `date`. This is a date bucket, not a unique identifier, so it collides across rows once results are split by type. */
  id: Scalars['String']['output'];
  type?: Maybe<Scalars['String']['output']>;
};

export type DecreeSummary = {
  deepDive?: Maybe<Scalars['String']['output']>;
  keyPoints?: Maybe<Array<Scalars['String']['output']>>;
  shortSummary?: Maybe<Scalars['String']['output']>;
};

export type DeletedUrbanFeatureRes = {
  id: Scalars['ID']['output'];
};

export type Detection = {
  end: Scalars['Float']['output'];
  start: Scalars['Float']['output'];
  vehicleType: Scalars['Float']['output'];
};

export type Extension = {
  /**
   * Number of the extended decree, isolated from its full reference
   * (e.g. "2024-123", "B-ART-2024-0123").
   */
  originalDecreeNumber?: Maybe<Scalars['String']['output']>;
  /**
   * Reference of the decree being extended, as written in the text
   * (e.g. "arrêté n°2024-123 du 15/03/2024").
   */
  originalDecreeReference?: Maybe<Scalars['String']['output']>;
};

export type ExtensionInput = {
  /**
   * Number of the extended decree, isolated from its full reference
   * (e.g. "2024-123", "B-ART-2024-0123").
   */
  originalDecreeNumber?: InputMaybe<Scalars['String']['input']>;
  /**
   * Reference of the decree being extended, as written in the text
   * (e.g. "arrêté n°2024-123 du 15/03/2024").
   */
  originalDecreeReference?: InputMaybe<Scalars['String']['input']>;
};

export type FilterInput = {
  field: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type GetDecreesInput = {
  analyzed?: InputMaybe<Scalars['Boolean']['input']>;
  category?: InputMaybe<Array<DecreeCategory>>;
  cityId: Scalars['String']['input'];
  decreeIds?: InputMaybe<Array<Scalars['String']['input']>>;
  done?: InputMaybe<Scalars['Boolean']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** This will filter decrees by published date */
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** This will search by decree name and decree content */
  text?: InputMaybe<Scalars['String']['input']>;
};

export type GetHistoryTensionInput = {
  cityId: Scalars['String']['input'];
  endDate: Scalars['DateTime']['input'];
  granularity: Granularity;
  nearBy?: InputMaybe<Array<Array<Scalars['Float']['input']>>>;
  startDate: Scalars['DateTime']['input'];
};

export type GetHistoryViolationsInput = {
  cityId: Scalars['String']['input'];
  endDate: Scalars['DateTime']['input'];
  granularity: Granularity;
  longstayThreshold?: InputMaybe<Scalars['Float']['input']>;
  nearBy?: InputMaybe<Array<Array<Scalars['Float']['input']>>>;
  overstayThreshold?: InputMaybe<Scalars['Float']['input']>;
  startDate: Scalars['DateTime']['input'];
};

export type GetLiveAvailabilitiesInput = {
  cityId: Scalars['String']['input'];
  nearBy?: InputMaybe<Array<Array<Scalars['Float']['input']>>>;
  time?: InputMaybe<Scalars['DateTime']['input']>;
};

export type GetOccupancyProfileInput = {
  cityId: Scalars['String']['input'];
  endDate: Scalars['DateTime']['input'];
  nearBy?: InputMaybe<Array<Array<Scalars['Float']['input']>>>;
  startDate: Scalars['DateTime']['input'];
};

export type GetPermitDecreesInput = {
  analyzed?: InputMaybe<Scalars['Boolean']['input']>;
  category?: InputMaybe<Array<DecreeCategory>>;
  cityId: Scalars['String']['input'];
  decreeIds?: InputMaybe<Array<Scalars['String']['input']>>;
  done?: InputMaybe<Scalars['Boolean']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** This will filter decrees by published date */
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** This will search by decree name and decree content */
  text?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Array<PermitType>>;
};

export type GetTemporaryDecreesInput = {
  analyzed?: InputMaybe<Scalars['Boolean']['input']>;
  category?: InputMaybe<Array<DecreeCategory>>;
  cityId: Scalars['String']['input'];
  decreeIds?: InputMaybe<Array<Scalars['String']['input']>>;
  done?: InputMaybe<Scalars['Boolean']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  restrictionEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  /**
   * Returns decrees that have at least one restriction whose timeSpan endDate falls within the given range.
   * Use this to find decrees about to end (e.g. ending in the next 3 days).
   */
  restrictionEndsBetween?: InputMaybe<DateRangeInput>;
  /** Returns decrees that have at least one restriction whose timeSpan overlaps the given range. */
  restrictionStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  /**
   * Returns decrees that have at least one restriction whose timeSpan startDate falls within the given range.
   * Use this to find decrees about to begin (e.g. starting in the next 3 days).
   */
  restrictionStartsBetween?: InputMaybe<DateRangeInput>;
  /** This will filter decrees by published date */
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** This will search by decree name and decree content */
  text?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Array<TemporaryType>>;
};

export enum Granularity {
  Day = 'Day',
  Hour = 'Hour'
}

export type GroupedApplicant = {
  /** Name of the applicant (pétitionnaire) who requested the decree. */
  applicant: Scalars['String']['output'];
  /** Number of temporary decrees associated to this applicant. */
  count: Scalars['Float']['output'];
};

export type GroupedApplicantPaginatedResult = {
  /** Available filters */
  filters?: Maybe<Scalars['JSON']['output']>;
  results: Array<GroupedApplicant>;
  /** Total number of items */
  totalCount: Scalars['Int']['output'];
  /** Total number of pages */
  totalPages: Scalars['Int']['output'];
};

export type GroupedCurbArea = {
  /**
   * Number of distinct temporary decrees with at least one restriction
   * located in this curb area.
   */
  count: Scalars['Float']['output'];
  /**
   * The curb area this bucket counts, or null for the bucket of decrees
   * located outside every curb area.
   */
  curbAreaId?: Maybe<Scalars['UUID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type GroupedTrafficRestriction = {
  /** Street name. */
  streetName: Scalars['String']['output'];
  /** Total length, in meters, of the matching traffic restrictions on this street. */
  totalLength: Scalars['Float']['output'];
};

export type GroupedType = {
  /** Number of decrees of this type */
  count: Scalars['Float']['output'];
  /** Decree type */
  type?: Maybe<Scalars['String']['output']>;
};

/** A half-open hour-of-day span `[from, to)` in the city's local time. For a single hour use `to = from + 1`. */
export type HourRangeInput = {
  /** Inclusive start hour, `0`–`23`. */
  from: Scalars['Int']['input'];
  /** Exclusive end hour, `1`–`24`, and greater than `from`. */
  to: Scalars['Int']['input'];
};

export type IDecree = {
  /** True if decree has been analyzed by the AI */
  analyzed?: Maybe<Scalars['Boolean']['output']>;
  /** Decree category */
  category: DecreeCategory;
  /** CityID of decree */
  cityId: Scalars['String']['output'];
  /** Comments of decree */
  comments?: Maybe<Scalars['String']['output']>;
  /** Created at */
  createdAt: Scalars['DateTime']['output'];
  /** Decree's own reference number as written in the document */
  decreeNumber?: Maybe<Scalars['String']['output']>;
  /** Image associated to the city */
  done: Scalars['Boolean']['output'];
  /** Unique city ID */
  id: Scalars['ID']['output'];
  /** Name of decree */
  name: Scalars['String']['output'];
  /** Public URL of the decree */
  publicUrl?: Maybe<Scalars['String']['output']>;
  /** Date of decree publication */
  publishedDate?: Maybe<Scalars['DateTime']['output']>;
  restrictionInstructions?: Maybe<Array<RestrictionInstruction>>;
  /** Short summary of the decree for display */
  summary?: Maybe<DecreeSummary>;
  /** Title of decree */
  title?: Maybe<Scalars['String']['output']>;
};

export type IDecreePaginatedResult = {
  /** Available filters */
  filters?: Maybe<Scalars['JSON']['output']>;
  results: Array<IDecree>;
  /** Total number of items */
  totalCount: Scalars['Int']['output'];
  /** Total number of pages */
  totalPages: Scalars['Int']['output'];
};

export type IWazeEvent = {
  city?: Maybe<Scalars['String']['output']>;
  cityId: Scalars['String']['output'];
  cityName: Scalars['String']['output'];
  country?: Maybe<Scalars['String']['output']>;
  eventType: WazeEventType;
  id: Scalars['ID']['output'];
  lastSeenAt: Scalars['DateTime']['output'];
  street?: Maybe<Scalars['String']['output']>;
};

export enum IconColor {
  Blue = 'blue',
  Green = 'green',
  Orange1 = 'orange1',
  Orange2 = 'orange2',
  Purple = 'purple',
  Red = 'red',
  Yellow = 'yellow'
}

export type LiveParkingAvailability = {
  detections?: Maybe<Array<Detection>>;
  /**
   * this property hase the duration of occupation in minutes
   * Or if the parking is empty it's the duration it has been empty
   */
  duration?: Maybe<Scalars['Float']['output']>;
  id: Scalars['String']['output'];
  occupancyRate?: Maybe<Scalars['Float']['output']>;
  occupied?: Maybe<Scalars['Boolean']['output']>;
  parkingId: Scalars['String']['output'];
  timestamp: Scalars['DateTime']['output'];
  vehicleType?: Maybe<Scalars['Float']['output']>;
};

export type LocationReference = {
  /**
   * The distance (in meters) from the start of the referenced linear feature to the end of the Curb Zone (exclusive, see Range Boundaries).
   * 'end' MAY be smaller than start, implying that the direction of the Curb Zone is opposite to
   * the direction of the referenced linear feature - in this case the Range Boundaries) are reversed.
   */
  end: Scalars['Float']['output'];
  /**
   * The linear feature being referenced (usually a street or curb segment).
   * For OpenLR, this is the Base64-encoded OpenLR line location for the street segment of which this Curb Zone is part,
   * and the start and end offsets below are relative to this segment.
   */
  refId: Scalars['String']['output'];
  /**
   * If the referenced linear feature is a roadway, the side of the roadway on which the Curb Zone may be found,
   * when heading from the start to the end of the feature in its native orientation.
   * Values are left and right. MUST be absent for features where entireRoadway is true.
   */
  side?: Maybe<Scalars['String']['output']>;
  /**
   * An identifier for the source of the linear reference.
   * This MUST be a URL pointing to more information about the underlying map or reference system.
   * Values include (but other can be used):
   *
   * https://sharedstreets.io: SharedStreets
   * http://openlr.org: OpenLR
   * https://yourcityname.gov/LR: custom city LR, direct link if possible
   */
  source: Scalars['String']['output'];
  /** The distance (in meters) from the start of the referenced linear feature to the start of the Curb Zone (inclusive, see Range Boundaries). */
  start: Scalars['Float']['output'];
};

export type LocationReferenceInput = {
  /**
   * The distance (in meters) from the start of the referenced linear feature to the end of the Curb Zone (exclusive, see Range Boundaries).
   * 'end' MAY be smaller than start, implying that the direction of the Curb Zone is opposite to
   * the direction of the referenced linear feature - in this case the Range Boundaries) are reversed.
   */
  end: Scalars['Float']['input'];
  /**
   * The linear feature being referenced (usually a street or curb segment).
   * For OpenLR, this is the Base64-encoded OpenLR line location for the street segment of which this Curb Zone is part,
   * and the start and end offsets below are relative to this segment.
   */
  refId: Scalars['String']['input'];
  /**
   * If the referenced linear feature is a roadway, the side of the roadway on which the Curb Zone may be found,
   * when heading from the start to the end of the feature in its native orientation.
   * Values are left and right. MUST be absent for features where entireRoadway is true.
   */
  side?: InputMaybe<Scalars['String']['input']>;
  /**
   * An identifier for the source of the linear reference.
   * This MUST be a URL pointing to more information about the underlying map or reference system.
   * Values include (but other can be used):
   *
   * https://sharedstreets.io: SharedStreets
   * http://openlr.org: OpenLR
   * https://yourcityname.gov/LR: custom city LR, direct link if possible
   */
  source: Scalars['String']['input'];
  /** The distance (in meters) from the start of the referenced linear feature to the start of the Curb Zone (inclusive, see Range Boundaries). */
  start: Scalars['Float']['input'];
};

export type LostRevenueByPolicy = {
  iconColor?: Maybe<IconColor>;
  /** Lost revenue attributed to this policy, in cents. Integer-valued. */
  lostRevenue: Scalars['Float']['output'];
  policyId: Scalars['ID']['output'];
  policyName?: Maybe<Scalars['String']['output']>;
  /** Parking rate in cents per hour applied for this policy. Integer-valued. */
  ratePerHour: Scalars['Float']['output'];
  restrictionCount: Scalars['Int']['output'];
  totalSpaceHours: Scalars['Float']['output'];
};

export type LostRevenueByType = {
  byPolicy: Array<LostRevenueByPolicy>;
  /** Lost revenue in this restriction-type bucket, in cents. Integer-valued. */
  lostRevenue: Scalars['Float']['output'];
  restrictionCount: Scalars['Int']['output'];
  totalSpaceHours: Scalars['Float']['output'];
  type: TemporaryType;
};

export type LostRevenueReport = {
  byType: Array<LostRevenueByType>;
  /** ISO 4217 currency code from the city (e.g. "EUR"). */
  currency: Scalars['String']['output'];
  /** Approximate lost revenue across the queried window, in cents. Integer-valued. */
  totalLostRevenue: Scalars['Float']['output'];
};

export type LotDayOccupancy = {
  /** ISO weekday these spans cover (Monday = 1 … Sunday = 7). */
  dayOfWeek: Scalars['Int']['output'];
  ranges: Array<LotTimeRangeOccupancy>;
};

export type LotTimeRangeOccupancy = {
  /** Average length, in seconds, of a completed session in the span; null when there were no sessions. */
  averageDurationSeconds?: Maybe<Scalars['Float']['output']>;
  /** Inclusive start hour of the span, `0`–`23`. */
  from: Scalars['Int']['output'];
  /** Occupied share of observed time across the span, as a percentage (0–100); null when nothing was observed. */
  occupancyPct?: Maybe<Scalars['Float']['output']>;
  /** Busiest hour within the span (0–23); null when nothing was observed. */
  peak?: Maybe<Scalars['Int']['output']>;
  /** Occupancy percentage at the busiest hour; null when nothing was observed. */
  peakOccupancyPct?: Maybe<Scalars['Float']['output']>;
  /** Exclusive end hour of the span, `1`–`24`. */
  to: Scalars['Int']['output'];
  /** Completed parking sessions per space over the span; null when the lot's capacity is unknown. */
  turnover?: Maybe<Scalars['Float']['output']>;
};

export type MonthTimeline = {
  mainPolicy: Scalars['String']['output'];
  months: Array<Scalars['Float']['output']>;
  monthsDisplay: Scalars['String']['output'];
  policiesLegend: Array<PolicyLegend>;
  timelines: Array<DayTimeline>;
};

export type Mutation = {
  addPermitDecreeLocation: PermitDecree;
  addUrbanFeatureToCity: UrbanFeature;
  bulkCreateRestrictions: Array<Restriction>;
  bulkDeleteCurbZones: Array<CurbZone>;
  bulkDeleteRestrictions: Scalars['Boolean']['output'];
  bulkUpdateCurbZones: Array<CurbZone>;
  bulkUpdateRestrictions: Array<Restriction>;
  createCity: City;
  createCurbArea: CurbArea;
  createCurbZone: CurbZone;
  createOffStreetParking: OffStreetParking;
  createParkingLot: ParkingLot;
  createParkingMeter: ParkingMeter;
  createPermanentDecree: PermanentDecree;
  createPermitDecree: PermitDecree;
  createPolicy: Policy;
  createRestriction: RestrictionDecree;
  createTemporaryDecree: TemporaryDecree;
  createUserReport: UserReport;
  createWorkArea: WorkArea;
  deleteCurbArea: CurbArea;
  deleteCurbZone: CurbZone;
  deleteOffStreetParking: OffStreetParking;
  deleteParkingLot: ParkingLot;
  deletePolicy: Policy;
  deleteRestriction: Restriction;
  deleteWorkArea: WorkArea;
  publishCitiesTiles: TilesetResponseEntity;
  removeCity: City;
  removeDecree: Decree;
  removeParkingMeter: ParkingMeter;
  removePermanentDecree: PermanentDecree;
  removePermitDecree: PermitDecree;
  removePermitDecreeLocation: PermitDecree;
  removeTemporaryDecree: TemporaryDecree;
  removeUrbanFeature: DeletedUrbanFeatureRes;
  updateCity: City;
  updateCurbArea: CurbArea;
  updateCurbZone: CurbZone;
  /** Update common decree fields except category */
  updateDecree: Decree;
  /** Change decree category */
  updateDecreeCategory: Decree;
  updateOffStreetParking: OffStreetParking;
  updateParkingLot: ParkingLot;
  updateParkingMeter: ParkingMeter;
  updatePermanentDecree: PermanentDecree;
  updatePermitDecree: PermitDecree;
  updatePermitDecreeLocation: PermitDecree;
  updatePolicy: Policy;
  updateRestriction: RestrictionDecree;
  updateTemporaryDecree: TemporaryDecree;
  updateUrbanFeature: UrbanFeature;
  updateUserReport: UserReport;
  updateWorkArea: WorkArea;
};


export type MutationAddPermitDecreeLocationArgs = {
  decreeId: Scalars['String']['input'];
  location: PermitDecreeLocationInput;
};


export type MutationAddUrbanFeatureToCityArgs = {
  createUrbanFeaturesInput: CreateUrbanFeaturesInput;
};


export type MutationBulkCreateRestrictionsArgs = {
  input: BulkCreateRestrictionsInput;
};


export type MutationBulkDeleteCurbZonesArgs = {
  curbZoneIds: Array<Scalars['String']['input']>;
};


export type MutationBulkDeleteRestrictionsArgs = {
  ids: Array<Scalars['String']['input']>;
};


export type MutationBulkUpdateCurbZonesArgs = {
  curbZoneInputs: Array<UpdateCurbZoneInput>;
};


export type MutationBulkUpdateRestrictionsArgs = {
  input: BulkUpdateRestrictionsInput;
};


export type MutationCreateCityArgs = {
  createCityInput: CreateCityInput;
};


export type MutationCreateCurbAreaArgs = {
  input: CreateCurbAreaInput;
};


export type MutationCreateCurbZoneArgs = {
  curbZoneInput: CreateCurbZoneInput;
};


export type MutationCreateOffStreetParkingArgs = {
  input: CreateOffStreetParkingInput;
};


export type MutationCreateParkingLotArgs = {
  input: CreateParkingLotInput;
};


export type MutationCreateParkingMeterArgs = {
  createParkingMeterInput: CreateParkingMeterInput;
};


export type MutationCreatePermanentDecreeArgs = {
  createDecreeInput: CreatePermanentDecreeInput;
};


export type MutationCreatePermitDecreeArgs = {
  createDecreeInput: CreatePermitDecreeInput;
};


export type MutationCreatePolicyArgs = {
  createPolicyInput: CreatePolicyInput;
};


export type MutationCreateRestrictionArgs = {
  input: CreateRestrictionInput;
};


export type MutationCreateTemporaryDecreeArgs = {
  createDecreeInput: CreateTemporaryDecreeInput;
};


export type MutationCreateUserReportArgs = {
  reportInput: CreateUserReportInput;
};


export type MutationCreateWorkAreaArgs = {
  workAreaInput: CreateWorkAreaInput;
};


export type MutationDeleteCurbAreaArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteCurbZoneArgs = {
  curbZoneId: Scalars['String']['input'];
};


export type MutationDeleteOffStreetParkingArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteParkingLotArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeletePolicyArgs = {
  policyId: Scalars['String']['input'];
};


export type MutationDeleteRestrictionArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteWorkAreaArgs = {
  id: Scalars['String']['input'];
};


export type MutationRemoveCityArgs = {
  id: Scalars['String']['input'];
};


export type MutationRemoveDecreeArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemoveParkingMeterArgs = {
  meterId: Scalars['String']['input'];
};


export type MutationRemovePermanentDecreeArgs = {
  id: Scalars['String']['input'];
};


export type MutationRemovePermitDecreeArgs = {
  id: Scalars['String']['input'];
};


export type MutationRemovePermitDecreeLocationArgs = {
  decreeId: Scalars['String']['input'];
  locationId: Scalars['String']['input'];
};


export type MutationRemoveTemporaryDecreeArgs = {
  id: Scalars['String']['input'];
};


export type MutationRemoveUrbanFeatureArgs = {
  urbanFeatureId: Scalars['String']['input'];
};


export type MutationUpdateCityArgs = {
  updateCityInput: UpdateCityInput;
};


export type MutationUpdateCurbAreaArgs = {
  input: UpdateCurbAreaInput;
};


export type MutationUpdateCurbZoneArgs = {
  curbZoneInput: UpdateCurbZoneInput;
};


export type MutationUpdateDecreeArgs = {
  input: UpdateDecreeInput;
};


export type MutationUpdateDecreeCategoryArgs = {
  id: Scalars['ID']['input'];
  input: UpdateDecreeCategoryInput;
};


export type MutationUpdateOffStreetParkingArgs = {
  input: UpdateOffStreetParkingInput;
};


export type MutationUpdateParkingLotArgs = {
  input: UpdateParkingLotInput;
};


export type MutationUpdateParkingMeterArgs = {
  updateParkingMeterInput: UpdateParkingMeterInput;
};


export type MutationUpdatePermanentDecreeArgs = {
  updateDecreeInput: UpdatePermanentDecreeInput;
};


export type MutationUpdatePermitDecreeArgs = {
  updateDecreeInput: UpdatePermitDecreeInput;
};


export type MutationUpdatePermitDecreeLocationArgs = {
  decreeId: Scalars['String']['input'];
  location: PermitDecreeLocationInput;
  locationId: Scalars['String']['input'];
};


export type MutationUpdatePolicyArgs = {
  updatePolicyInput: UpdatePolicyInput;
};


export type MutationUpdateRestrictionArgs = {
  input: UpdateRestrictionInput;
};


export type MutationUpdateTemporaryDecreeArgs = {
  updateDecreeInput: UpdateTemporaryDecreeInput;
};


export type MutationUpdateUrbanFeatureArgs = {
  updateUrbanFeatureInput: UpdateUrbanFeatureInput;
};


export type MutationUpdateUserReportArgs = {
  reportInput: UpdateUserReportInput;
};


export type MutationUpdateWorkAreaArgs = {
  workAreaInput: UpdateWorkAreaInput;
};

export type OccupancyBucket = {
  bucket: Scalars['Int']['output'];
  occupied: Scalars['Float']['output'];
  total: Scalars['Float']['output'];
};

export type OccupancyProfile = {
  /** Occupancy grouped by hour of day in the city's local time; bucket ranges from 0 to 23. */
  byHour: Array<OccupancyBucket>;
  /** Occupancy grouped by day of week in the city's local time; bucket ranges from 1 (Monday) to 7 (Sunday). */
  byWeekday: Array<OccupancyBucket>;
};

export type OffStreetOccupancyBucket = {
  availablePlaces: Scalars['Float']['output'];
  bucket: Scalars['Int']['output'];
  totalPlaces: Scalars['Float']['output'];
};

export type OffStreetOccupancyProfile = {
  /** Availability grouped by hour of day in the city's local time; bucket ranges from 0 to 23. */
  byHour: Array<OffStreetOccupancyBucket>;
  /** Availability grouped by day of week in the city's local time; bucket ranges from 1 (Monday) to 7 (Sunday). */
  byWeekday: Array<OffStreetOccupancyBucket>;
};

export type OffStreetParking = {
  /** Payment methods accepted at the facility. */
  acceptedPaymentMethods?: Maybe<Array<PaymentMethod>>;
  /** Entrances and exits of the facility, each with its own type, position and address. */
  accessPoints?: Maybe<Array<AccessPointEntity>>;
  /** Who is allowed to use the facility. */
  accessType?: Maybe<ParkingAccessType>;
  address: Scalars['String']['output'];
  /** Structured postal address of the facility. */
  addressDetails?: Maybe<Address>;
  /** Typical attendance profile over recent weeks; provided by the `offStreetParking` query. */
  attendance?: Maybe<ParkingAttendance>;
  availablePlaces?: Maybe<Scalars['Float']['output']>;
  /** Footprint of the facility building or lot. */
  boundary?: Maybe<Scalars['GeoJSONPolygon']['output']>;
  cityId: Scalars['String']['output'];
  createdDate?: Maybe<Scalars['DateTime']['output']>;
  currencyCode?: Maybe<Scalars['String']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  /** Physical construction of the facility. */
  layout?: Maybe<ParkingLayout>;
  /** Number of levels */
  levels?: Maybe<Scalars['Float']['output']>;
  location: Scalars['GeoJSONPoint']['output'];
  /** Maximum vehicle height allowed, in metres. */
  maxHeight?: Maybe<Scalars['Float']['output']>;
  /** Maximum vehicle length allowed, in metres. */
  maxLength?: Maybe<Scalars['Float']['output']>;
  /** Maximum vehicle weight allowed, in tonnes. */
  maxWeight?: Maybe<Scalars['Float']['output']>;
  /** Maximum vehicle width allowed, in metres. */
  maxWidth?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  /** If specified, this opening hours of the parking */
  openingHours?: Maybe<Array<TimeSpanEntity>>;
  /** Name of the company operating the facility. */
  operator?: Maybe<Scalars['String']['output']>;
  /** Options of the private parking */
  options?: Maybe<OffStreetParkingOptionsEntity>;
  /**
   * Legacy free-text secondary entrances. Superseded by `accessPoints`.
   * @deprecated Use `accessPoints`.
   */
  otherAdresses?: Maybe<Array<Scalars['String']['output']>>;
  /** Contact phone number for the facility. */
  phone?: Maybe<Scalars['String']['output']>;
  pricePerHour?: Maybe<Scalars['Float']['output']>;
  /**
   * Legacy free-text construction type. Superseded by `layout`.
   * @deprecated Use `layout`.
   */
  structure?: Maybe<Scalars['String']['output']>;
  totalPlaces?: Maybe<Scalars['Float']['output']>;
  updatedDate?: Maybe<Scalars['DateTime']['output']>;
  /** Website of the facility. */
  website?: Maybe<Scalars['String']['output']>;
};

export type OffStreetParkingAvailability = {
  /** Payment methods accepted at the facility. */
  acceptedPaymentMethods?: Maybe<Array<PaymentMethod>>;
  /** Entrances and exits of the facility, each with its own type, position and address. */
  accessPoints?: Maybe<Array<AccessPointEntity>>;
  /** Who is allowed to use the facility. */
  accessType?: Maybe<ParkingAccessType>;
  address: Scalars['String']['output'];
  /** Structured postal address of the facility. */
  addressDetails?: Maybe<Address>;
  /** Typical attendance profile over recent weeks; provided by the `offStreetParking` query. */
  attendance?: Maybe<ParkingAttendance>;
  availabilities?: Maybe<Array<ParkingAvailability>>;
  availablePlaces?: Maybe<Scalars['Float']['output']>;
  /** Footprint of the facility building or lot. */
  boundary?: Maybe<Scalars['GeoJSONPolygon']['output']>;
  cityId: Scalars['String']['output'];
  createdDate?: Maybe<Scalars['DateTime']['output']>;
  currencyCode?: Maybe<Scalars['String']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  /** Physical construction of the facility. */
  layout?: Maybe<ParkingLayout>;
  /** Number of levels */
  levels?: Maybe<Scalars['Float']['output']>;
  location: Scalars['GeoJSONPoint']['output'];
  /** Maximum vehicle height allowed, in metres. */
  maxHeight?: Maybe<Scalars['Float']['output']>;
  /** Maximum vehicle length allowed, in metres. */
  maxLength?: Maybe<Scalars['Float']['output']>;
  /** Maximum vehicle weight allowed, in tonnes. */
  maxWeight?: Maybe<Scalars['Float']['output']>;
  /** Maximum vehicle width allowed, in metres. */
  maxWidth?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  /** If specified, this opening hours of the parking */
  openingHours?: Maybe<Array<TimeSpanEntity>>;
  /** Name of the company operating the facility. */
  operator?: Maybe<Scalars['String']['output']>;
  /** Options of the private parking */
  options?: Maybe<OffStreetParkingOptionsEntity>;
  /**
   * Legacy free-text secondary entrances. Superseded by `accessPoints`.
   * @deprecated Use `accessPoints`.
   */
  otherAdresses?: Maybe<Array<Scalars['String']['output']>>;
  /** Contact phone number for the facility. */
  phone?: Maybe<Scalars['String']['output']>;
  pricePerHour?: Maybe<Scalars['Float']['output']>;
  /**
   * Legacy free-text construction type. Superseded by `layout`.
   * @deprecated Use `layout`.
   */
  structure?: Maybe<Scalars['String']['output']>;
  totalPlaces?: Maybe<Scalars['Float']['output']>;
  updatedDate?: Maybe<Scalars['DateTime']['output']>;
  /** Website of the facility. */
  website?: Maybe<Scalars['String']['output']>;
};

export type OffStreetParkingOptionsEntity = {
  /** Bicycle access */
  bicycleAccess?: Maybe<Scalars['Boolean']['output']>;
  /** Number of places for Bicycle */
  bicyclePlaces?: Maybe<Scalars['Float']['output']>;
  /** Disabled persons access */
  disabledAccess?: Maybe<Scalars['Boolean']['output']>;
  /** Number of disabled spots */
  disabledPlaces?: Maybe<Scalars['Float']['output']>;
  /**
   * Corrected spelling: use `disabledPlaces`.
   * @deprecated Corrected spelling: use `disabledPlaces`.
   */
  disablesPlaces?: Maybe<Scalars['Float']['output']>;
  /** Number of EV Chargers */
  evChargers?: Maybe<Scalars['Float']['output']>;
  /** Motorcycle access */
  motorcycleAccess?: Maybe<Scalars['Boolean']['output']>;
  /** Number of places for motorcycles */
  motorcyclePlaces?: Maybe<Scalars['Float']['output']>;
  /** Has toilets */
  toilets?: Maybe<Scalars['Boolean']['output']>;
};

export type OffStreetParkingOptionsInput = {
  /** Bicycle access */
  bicycleAccess?: InputMaybe<Scalars['Boolean']['input']>;
  /** Number of places for Bicycle */
  bicyclePlaces?: InputMaybe<Scalars['Float']['input']>;
  /** Disabled persons access */
  disabledAccess?: InputMaybe<Scalars['Boolean']['input']>;
  /** Number of disabled spots */
  disabledPlaces?: InputMaybe<Scalars['Float']['input']>;
  /**
   * Corrected spelling: use `disabledPlaces`. When both are sent, `disabledPlaces` wins.
   * @deprecated Corrected spelling: use `disabledPlaces`.
   */
  disablesPlaces?: InputMaybe<Scalars['Float']['input']>;
  /** Number of EV Chargers */
  evChargers?: InputMaybe<Scalars['Float']['input']>;
  /** Motorcycle access */
  motorcycleAccess?: InputMaybe<Scalars['Boolean']['input']>;
  /** Number of places for motorcycles */
  motorcyclePlaces?: InputMaybe<Scalars['Float']['input']>;
  /** Has toilets */
  toilets?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OffStreetParkingSummary = {
  /** Main address of the parking */
  address: Scalars['String']['output'];
  /** Number of empty places */
  availablePlaces?: Maybe<Scalars['Float']['output']>;
  /** City of the parking */
  cityId: Scalars['String']['output'];
  /** Unique Offstreet Parking ID */
  id: Scalars['String']['output'];
  /** Location of the parking */
  location: Scalars['GeoJSONPoint']['output'];
  /** The name of the Parking */
  name: Scalars['String']['output'];
  /** Total number of places */
  totalPlaces?: Maybe<Scalars['Float']['output']>;
};

export type OptionsEntity = {
  /** Is main map curb zones view available for the city */
  curbZones?: Maybe<Scalars['Boolean']['output']>;
  /** Configuration of the decree analysis feature */
  decreeAnalysis?: Maybe<DecreeAnalysisEntity>;
  /** Are sensor present in the city */
  live?: Maybe<Scalars['Boolean']['output']>;
  /** Does city have iFrame map integration */
  mapIntegration?: Maybe<Scalars['Boolean']['output']>;
  /** Do we publish the map to the Mobile apps */
  mobileMap?: Maybe<Scalars['Boolean']['output']>;
  /** Is Offstreet parking available in the city */
  offstreet?: Maybe<Scalars['Boolean']['output']>;
  /** Is in app payment is enabled in the city */
  payment?: Maybe<Scalars['Boolean']['output']>;
  /** Is prediction available in the city */
  prediction?: Maybe<Scalars['Boolean']['output']>;
  /** Waze data feed URL */
  wazeFeedUrl?: Maybe<Scalars['String']['output']>;
};

export type PaginatedGroupedTrafficRestrictionResult = {
  /** Available filters */
  filters?: Maybe<Scalars['JSON']['output']>;
  results: Array<GroupedTrafficRestriction>;
  /** Total number of items */
  totalCount: Scalars['Int']['output'];
  /** Sum of length, in meters, across every matching street. */
  totalLength: Scalars['Float']['output'];
  /** Total number of pages */
  totalPages: Scalars['Int']['output'];
};

/** Who is allowed to use the facility. */
export enum ParkingAccessType {
  /** Restricted to authorised users. */
  Private = 'private',
  /** Open to the general public. */
  Public = 'public',
  /** A mix of public and reserved spaces. */
  PublicPrivate = 'publicPrivate'
}

export enum ParkingAngle {
  Angled = 'angled',
  Parallel = 'parallel',
  Perpendicular = 'perpendicular'
}

export type ParkingAttendance = {
  /** Whole-day profile per ISO weekday; empty when the parking has no observations. */
  byWeekday: Array<AttendanceWeekday>;
  /** Typical-day profile per ISO weekday, in the city's local time; empty when the parking has no observations. */
  days: Array<AttendanceDay>;
};

export type ParkingAvailability = {
  availablePlaces: Scalars['Float']['output'];
  date: Scalars['String']['output'];
  granularity: Scalars['String']['output'];
  totalPlaces: Scalars['Float']['output'];
};

/** Physical construction of the parking facility. */
export enum ParkingLayout {
  /** Mechanical / automated parking system. */
  Automated = 'automated',
  /** Above-ground structure with several levels. */
  MultiStorey = 'multiStorey',
  /** Open-air, ground-level lot. */
  Surface = 'surface',
  /** Below-ground parking. */
  Underground = 'underground'
}

export type ParkingLot = {
  /** The address of this parking lot for reference. */
  address?: Maybe<Scalars['String']['output']>;
  /** Typical attendance profile over recent weeks; provided by the `parkingLot` query. */
  attendance?: Maybe<ParkingAttendance>;
  /** Macaron custom data */
  cityId: Scalars['String']['output'];
  /** The IDs of all the Curb Zones included within this Parking Lot at the requested time. */
  curbZoneIds: Array<Scalars['UUID']['output']>;
  /** An array of Curb Zone objects. */
  curbZones: Array<CurbZone>;
  /** The spatial extent of this parking lot. */
  geometry: Scalars['GeoJSONPolygon']['output'];
  /** Unique Parking Lot ID */
  id: Scalars['ID']['output'];
  /** The name of this parking lot for reference. */
  name?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  /** The center of this parking lot. */
  position: Array<Scalars['Float']['output']>;
};

export type ParkingLotDayTimeOccupancy = {
  days: Array<LotDayOccupancy>;
  lotId: Scalars['ID']['output'];
};

export type ParkingLotMetrics = {
  /** Average length, in seconds, of a completed parking session; null when there were no sessions in the range. */
  averageDurationSeconds?: Maybe<Scalars['Float']['output']>;
  /** Occupancy grouped by hour of day in the city's local time; bucket ranges from 0 to 23. */
  byHour: Array<OccupancyBucket>;
  /** Occupancy grouped by day of week in the city's local time; bucket ranges from 1 (Monday) to 7 (Sunday). */
  byWeekday: Array<OccupancyBucket>;
  lotId: Scalars['ID']['output'];
  /** Completed parking sessions per space over the range; null when the lot's capacity is unknown. */
  turnover?: Maybe<Scalars['Float']['output']>;
};

export type ParkingLotTurnover = {
  /**
   * Per-day session counts and capacity for this lot, ordered ascending by date.
   * A day's turnover is sessions / spotCount; aggregate across lots with Σsessions / ΣspotCount.
   */
  daily: Array<ParkingLotTurnoverDay>;
  lotId: Scalars['ID']['output'];
};

export type ParkingLotTurnoverDay = {
  /** Day in the city's local time, formatted YYYY-MM-DD. */
  date: Scalars['String']['output'];
  /** Completed parking sessions that day for this lot. */
  sessions: Scalars['Float']['output'];
  /** Lot capacity that day (max observed spot count). */
  spotCount: Scalars['Float']['output'];
};

export type ParkingMeter = {
  address: Address;
  /** Battery level of the parking meter if available */
  batteryLevel?: Maybe<Scalars['Float']['output']>;
  /** Brand of of the parking meter */
  brand: Scalars['String']['output'];
  /** City id */
  cityId: Scalars['String']['output'];
  /** External id */
  externalId?: Maybe<Scalars['String']['output']>;
  /** Id */
  id: Scalars['String']['output'];
  /** Last maintenance date */
  lastMaintenanceDate?: Maybe<Scalars['DateTime']['output']>;
  /** Location */
  location: Scalars['GeoJSONPoint']['output'];
  /** Model of the parking meter */
  model: Scalars['String']['output'];
  /** Name */
  name: Scalars['String']['output'];
  /** Operator of the parking meter */
  operator: Scalars['String']['output'];
  /** Options */
  options?: Maybe<ParkingMeterOptions>;
  /** Status */
  status?: Maybe<Scalars['String']['output']>;
  /** Zone the parking meter operates in */
  zone?: Maybe<Scalars['String']['output']>;
};

export type ParkingMeterOptions = {
  /** Cash payment accepted */
  cash?: Maybe<Scalars['Boolean']['output']>;
  /** Contactless payment accepted */
  contactless?: Maybe<Scalars['Boolean']['output']>;
  /** Credit card payment accepted */
  creditCard?: Maybe<Scalars['Boolean']['output']>;
};

export type ParkingMeterOptionsInput = {
  /** Cash payment accepted */
  cash?: InputMaybe<Scalars['Boolean']['input']>;
  /** Contactless payment accepted */
  contactless?: InputMaybe<Scalars['Boolean']['input']>;
  /** Credit card payment accepted */
  creditCard?: InputMaybe<Scalars['Boolean']['input']>;
};

/** A way a driver can pay for parking. */
export enum PaymentMethod {
  App = 'app',
  Card = 'card',
  Cash = 'cash',
  Contactless = 'contactless'
}

export type PermanentDecree = IDecree & {
  /** True if decree has been analyzed by the AI */
  analyzed?: Maybe<Scalars['Boolean']['output']>;
  /** Decree category */
  category: DecreeCategory;
  /** CityID of decree */
  cityId: Scalars['String']['output'];
  /** Comments of decree */
  comments?: Maybe<Scalars['String']['output']>;
  /** Created at */
  createdAt: Scalars['DateTime']['output'];
  /** Decree's own reference number as written in the document */
  decreeNumber?: Maybe<Scalars['String']['output']>;
  /** Image associated to the city */
  done: Scalars['Boolean']['output'];
  /** Unique city ID */
  id: Scalars['ID']['output'];
  /** Name of decree */
  name: Scalars['String']['output'];
  /** Public URL of the decree */
  publicUrl?: Maybe<Scalars['String']['output']>;
  /** Date of decree publication */
  publishedDate?: Maybe<Scalars['DateTime']['output']>;
  restrictionInstructions?: Maybe<Array<RestrictionInstruction>>;
  /** Short summary of the decree for display */
  summary?: Maybe<DecreeSummary>;
  /** Title of decree */
  title?: Maybe<Scalars['String']['output']>;
};

export type PermanentDecreePaginatedResult = {
  /** Available filters */
  filters?: Maybe<Scalars['JSON']['output']>;
  results: Array<PermanentDecree>;
  /** Total number of items */
  totalCount: Scalars['Int']['output'];
  /** Total number of pages */
  totalPages: Scalars['Int']['output'];
};

export type PermitDecree = IDecree & {
  /** True if decree has been analyzed by the AI */
  analyzed?: Maybe<Scalars['Boolean']['output']>;
  /** Decree category */
  category: DecreeCategory;
  /** CityID of decree */
  cityId: Scalars['String']['output'];
  /** Comments of decree */
  comments?: Maybe<Scalars['String']['output']>;
  /** Created at */
  createdAt: Scalars['DateTime']['output'];
  /** Decree's own reference number as written in the document */
  decreeNumber?: Maybe<Scalars['String']['output']>;
  /** Image associated to the city */
  done: Scalars['Boolean']['output'];
  /** End date of the permit */
  endDate: Scalars['DateTime']['output'];
  /** Unique city ID */
  id: Scalars['ID']['output'];
  /** Locations of permit */
  locations: Array<PermitDecreeLocation>;
  /** Name of decree */
  name: Scalars['String']['output'];
  /** Name of the petitionner */
  petitionnerName?: Maybe<Scalars['String']['output']>;
  /** Public URL of the decree */
  publicUrl?: Maybe<Scalars['String']['output']>;
  /** Date of decree publication */
  publishedDate?: Maybe<Scalars['DateTime']['output']>;
  restrictionInstructions?: Maybe<Array<RestrictionInstruction>>;
  /** Start date of the permit */
  startDate: Scalars['DateTime']['output'];
  /** Short summary of the decree for display */
  summary?: Maybe<DecreeSummary>;
  /** Title of decree */
  title?: Maybe<Scalars['String']['output']>;
  /** Decree type */
  type?: Maybe<PermitType>;
};

export type PermitDecreeLocation = {
  address: Address;
  id: Scalars['String']['output'];
  position: Scalars['GeoJSONPoint']['output'];
};

export type PermitDecreeLocationInput = {
  address: AddressInput;
  id?: InputMaybe<Scalars['ObjectID']['input']>;
  position: Scalars['GeoJSONPoint']['input'];
};

export type PermitDecreePaginatedResult = {
  /** Available filters */
  filters?: Maybe<Scalars['JSON']['output']>;
  results: Array<PermitDecree>;
  /** Total number of items */
  totalCount: Scalars['Int']['output'];
  /** Total number of pages */
  totalPages: Scalars['Int']['output'];
};

/** Type of Permit (e.g. "Demolition", "Development") */
export enum PermitType {
  Building = 'building',
  BuildingAndDemolition = 'buildingAndDemolition',
  Demolition = 'demolition',
  Development = 'development',
  Other = 'other',
  PriorDeclaration = 'priorDeclaration',
  SingleFamilyHomeBuilding = 'singleFamilyHomeBuilding'
}

export type Policy = {
  category?: Maybe<PolicyCategory>;
  cityId: Scalars['String']['output'];
  color?: Maybe<Color>;
  /**
   * An ID that uniquely identifies this exact regulation across Curb Zones.
   * Two Policy objects containing the same curbPolicyId MUST be completely identical.
   * A curbPolicyId MUST NOT be reused -- once created, it must continue to refer to the identical policy forever.
   */
  curbPolicyId?: Maybe<Scalars['UUID']['output']>;
  /**
   * An array of Data Source Operator IDs that this policy only applies to.
   * IDs come from dataSourceOperators.csv file here in the CDS repo.
   * Read our How to Get a Data Source Operator ID guide.
   */
  dataSourceOperatorId?: Maybe<Array<Scalars['UUID']['output']>>;
  icon?: Maybe<Scalars['String']['output']>;
  /** Unique CurbZone ID, for Macaron usage only */
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  note?: Maybe<Scalars['String']['output']>;
  /**
   * Specifies which other policies this one takes precedence over.
   * If two Policies on the same Curb Zone have overlapping Time Spans and apply to the same user class,
   * the one that applies at a given time is the one with the lowest priority.
   * E.g., a priority of 1 takes precedence over a priority of 3.
   * Two Policies that apply to the same Curb Zone with overlapping Time Spans and equivalent User Class enumerations MUST NOT have the same priority.
   */
  priority: Scalars['Float']['output'];
  /** The date/time that this policy was first published in this data feed. */
  publishedDate: Scalars['DateTime']['output'];
  /** The rule(s) that this policy applies. If a Policy specifies multiple rules, each rule MUST specify disjoint lists of user classes. */
  rules: Array<PolicyRule>;
  state?: Maybe<Scalars['String']['output']>;
  /** If specified, this regulation only applies at the times defined within. */
  timeSpans?: Maybe<Array<TimeSpanEntity>>;
};

export enum PolicyCategory {
  Ambulance = 'ambulance',
  Bicycle = 'bicycle',
  BikeSharing = 'bikeSharing',
  BusStop = 'busStop',
  Carpooling = 'carpooling',
  CashTransport = 'cashTransport',
  Coach = 'coach',
  Delivery = 'delivery',
  Disabled = 'disabled',
  Disc = 'disc',
  DropOff = 'dropOff',
  Electric = 'electric',
  FireFighters = 'fireFighters',
  Free = 'free',
  Motorcycle = 'motorcycle',
  Other = 'other',
  Paid = 'paid',
  Police = 'police',
  Scooter = 'scooter',
  Taxi = 'taxi',
  TwoWheels = 'twoWheels'
}

export type PolicyLegend = {
  category: Scalars['String']['output'];
  fillColor: Array<Scalars['Float']['output']>;
  policyName: Scalars['String']['output'];
};

export type PolicyRule = {
  /**
   * The activity that is forbidden or permitted by this regulation. Value MUST be one of the activities.
   * Activities
   *
   * The following activities may be specified for rules within a policy.
   * The reason we have "positive" and "negative" versions of the same activities (like loading and no parking) is due to priorities:
   * a loading rule that is higher priority than a no loading rule, for instance, implies that the Curb Zone does allow loading at the time in question,
   * while a no parking rule would not. If "negative", rate array should be empty.
   *
   *     parking - implies that loading and stopping are also permitted
   *     no parking - may not stop and leave vehicle unattended
   *     loading - loading of goods; implies that stopping is also permitted
   *     no loading - no loading allowed; implies that parking is also prohibited
   *     unloading - unloading of goods; implies that stopping is also permitted
   *     no unloading - no unloading allowed; implies that parking is also prohibited
   *     stopping - stopping briefly to pick up or drop off passengers
   *     no stopping - stopping, loading, unloading, and parking are all prohibited; not a typical travel lane
   *     travel - represents curbside lanes typically intended for moving vehicles, like bus lanes, bike lanes, and rush-hour-only travel lanes; implies that parking, loading, unloading, and stopping are prohibited.
   *     no travel - no travel allowed; implies it could be used for other activities
   */
  activity: Scalars['String']['output'];
  /**
   * The length of time (in units of maxStayUnit) for which the curb may be used under this regulation.
   * If not specified, the curb may be used under this regulation indefinitely. May not be applicable for all activities.
   */
  maxStay?: Maybe<Scalars['Float']['output']>;
  /** The Unit of Time associated with the maxStay value. Defaults to "minute". */
  maxStayUnit?: Maybe<UnitOfTime>;
  /**
   * The length of time (in units of noReturnUnit) that a user must vacate a Curb Zone before being allowed to return for another stay.
   * Defaults to 0. May not be applicable for all activities.
   */
  noReturn?: Maybe<Scalars['Float']['output']>;
  /** The Unit of Time associated with the noReturn value. Defaults to "minute". */
  noReturnUnit?: Maybe<UnitOfTime>;
  /**
   * The cost of using this Curb Zone when this regulation applies.
   * Rates are repeated to allow for prices that change over time.
   * For instance, a regulation may have a price of $1 for the first hour but $2 for every subsequent hour.
   * The complete set of the Rates array must span from startMinutes = 0 or null to endMinutes = maxStay without overlap of effective minutes
   * (i.e. the range created by rate startMinutes and endMinutes).
   * If a "negative" activity is used, this array should be empty. May not be applicable for all activity.
   */
  rate?: Maybe<Array<Rate>>;
  /**
   * If specified, this regulation only applies to users matching the user classes contained within.
   * If not specified, this regulation applies to everyone.
   * The order of userClasses is not relevant, but a vehicle using a curb with this rule must match all userClasses contained in the array.
   *
   * Well-known values:
   *
   * Vehicle types: bicycle, bus, cargoBicycle, car, moped, motorcycle, scooter, truck, van
   *
   * Vehicle properties: handicap-accessible, human, electricAssist, electric, combustion, autonomous
   *
   * Purpose: construction, delivery, emergencyUse, freight, parking, permit, rideshare, school, serviceVehicles, specialEvents, taxi, utilities, vending, wasteManagement
   */
  userClasses?: Maybe<Array<Scalars['String']['output']>>;
};

export type PolicyRuleInput = {
  /**
   * The activity that is forbidden or permitted by this regulation. Value MUST be one of the activities.
   * Activities
   *
   * The following activities may be specified for rules within a policy.
   * The reason we have "positive" and "negative" versions of the same activities (like loading and no parking) is due to priorities:
   * a loading rule that is higher priority than a no loading rule, for instance, implies that the Curb Zone does allow loading at the time in question,
   * while a no parking rule would not. If "negative", rate array should be empty.
   *
   *     parking - implies that loading and stopping are also permitted
   *     no parking - may not stop and leave vehicle unattended
   *     loading - loading of goods; implies that stopping is also permitted
   *     no loading - no loading allowed; implies that parking is also prohibited
   *     unloading - unloading of goods; implies that stopping is also permitted
   *     no unloading - no unloading allowed; implies that parking is also prohibited
   *     stopping - stopping briefly to pick up or drop off passengers
   *     no stopping - stopping, loading, unloading, and parking are all prohibited; not a typical travel lane
   *     travel - represents curbside lanes typically intended for moving vehicles, like bus lanes, bike lanes, and rush-hour-only travel lanes; implies that parking, loading, unloading, and stopping are prohibited.
   *     no travel - no travel allowed; implies it could be used for other activities
   */
  activity: Activity;
  /**
   * The length of time (in units of maxStayUnit) for which the curb may be used under this regulation.
   * If not specified, the curb may be used under this regulation indefinitely. May not be applicable for all activities.
   */
  maxStay?: InputMaybe<Scalars['Float']['input']>;
  /** The Unit of Time associated with the maxStay value. Defaults to "minute". */
  maxStayUnit?: InputMaybe<UnitOfTime>;
  /**
   * The length of time (in units of noReturnUnit) that a user must vacate a Curb Zone before being allowed to return for another stay.
   * Defaults to 0. May not be applicable for all activities.
   */
  noReturn?: InputMaybe<Scalars['Float']['input']>;
  /** The Unit of Time associated with the noReturn value. Defaults to "minute". */
  noReturnUnit?: InputMaybe<UnitOfTime>;
  /**
   * The cost of using this Curb Zone when this regulation applies.
   * Rates are repeated to allow for prices that change over time.
   * For instance, a regulation may have a price of $1 for the first hour but $2 for every subsequent hour.
   * The complete set of the Rates array must span from startMinutes = 0 or null to endMinutes = maxStay without overlap of effective minutes
   * (i.e. the range created by rate startMinutes and endMinutes).
   * If a "negative" activity is used, this array should be empty. May not be applicable for all activity.
   */
  rate?: InputMaybe<Array<RateInput>>;
  /**
   * If specified, this regulation only applies to users matching the user classes contained within.
   * If not specified, this regulation applies to everyone.
   * The order of userClasses is not relevant, but a vehicle using a curb with this rule must match all userClasses contained in the array.
   *
   * Well-known values:
   *
   * Vehicle types: bicycle, bus, cargoBicycle, car, moped, motorcycle, scooter, truck, van
   *
   * Vehicle properties: handicap-accessible, human, electricAssist, electric, combustion, autonomous
   *
   * Purpose: construction, delivery, emergencyUse, freight, parking, permit, rideshare, school, serviceVehicles, specialEvents, taxi, utilities, vending, wasteManagement
   */
  userClasses?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type PreviousPolicy = {
  /** An array of IDs of Policy objects. Together, these define the previous regulations of this Curb Zone. */
  curbPolicyIds: Array<Scalars['UUID']['output']>;
  /** The date/time that this policy ended being active for this curb location (exclusive, see Range Boundaries). */
  endDate: Scalars['DateTime']['output'];
  /** The date/time that this policy started being active for this curb location (inclusive, see Range Boundaries). */
  startDate: Scalars['DateTime']['output'];
};

export type PreviousPolicyInput = {
  /** An array of IDs of Policy objects. Together, these define the previous regulations of this Curb Zone. */
  curbPolicyIds: Array<Scalars['UUID']['input']>;
  /** The date/time that this policy ended being active for this curb location (exclusive, see Range Boundaries). */
  endDate: Scalars['DateTime']['input'];
  /** The date/time that this policy started being active for this curb location (inclusive, see Range Boundaries). */
  startDate: Scalars['DateTime']['input'];
};

export type Query = {
  cities: Array<City>;
  city: City;
  cityByPosition?: Maybe<City>;
  curbAreas: Array<CurbArea>;
  curbZone: CurbZoneWithTimelines;
  curbZoneDrawActivity: CurbZoneDrawActivityPeriods;
  curbZones: Array<CurbZone>;
  decreeActivity: DecreeActivityPeriods;
  decreesPaginated: IDecreePaginatedResult;
  getParkingMeters: Array<ParkingMeter>;
  getTotalCalculatedSpaces: Scalars['Float']['output'];
  getUrbanFeatureDetail: UrbanFeature;
  getUserReportsByCityId: UserReportPaginatedResult;
  historyAvailabilities: Array<LiveParkingAvailability>;
  occupancyProfile: OccupancyProfile;
  offStreetParking: OffStreetParking;
  offStreetParkingAvailability: Array<OffStreetParkingAvailability>;
  offStreetParkingOccupancyProfile: OffStreetOccupancyProfile;
  offStreetParkings: Array<OffStreetParkingSummary>;
  paginatedCities: CityPaginatedResult;
  parkingLot: ParkingLot;
  parkingLotMetrics: Array<ParkingLotMetrics>;
  parkingLotOccupancyByDayTime: Array<ParkingLotDayTimeOccupancy>;
  parkingLotTurnover: Array<ParkingLotTurnover>;
  parkingLots: Array<ParkingLot>;
  permanentDecreeCountsByType: Array<GroupedType>;
  permanentDecrees: Array<PermanentDecree>;
  permanentDecreesCount: Scalars['Float']['output'];
  permanentDecreesPaginated: PermanentDecreePaginatedResult;
  permitDecree: PermitDecree;
  permitDecreeCountsByType: Array<GroupedType>;
  permitDecreeStats: DecreeStats;
  permitDecrees: Array<PermitDecree>;
  permitDecreesCount: Scalars['Float']['output'];
  permitDecreesPaginated: PermitDecreePaginatedResult;
  policiesByCityId: Array<Policy>;
  /** Sum of parking spaces restricted by parking restrictions over a date range, grouped by restriction type then by applicable policy. Each restriction contributes its own space count, so a space restricted multiple times in the window contributes once per restriction. */
  restrictedPlaces: RestrictedPlacesReport;
  restrictions: Array<RestrictionDecree>;
  /** @deprecated Use restrictions instead. */
  restrictionsByBounding: Array<RestrictionDecree>;
  /** Approximate parking revenue lost to parking restrictions over a date range, grouped by restriction type then by applicable policy. */
  restrictionsLostRevenue: LostRevenueReport;
  temporaryDecree: TemporaryDecree;
  temporaryDecreeApplicantsPaginated: GroupedApplicantPaginatedResult;
  temporaryDecreeCountsByCurbArea: Array<GroupedCurbArea>;
  temporaryDecreeCountsByType: Array<GroupedType>;
  temporaryDecreeStats: DecreeStats;
  temporaryDecreesCount: Scalars['Float']['output'];
  temporaryDecreesPaginated: TemporaryDecreePaginatedResult;
  tension: Array<Tension>;
  trafficRestrictionsLengthByStreetPaginated: PaginatedGroupedTrafficRestrictionResult;
  urbanFeaturesByBounding: Array<UrbanFeature>;
  violation: Array<Violation>;
  wazeEvents: Array<IWazeEvent>;
  workAreas: Array<WorkArea>;
};


export type QueryCityArgs = {
  id: Scalars['String']['input'];
};


export type QueryCityByPositionArgs = {
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
};


export type QueryCurbAreasArgs = {
  cityId: Scalars['String']['input'];
};


export type QueryCurbZoneArgs = {
  cityId: Scalars['String']['input'];
  curbZoneId: Scalars['String']['input'];
};


export type QueryCurbZoneDrawActivityArgs = {
  cityId?: InputMaybe<Scalars['String']['input']>;
  current: ActivityWindowInput;
  previous?: InputMaybe<ActivityWindowInput>;
};


export type QueryCurbZonesArgs = {
  filterInput: SearchCurbZoneInput;
};


export type QueryDecreeActivityArgs = {
  cityId?: InputMaybe<Scalars['String']['input']>;
  current: ActivityWindowInput;
  previous?: InputMaybe<ActivityWindowInput>;
};


export type QueryDecreesPaginatedArgs = {
  cityId: Scalars['String']['input'];
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  filter?: InputMaybe<Array<FilterInput>>;
  pageIndex?: Scalars['Int']['input'];
  pageSize?: Scalars['Int']['input'];
  sortField?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<SortOrder>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};


export type QueryGetParkingMetersArgs = {
  cityId: Scalars['String']['input'];
};


export type QueryGetTotalCalculatedSpacesArgs = {
  filterInput: SearchCalculatedSpacesInput;
};


export type QueryGetUrbanFeatureDetailArgs = {
  urbanFeatureId: Scalars['String']['input'];
};


export type QueryGetUserReportsByCityIdArgs = {
  cityId: Scalars['String']['input'];
  filter?: InputMaybe<Array<FilterInput>>;
  pageIndex?: Scalars['Int']['input'];
  pageSize?: Scalars['Int']['input'];
  sortField?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<SortOrder>;
};


export type QueryHistoryAvailabilitiesArgs = {
  filterInput: GetLiveAvailabilitiesInput;
};


export type QueryOccupancyProfileArgs = {
  filterInput: GetOccupancyProfileInput;
};


export type QueryOffStreetParkingArgs = {
  cityId: Scalars['String']['input'];
  id: Scalars['String']['input'];
};


export type QueryOffStreetParkingAvailabilityArgs = {
  cityId: Scalars['String']['input'];
  endDate: Scalars['DateTime']['input'];
  startDate: Scalars['DateTime']['input'];
};


export type QueryOffStreetParkingOccupancyProfileArgs = {
  cityId: Scalars['String']['input'];
  endDate: Scalars['DateTime']['input'];
  startDate: Scalars['DateTime']['input'];
};


export type QueryOffStreetParkingsArgs = {
  boundingBox?: InputMaybe<Array<Array<Scalars['Float']['input']>>>;
  cityId: Scalars['String']['input'];
};


export type QueryPaginatedCitiesArgs = {
  filter?: InputMaybe<Array<FilterInput>>;
  pageIndex?: Scalars['Int']['input'];
  pageSize?: Scalars['Int']['input'];
  sortField?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<SortOrder>;
};


export type QueryParkingLotArgs = {
  cityId: Scalars['String']['input'];
  id: Scalars['String']['input'];
};


export type QueryParkingLotMetricsArgs = {
  cityId: Scalars['String']['input'];
  endDate: Scalars['DateTime']['input'];
  lotIds?: InputMaybe<Array<Scalars['String']['input']>>;
  startDate: Scalars['DateTime']['input'];
};


export type QueryParkingLotOccupancyByDayTimeArgs = {
  cityId: Scalars['String']['input'];
  daysOfWeek?: InputMaybe<Array<Scalars['Int']['input']>>;
  endDate: Scalars['DateTime']['input'];
  lotIds?: InputMaybe<Array<Scalars['String']['input']>>;
  startDate: Scalars['DateTime']['input'];
  timeRanges?: InputMaybe<Array<HourRangeInput>>;
};


export type QueryParkingLotTurnoverArgs = {
  cityId: Scalars['String']['input'];
  endDate: Scalars['DateTime']['input'];
  lotIds?: InputMaybe<Array<Scalars['String']['input']>>;
  startDate: Scalars['DateTime']['input'];
};


export type QueryParkingLotsArgs = {
  cityId: Scalars['String']['input'];
};


export type QueryPermanentDecreeCountsByTypeArgs = {
  category: DecreeCategory;
  cityId: Scalars['String']['input'];
  done?: InputMaybe<Scalars['Boolean']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};


export type QueryPermanentDecreesArgs = {
  filterInput: GetDecreesInput;
};


export type QueryPermanentDecreesCountArgs = {
  filterInput: GetDecreesInput;
};


export type QueryPermanentDecreesPaginatedArgs = {
  cityId: Scalars['String']['input'];
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  filter?: InputMaybe<Array<FilterInput>>;
  pageIndex?: Scalars['Int']['input'];
  pageSize?: Scalars['Int']['input'];
  sortField?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<SortOrder>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};


export type QueryPermitDecreeArgs = {
  cityId: Scalars['String']['input'];
  id: Scalars['String']['input'];
};


export type QueryPermitDecreeCountsByTypeArgs = {
  category: DecreeCategory;
  cityId: Scalars['String']['input'];
  done?: InputMaybe<Scalars['Boolean']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};


export type QueryPermitDecreeStatsArgs = {
  cityId: Scalars['String']['input'];
  endDate: Scalars['DateTime']['input'];
  startDate: Scalars['DateTime']['input'];
};


export type QueryPermitDecreesArgs = {
  permitDecreesInput: GetPermitDecreesInput;
};


export type QueryPermitDecreesCountArgs = {
  filterInput: GetPermitDecreesInput;
};


export type QueryPermitDecreesPaginatedArgs = {
  cityId: Scalars['String']['input'];
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  filter?: InputMaybe<Array<FilterInput>>;
  pageIndex?: Scalars['Int']['input'];
  pageSize?: Scalars['Int']['input'];
  sortField?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<SortOrder>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};


export type QueryPoliciesByCityIdArgs = {
  cityId: Scalars['String']['input'];
};


export type QueryRestrictedPlacesArgs = {
  cityId: Scalars['ID']['input'];
  from: Scalars['DateTime']['input'];
  to: Scalars['DateTime']['input'];
};


export type QueryRestrictionsArgs = {
  filterInput: SearchRestrictionInput;
};


export type QueryRestrictionsByBoundingArgs = {
  filterInput: SearchRestrictionInput;
};


export type QueryRestrictionsLostRevenueArgs = {
  cityId: Scalars['ID']['input'];
  from: Scalars['DateTime']['input'];
  to: Scalars['DateTime']['input'];
};


export type QueryTemporaryDecreeArgs = {
  cityId: Scalars['String']['input'];
  id: Scalars['String']['input'];
};


export type QueryTemporaryDecreeApplicantsPaginatedArgs = {
  cityId: Scalars['String']['input'];
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  filter?: InputMaybe<Array<FilterInput>>;
  pageIndex?: Scalars['Int']['input'];
  pageSize?: Scalars['Int']['input'];
  restrictionEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  restrictionStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  sortField?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<SortOrder>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  type?: InputMaybe<Array<TemporaryType>>;
};


export type QueryTemporaryDecreeCountsByCurbAreaArgs = {
  cityId: Scalars['String']['input'];
  done?: InputMaybe<Scalars['Boolean']['input']>;
  endDate: Scalars['DateTime']['input'];
  startDate: Scalars['DateTime']['input'];
};


export type QueryTemporaryDecreeCountsByTypeArgs = {
  category: DecreeCategory;
  cityId: Scalars['String']['input'];
  done?: InputMaybe<Scalars['Boolean']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};


export type QueryTemporaryDecreeStatsArgs = {
  cityId: Scalars['String']['input'];
  endDate: Scalars['DateTime']['input'];
  startDate: Scalars['DateTime']['input'];
};


export type QueryTemporaryDecreesCountArgs = {
  filterInput: GetTemporaryDecreesInput;
};


export type QueryTemporaryDecreesPaginatedArgs = {
  cityId: Scalars['String']['input'];
  curbAreaIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  filter?: InputMaybe<Array<FilterInput>>;
  pageIndex?: Scalars['Int']['input'];
  pageSize?: Scalars['Int']['input'];
  restrictionEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  restrictionEndsBetween?: InputMaybe<DateRangeInput>;
  restrictionStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  restrictionStartsBetween?: InputMaybe<DateRangeInput>;
  sortField?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<SortOrder>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};


export type QueryTensionArgs = {
  filterInput: GetHistoryTensionInput;
};


export type QueryTrafficRestrictionsLengthByStreetPaginatedArgs = {
  cityId: Scalars['String']['input'];
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  filter?: InputMaybe<Array<FilterInput>>;
  pageIndex?: Scalars['Int']['input'];
  pageSize?: Scalars['Int']['input'];
  restrictionEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  restrictionStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  sortField?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<SortOrder>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};


export type QueryUrbanFeaturesByBoundingArgs = {
  boundingbox?: InputMaybe<Array<Array<Scalars['Float']['input']>>>;
  cityId: Scalars['String']['input'];
  types?: InputMaybe<Array<UrbanFeatureType>>;
};


export type QueryViolationArgs = {
  filterInput: GetHistoryViolationsInput;
};


export type QueryWazeEventsArgs = {
  cityId: Scalars['String']['input'];
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};


export type QueryWorkAreasArgs = {
  cityId: Scalars['String']['input'];
};

export type Rate = {
  /** The number of rateUnits after which the rate stops applying (exclusive, see Range Boundaries). If not specified, this rate ends when the vehicle departs. */
  endDuration?: Maybe<Scalars['Float']['output']>;
  /** If specified, the rate for this space is rounded up to the nearest increment of this amount, specified in the same currency units as rate. */
  incrementAmount?: Maybe<Scalars['Float']['output']>;
  /**
   * If specified, this is the smallest number of rateUnits a user can pay for
   * (e.g., if incrementDuration is 15 and rateUnit is minute, a user can pay for 15, 30, 45, etc. minutes).
   */
  incrementDuration?: Maybe<Scalars['Float']['output']>;
  /** The rate for this space in cents (or the smallest denomination of local currency) per rateUnit. */
  rate: Scalars['Float']['output'];
  /** The unit of time associated with the rate. One of "second", "minute", "hour", "day", "week", "month", "quarter", "year". */
  rateUnit: UnitOfTime;
  /**
   * The period of time that the rateUnit covers. One of "rolling" or "calendar". If not specified, defaults to "rolling".
   * When rolling, the rateUnit begins (inclusive) at the timestamp of the event and ends (exclusive) when one full rateUnit has elapsed.
   *
   * For example, with {"rateUnit": "month", "rateUnitPeriod": "rolling"} the rateUnit for an event starting at 2022-02-25 19:25:52
   * would be interpreted as ranging from the start of the event - 2022-02-25 19:25:52 (inclusive) -
   * to the timestamp when one "month" has elapsed: 2022-03-25 19:25:52 (exclusive).
   * E.g. from the 25th of one month to the 25th of the next month.
   *
   * When calendar, the rateUnit begins (inclusive) at the start of the rateUnit in question and ends (exclusive) when one full rateUnit has elapsed.
   * For example, with {"rateUnit": "month", "rateUnitPeriod": "calendar"} the rateUnit for an event starting at 2022-02-25 19:25:52
   * would be interpreted as ranging from the start of the "month" - 2022-02-01 00:00:00 (inclusive) -
   * to the end of the "month": 2022-03-01 00:00:00 (exclusive).
   * E.g. from the 25th of the month to the end of the current calendar month only.
   *
   * The "week" rateUnit is defined as starting on Monday, per the ISO 8601 standard.
   */
  rateUnitPeriod?: Maybe<RateUnitPeriod>;
  /**
   * The number of rateUnits the vehicle must have already been present in the Curb Zone before this rate starts applying (inclusive, see Range Boundaries).
   * If not specified, this rate starts when the vehicle arrives.
   */
  startDuration?: Maybe<Scalars['Float']['output']>;
};

export type RateInput = {
  /** The number of rateUnits after which the rate stops applying (exclusive, see Range Boundaries). If not specified, this rate ends when the vehicle departs. */
  endDuration?: InputMaybe<Scalars['Float']['input']>;
  /** If specified, the rate for this space is rounded up to the nearest increment of this amount, specified in the same currency units as rate. */
  incrementAmount?: InputMaybe<Scalars['Float']['input']>;
  /**
   * If specified, this is the smallest number of rateUnits a user can pay for
   * (e.g., if incrementDuration is 15 and rateUnit is minute, a user can pay for 15, 30, 45, etc. minutes).
   */
  incrementDuration?: InputMaybe<Scalars['Float']['input']>;
  /** The rate for this space in cents (or the smallest denomination of local currency) per rateUnit. */
  rate: Scalars['Float']['input'];
  /** The unit of time associated with the rate. One of "second", "minute", "hour", "day", "week", "month", "quarter", "year". */
  rateUnit: UnitOfTime;
  /**
   * The period of time that the rateUnit covers. One of "rolling" or "calendar". If not specified, defaults to "rolling".
   * When rolling, the rateUnit begins (inclusive) at the timestamp of the event and ends (exclusive) when one full rateUnit has elapsed.
   *
   * For example, with {"rateUnit": "month", "rateUnitPeriod": "rolling"} the rateUnit for an event starting at 2022-02-25 19:25:52
   * would be interpreted as ranging from the start of the event - 2022-02-25 19:25:52 (inclusive) -
   * to the timestamp when one "month" has elapsed: 2022-03-25 19:25:52 (exclusive).
   * E.g. from the 25th of one month to the 25th of the next month.
   *
   * When calendar, the rateUnit begins (inclusive) at the start of the rateUnit in question and ends (exclusive) when one full rateUnit has elapsed.
   * For example, with {"rateUnit": "month", "rateUnitPeriod": "calendar"} the rateUnit for an event starting at 2022-02-25 19:25:52
   * would be interpreted as ranging from the start of the "month" - 2022-02-01 00:00:00 (inclusive) -
   * to the end of the "month": 2022-03-01 00:00:00 (exclusive).
   * E.g. from the 25th of the month to the end of the current calendar month only.
   *
   * The "week" rateUnit is defined as starting on Monday, per the ISO 8601 standard.
   */
  rateUnitPeriod?: InputMaybe<RateUnitPeriod>;
  /**
   * The number of rateUnits the vehicle must have already been present in the Curb Zone before this rate starts applying (inclusive, see Range Boundaries).
   * If not specified, this rate starts when the vehicle arrives.
   */
  startDuration?: InputMaybe<Scalars['Float']['input']>;
};

export enum RateUnitPeriod {
  Calendar = 'calendar',
  Rolling = 'rolling'
}

export type RestrictedPlacesByPolicy = {
  category: PolicyCategory;
  iconColor?: Maybe<IconColor>;
  policyId: Scalars['ID']['output'];
  policyName?: Maybe<Scalars['String']['output']>;
  /**
   * Sum of restricted spaces attributed to this policy across the queried
   * window. Each restriction contributes its own space count, so a single
   * parking space may be counted multiple times if it was restricted more
   * than once during the window.
   */
  restrictedSpaces: Scalars['Int']['output'];
  restrictionCount: Scalars['Int']['output'];
};

export type RestrictedPlacesByType = {
  byPolicy: Array<RestrictedPlacesByPolicy>;
  /**
   * Sum of restricted spaces attributed to this restriction type across the
   * queried window. Each restriction contributes its own space count, so a
   * single parking space may be counted multiple times if it was restricted
   * more than once during the window.
   */
  restrictedSpaces: Scalars['Int']['output'];
  restrictionCount: Scalars['Int']['output'];
  type: TemporaryType;
};

export type RestrictedPlacesReport = {
  byType: Array<RestrictedPlacesByType>;
  /**
   * Sum of restricted spaces across every restriction in the queried window.
   * Each restriction contributes its own space count independently; a parking
   * space restricted multiple times (e.g. by restrictions of different types)
   * contributes to the total once per restriction.
   */
  totalRestrictedSpaces: Scalars['Int']['output'];
};

export type Restriction = {
  /** Number of restricted spaces */
  calculatedSpaces?: Maybe<Scalars['Float']['output']>;
  /** Category of restriction (e.g. "Stationnement", "Circulation") */
  category: Scalars['String']['output'];
  cityId: Scalars['String']['output'];
  curbZoneId?: Maybe<Scalars['UUID']['output']>;
  decreeIds?: Maybe<Array<Scalars['String']['output']>>;
  description?: Maybe<Scalars['String']['output']>;
  editLine: Scalars['GeoJSONFeature']['output'];
  geoPoint2d: Array<Scalars['Float']['output']>;
  geometry: Scalars['GeoJSONPolygon']['output'];
  /** Unique CurbZone ID, for Macaron usage only */
  id: Scalars['ID']['output'];
  /** The length of the restriction in meters. */
  length?: Maybe<Scalars['Float']['output']>;
  /** The name of the street that this restriction is on. */
  streetName?: Maybe<Scalars['String']['output']>;
  streetNumberEnd?: Maybe<Scalars['String']['output']>;
  streetNumberStart?: Maybe<Scalars['String']['output']>;
  timeSpans?: Maybe<Array<TimeSpanEntity>>;
  /** Total duration of the restriction in minutes */
  totalDuration?: Maybe<Scalars['Float']['output']>;
  /** Type of restriction (e.g. "Demenagement", "Livraison") */
  type?: Maybe<RestrictionType>;
  /** The width, in meters, that the Curb Zone occupies from the curb to the roadway lane. */
  width?: Maybe<Scalars['Float']['output']>;
};

export type RestrictionDecree = {
  /** Number of restricted spaces */
  calculatedSpaces?: Maybe<Scalars['Float']['output']>;
  /** Category of restriction (e.g. "Stationnement", "Circulation") */
  category: Scalars['String']['output'];
  cityId: Scalars['String']['output'];
  curbZoneId?: Maybe<Scalars['UUID']['output']>;
  decreeIds?: Maybe<Array<Scalars['String']['output']>>;
  decrees?: Maybe<Array<TemporaryDecree>>;
  description?: Maybe<Scalars['String']['output']>;
  editLine: Scalars['GeoJSONFeature']['output'];
  geoPoint2d: Array<Scalars['Float']['output']>;
  geometry: Scalars['GeoJSONPolygon']['output'];
  /** Unique CurbZone ID, for Macaron usage only */
  id: Scalars['ID']['output'];
  /** The length of the restriction in meters. */
  length?: Maybe<Scalars['Float']['output']>;
  /** The name of the street that this restriction is on. */
  streetName?: Maybe<Scalars['String']['output']>;
  streetNumberEnd?: Maybe<Scalars['String']['output']>;
  streetNumberStart?: Maybe<Scalars['String']['output']>;
  timeSpans?: Maybe<Array<TimeSpanEntity>>;
  /** Total duration of the restriction in minutes */
  totalDuration?: Maybe<Scalars['Float']['output']>;
  /** Type of restriction (e.g. "Demenagement", "Livraison") */
  type?: Maybe<RestrictionType>;
  /** The width, in meters, that the Curb Zone occupies from the curb to the roadway lane. */
  width?: Maybe<Scalars['Float']['output']>;
};

export type RestrictionInstruction = {
  address: Scalars['String']['output'];
  /** [longitude, latitude]. Null when geocoding failed. */
  coordinates?: Maybe<Array<Scalars['Float']['output']>>;
  endDate?: Maybe<Scalars['DateTime']['output']>;
  instruction: Scalars['String']['output'];
  startDate?: Maybe<Scalars['DateTime']['output']>;
};

/** Type of Restriction (e.g. "Demenagement", "Livraison") */
export enum RestrictionType {
  AlternateTrafficRestriction = 'alternateTrafficRestriction',
  ConstructionWork = 'constructionWork',
  Moving = 'moving',
  OneTimeEvent = 'oneTimeEvent',
  Other = 'other',
  PublicDomainOccupation = 'publicDomainOccupation',
  RecurringEvent = 'recurringEvent',
  TrafficRestriction = 'trafficRestriction'
}

export type SearchCalculatedSpacesInput = {
  cityId: Scalars['String']['input'];
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type SearchCurbZoneInput = {
  boundingbox?: InputMaybe<Array<Array<Scalars['Float']['input']>>>;
  cityId: Scalars['String']['input'];
  liveParking?: InputMaybe<Scalars['Boolean']['input']>;
  policies?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** Only return curb zones whose properties were last updated at this date/time or later (inclusive). */
  updatedFrom?: InputMaybe<Scalars['DateTime']['input']>;
  /** Only return curb zones whose properties were last updated before this date/time (exclusive). */
  updatedTo?: InputMaybe<Scalars['DateTime']['input']>;
};

export type SearchRestrictionInput = {
  /** @deprecated Use temporaryDecreeCountsByCurbArea or the curbAreaIds filter of temporaryDecreesPaginated instead. */
  boundingbox?: InputMaybe<Array<Array<Scalars['Float']['input']>>>;
  cityId: Scalars['String']['input'];
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  type?: InputMaybe<RestrictionType>;
};

export enum SortOrder {
  Asc = 'ASC',
  Ascending = 'ASCENDING',
  Desc = 'DESC',
  Descending = 'DESCENDING',
  MinusOne = 'MINUS_ONE',
  One = 'ONE'
}

export type TemporaryDecree = IDecree & {
  /** True if decree has been analyzed by the AI */
  analyzed?: Maybe<Scalars['Boolean']['output']>;
  /** Name of the applicant (pétitionnaire) who requested the decree */
  applicant?: Maybe<Scalars['String']['output']>;
  /** Decree category */
  category: DecreeCategory;
  /** CityID of decree */
  cityId: Scalars['String']['output'];
  /** Comments of decree */
  comments?: Maybe<Scalars['String']['output']>;
  /** Created at */
  createdAt: Scalars['DateTime']['output'];
  /** Decree's own reference number as written in the document */
  decreeNumber?: Maybe<Scalars['String']['output']>;
  /** Image associated to the city */
  done: Scalars['Boolean']['output'];
  /**
   * Populated only when the decree extends (prorogates) a prior decree.
   * Undefined for new decrees.
   */
  extension?: Maybe<Extension>;
  /** Unique city ID */
  id: Scalars['ID']['output'];
  /** Name of decree */
  name: Scalars['String']['output'];
  /**
   * Name of the order-giver (donneur d'ordre / maître d'ouvrage) on whose behalf the work is done.
   * Null when the decree does not name a distinct order-giver.
   */
  orderGiver?: Maybe<Scalars['String']['output']>;
  /** Public URL of the decree */
  publicUrl?: Maybe<Scalars['String']['output']>;
  /** Date of decree publication */
  publishedDate?: Maybe<Scalars['DateTime']['output']>;
  restrictionInstructions?: Maybe<Array<RestrictionInstruction>>;
  /** Restrictions of decree */
  restrictions?: Maybe<Array<Restriction>>;
  /** Number of restrictions currently linked to this decree. */
  restrictionsCount?: Maybe<Scalars['Int']['output']>;
  /** Short summary of the decree for display */
  summary?: Maybe<DecreeSummary>;
  /** Title of decree */
  title?: Maybe<Scalars['String']['output']>;
  /** Decree type */
  type?: Maybe<TemporaryType>;
};

export type TemporaryDecreePaginatedResult = {
  /** Available filters */
  filters?: Maybe<Scalars['JSON']['output']>;
  results: Array<TemporaryDecree>;
  /** Total number of items */
  totalCount: Scalars['Int']['output'];
  /** Total number of pages */
  totalPages: Scalars['Int']['output'];
};

/** Type of Temporary Decree (e.g. "Demenagement", "Livraison") */
export enum TemporaryType {
  ConstructionWork = 'constructionWork',
  Moving = 'moving',
  OneTimeEvent = 'oneTimeEvent',
  Other = 'other',
  PublicDomainOccupation = 'publicDomainOccupation',
  RecurringEvent = 'recurringEvent'
}

export type Tension = {
  date: Scalars['String']['output'];
  totalOccupied: Scalars['Float']['output'];
};

export type TilesetResponseEntity = {
  citiesBoundariesTilesetId: Scalars['String']['output'];
  citiesCurbZoneParkingTilesetId: Scalars['String']['output'];
};

export type TimeSpanEntity = {
  /**
   * An array of days of the month when this Time Span applies, specified as integers (1-31).
   * Note that, in order to specify, e.g., the "2nd Monday of the month",
   * you can use daysOfMonth combined with daysOfWeek (in this example, daysOfWeek = ["mon"] and daysOfMonth = [8,9,10,11,12,13,14]).
   */
  daysOfMonth?: Maybe<Array<Scalars['Float']['output']>>;
  /** An array of days of the week when this Time Span applies, specified as 3-character strings ("sun", "mon", "tue", "wed", "thu", "fri", "sat"). */
  daysOfWeek?: Maybe<Array<DaysOfWeek>>;
  /** Localized display days of week */
  daysOfWeekDisplay?: Maybe<Scalars['String']['output']>;
  /**
   * A string representing an arbitrarily-named, externally-defined period of time.
   * Any values MAY be specified but the following known values SHOULD be used when possible:
   *
   *     snow emergency
   *     holidays
   *     school days
   *     game days
   */
  designatedPeriod?: Maybe<Scalars['String']['output']>;
  /**
   * If specified and true, this Time Span applies at all times not matching the named designated period.
   * (e.g., if designatedPeriod is snow emergency and designatedPeriodExcept is true, this Time Span does not apply on snow days).
   */
  designatedPeriodExcept?: Maybe<Scalars['Boolean']['output']>;
  /**
   * The latest point in time that this Time Span could apply (exclusive, see Range Boundaries).
   * If unspecified, the Time Span applies to all matching periods arbitrarily far in the future. See note below for more details.
   */
  endDate?: Maybe<Scalars['DateTime']['output']>;
  /** If specified, this Time Span applies only during these months (1=January, 12=December). */
  months?: Maybe<Array<Scalars['Float']['output']>>;
  /**
   * The earliest point in time that this Time Span could apply (inclusive, see Range Boundaries).
   * If unspecified, the Time Span applies to all matching periods arbitrarily far in the past. See note below for more details.
   */
  startDate?: Maybe<Scalars['DateTime']['output']>;
  /**
   * The 24-hour local time that this Time Span stops applying (exclusive, see Range Boundaries), in the local timezone.
   * This is not inclusive, so for instance if timeOfDayEnd is "17:00", this Time Span goes up to 5PM but does not include it.
   * If unspecified, this Time Span ends at midnight.
   */
  timeOfDayEnd?: Maybe<Scalars['String']['output']>;
  /**
   * The 24-hour local time that this Time Span starts to apply (inclusive, see Range Boundaries), in the local timezone.
   * If unspecified, this Time Span starts at midnight.
   */
  timeOfDayStart?: Maybe<Scalars['String']['output']>;
  /** Time range display, fomarted as "HH:mm - HH:mm" */
  timeRangeDisplay?: Maybe<Scalars['String']['output']>;
};

export type TimeSpanInput = {
  /**
   * An array of days of the month when this Time Span applies, specified as integers (1-31).
   * Note that, in order to specify, e.g., the "2nd Monday of the month",
   * you can use daysOfMonth combined with daysOfWeek (in this example, daysOfWeek = ["mon"] and daysOfMonth = [8,9,10,11,12,13,14]).
   */
  daysOfMonth?: InputMaybe<Array<Scalars['Float']['input']>>;
  /** An array of days of the week when this Time Span applies, specified as 3-character strings ("sun", "mon", "tue", "wed", "thu", "fri", "sat"). */
  daysOfWeek?: InputMaybe<Array<DaysOfWeek>>;
  /**
   * A string representing an arbitrarily-named, externally-defined period of time.
   * Any values MAY be specified but the following known values SHOULD be used when possible:
   *
   *     snow emergency
   *     holidays
   *     school days
   *     game days
   */
  designatedPeriod?: InputMaybe<Scalars['String']['input']>;
  /**
   * If specified and true, this Time Span applies at all times not matching the named designated period.
   * (e.g., if designatedPeriod is snow emergency and designatedPeriodExcept is true, this Time Span does not apply on snow days).
   */
  designatedPeriodExcept?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * The latest point in time that this Time Span could apply (exclusive, see Range Boundaries).
   * If unspecified, the Time Span applies to all matching periods arbitrarily far in the future. See note below for more details.
   */
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** If specified, this Time Span applies only during these months (1=January, 12=December). */
  months?: InputMaybe<Array<Scalars['Float']['input']>>;
  /**
   * The earliest point in time that this Time Span could apply (inclusive, see Range Boundaries).
   * If unspecified, the Time Span applies to all matching periods arbitrarily far in the past. See note below for more details.
   */
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  /**
   * The 24-hour local time that this Time Span stops applying (exclusive, see Range Boundaries), in the local timezone.
   * This is not inclusive, so for instance if timeOfDayEnd is "17:00", this Time Span goes up to 5PM but does not include it.
   * If unspecified, this Time Span ends at midnight.
   */
  timeOfDayEnd?: InputMaybe<Scalars['String']['input']>;
  /**
   * The 24-hour local time that this Time Span starts to apply (inclusive, see Range Boundaries), in the local timezone.
   * If unspecified, this Time Span starts at midnight.
   */
  timeOfDayStart?: InputMaybe<Scalars['String']['input']>;
};

export type TimelineSegment = {
  curbPolicyId?: Maybe<Scalars['UUID']['output']>;
  end: Scalars['String']['output'];
  endPercentage: Scalars['Float']['output'];
  fillColor: Array<Scalars['Float']['output']>;
  policyCategory?: Maybe<PolicyCategory>;
  policyName: Scalars['String']['output'];
  start: Scalars['String']['output'];
  startPercentage: Scalars['Float']['output'];
};

export type TimezoneEntity = {
  /** Timezone information. eg: Europe/Paris */
  iana: Scalars['String']['output'];
  /** Version of the timezone database used. eg: 2020a */
  tzdb?: Maybe<Scalars['String']['output']>;
};

export type TimezoneInput = {
  /** Timezone information. eg: Europe/Paris */
  iana: Scalars['String']['input'];
  /** Version of the timezone database used. eg: 2020a */
  tzdb?: InputMaybe<Scalars['String']['input']>;
};

export enum UnitOfTime {
  Day = 'day',
  Hour = 'hour',
  Minute = 'minute',
  Month = 'month',
  Second = 'second',
  Week = 'week',
  Year = 'year'
}

export type Update = {
  at: Scalars['DateTime']['output'];
  userId: Scalars['String']['output'];
};

export type UpdateCityInput = {
  /** City Boundaries */
  boundaries?: InputMaybe<Scalars['GeoJSONGeometry']['input']>;
  /** Other details about the city */
  details?: InputMaybe<CityDetailsInput>;
  id: Scalars['ID']['input'];
  /** Image associated to the city */
  image?: InputMaybe<Scalars['String']['input']>;
  /** Name of the city */
  name?: InputMaybe<Scalars['String']['input']>;
  /** GeoJSON position of the city */
  position?: InputMaybe<Array<Scalars['Float']['input']>>;
  /** City ZIP code */
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCurbAreaInput = {
  /** Macaron custom data */
  cityId?: InputMaybe<Scalars['String']['input']>;
  /** The spatial extent of this curb area. */
  geometry?: InputMaybe<Scalars['GeoJSONPolygon']['input']>;
  /** Unique CurbZone ID, for Macaron usage only */
  id: Scalars['ID']['input'];
  /** The name of this curb area for reference. */
  name?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCurbZoneInput = {
  /** If availability information is present, the timestamp corresponding to the most recent time that availability was computed for this zone. */
  availabilityTime?: InputMaybe<Scalars['DateTime']['input']>;
  /**
   * If availability information is present, an array of numbers containing the lengths (in meters) of all known non-overlapping available spaces within this Curb Zone.
   * In cases where availability is known less precisely, this data MAY be inferred from a model.
   */
  availableSpaceLengths?: InputMaybe<Array<Scalars['Float']['input']>>;
  /** Macaron custom data */
  calculatedArea?: InputMaybe<Scalars['Float']['input']>;
  calculatedSpaces?: InputMaybe<Scalars['Float']['input']>;
  cityId?: InputMaybe<Scalars['String']['input']>;
  /** The name of the cross street at the end of this Curb Zone. */
  crossStreetEndName?: InputMaybe<Scalars['String']['input']>;
  /**
   * The name of the cross street at or before the start of this Curb Zone
   * (which cross street is at the start and end of the location is defined in the same direction as the linear reference for this curb;
   * if no linear reference is provided, start and end SHOULD be oriented such that start comes before end when moving in the direction
   * of travel for the roadway immediately adjacent to the curb.)
   */
  crossStreetStartName?: InputMaybe<Scalars['String']['input']>;
  /**
   * The ID(s) of the Curb Areas that this Curb Zone is a part of.
   * If specified, the areas identified MUST be retrievable through the Curb API and its geographical area MUST contain that of the Curb Zone.
   */
  curbAreaIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** An array of IDs of Policy objects. Together, these define the regulations of this Curb Zone. */
  curbPolicyIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /**
   * The ID(s) of the Curb Spaces that this Curb Zone contains.
   * If specified, the spaces identified MUST be retrievable through the Curb API and its geographical area MUST be contained in this Curb Zone.
   */
  curbSpaceIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  decreeIds?: InputMaybe<Array<Scalars['String']['input']>>;
  editLine?: InputMaybe<Scalars['GeoJSONFeature']['input']>;
  /**
   * The time at which the data for this curb location ceases to be valid (exclusive, see Range Boundaries).
   * If not present, the data will be presumed to be valid indefinitely
   */
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  /**
   * If "true", this curb location takes up the entire width of the roadway (which may be impassible for through traffic when
   * the Curb Zone is being used for parking or loading).
   * This is a common condition for alleyways. If entireRoadway is true, streetSide MUST NOT be present.
   */
  entireRoadway?: InputMaybe<Scalars['Boolean']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  geoPoint2d?: InputMaybe<Array<Scalars['Float']['input']>>;
  /** The spatial extent of this curb zone. A new curbZoneId is required if this geometry changes. */
  geometry?: InputMaybe<Scalars['GeoJSONPolygon']['input']>;
  /** Unique CurbZone ID, for Macaron usage only */
  id: Scalars['ID']['input'];
  /**
   * The length, in meters, of the Curb Zone when projected along the street centerline.
   * Note that this is the definitive length of the curb area, and not the edge length of the geographic polygon.
   */
  length?: InputMaybe<Scalars['Float']['input']>;
  /** One or more linear references for this Curb Zone. */
  locationReferences?: InputMaybe<Array<LocationReferenceInput>>;
  /**
   * If "true", this curb location is on the median of a street, rather than its edge.
   * A median is a strip of land separating two roadways within the same street.
   * Note that, for medians, streetSide is interpreted relative to the roadway that the particular curb is on,
   * so the curb along the median of the southern roadway of a divided street would have streetSide of N.
   */
  median?: InputMaybe<Scalars['Boolean']['input']>;
  /** A human-readable name for this Curb Zone that identifies it to end users. */
  name?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  /** The number of demarcated spaces within this Curb Zone. Demarcated spaces may also be specified using Curb Spaces. */
  numSpaces?: InputMaybe<Scalars['Float']['input']>;
  /**
   * The angle in which passenger vehicles in this Curb Zone are meant to park. May take one of the following values:
   *
   * parallel
   * perpendicular
   * angled
   */
  parkingAngle?: InputMaybe<ParkingAngle>;
  /** An array of IDs of previous curb zone objects. They are listed in order with the most recent ones first. */
  prevCurbZoneIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** An array of information about previous policies that have applied to this curb zone. They are listed in order with the most recent ones first. */
  prevPolicies?: InputMaybe<Array<PreviousPolicyInput>>;
  /** The date/time that this curb zone was first published in this data feed. */
  publishedDate?: InputMaybe<Scalars['DateTime']['input']>;
  /**
   * The earliest time that the data for this curb location is known to be valid (inclusive, see Range Boundaries).
   * This could be the date on which the data was collected, for instance. This MUST never change for a given id.
   */
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** The name of the street that this Curb Zone is on. */
  streetName?: InputMaybe<Scalars['String']['input']>;
  streetNumberEnd?: InputMaybe<Scalars['String']['input']>;
  streetNumberStart?: InputMaybe<Scalars['String']['input']>;
  /**
   * The cardinal or subcardinal direction representing the side of the roadway that this curb is on.
   * May be N, NE, E, SE, S, SW, W, or NW.
   * For cities with "grid directions", the side MAY be based on the grid direction rather than the closest true-north compass direction,
   * but MUST NOT be more than 90 degrees away from the true compass direction.
   */
  streetSide?: InputMaybe<CardinalDirection>;
  /** An identifier that can be used to refer to this Curb Zone on physical signage as well as within mobile applications, typically for payment purposes. */
  userZoneId?: InputMaybe<Scalars['String']['input']>;
  /** The width, in meters, that the Curb Zone occupies from the curb to the roadway lane. */
  width?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateDecreeCategoryInput = {
  newCategory: DecreeCategory;
};

export type UpdateDecreeInput = {
  /** Comments of decree */
  comments?: InputMaybe<Scalars['String']['input']>;
  /** Decree's own reference number as written in the document */
  decreeNumber?: InputMaybe<Scalars['String']['input']>;
  /** Image associated to the city */
  done?: InputMaybe<Scalars['Boolean']['input']>;
  /** Unique city ID */
  id: Scalars['ID']['input'];
  /** Name of decree */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Date of decree publication */
  publishedDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Title of decree */
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOffStreetParkingInput = {
  /** Payment methods accepted at the facility. */
  acceptedPaymentMethods?: InputMaybe<Array<PaymentMethod>>;
  /** Entrances and exits of the facility, each with its own type, position and address. */
  accessPoints?: InputMaybe<Array<AccessPointInput>>;
  /** Who is allowed to use the facility. */
  accessType?: InputMaybe<ParkingAccessType>;
  address?: InputMaybe<Scalars['String']['input']>;
  /** Structured postal address of the facility. */
  addressDetails?: InputMaybe<AddressInput>;
  /** Footprint of the facility building or lot. */
  boundary?: InputMaybe<Scalars['GeoJSONPolygon']['input']>;
  cityId?: InputMaybe<Scalars['String']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  /** Physical construction of the facility. */
  layout?: InputMaybe<ParkingLayout>;
  /** Number of levels */
  levels?: InputMaybe<Scalars['Float']['input']>;
  location?: InputMaybe<Scalars['GeoJSONPoint']['input']>;
  /** Maximum vehicle height allowed, in metres. */
  maxHeight?: InputMaybe<Scalars['Float']['input']>;
  /** Maximum vehicle length allowed, in metres. */
  maxLength?: InputMaybe<Scalars['Float']['input']>;
  /** Maximum vehicle weight allowed, in tonnes. */
  maxWeight?: InputMaybe<Scalars['Float']['input']>;
  /** Maximum vehicle width allowed, in metres. */
  maxWidth?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** If specified, this opening hours of the parking */
  openingHours?: InputMaybe<Array<TimeSpanInput>>;
  /** Name of the company operating the facility. */
  operator?: InputMaybe<Scalars['String']['input']>;
  /** Options of the private parking */
  options?: InputMaybe<OffStreetParkingOptionsInput>;
  /**
   * Legacy free-text secondary entrances. Superseded by `accessPoints`.
   * @deprecated Use `accessPoints`.
   */
  otherAdresses?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Contact phone number for the facility. */
  phone?: InputMaybe<Scalars['String']['input']>;
  pricePerHour?: InputMaybe<Scalars['Float']['input']>;
  /** Legacy free-text construction type. Prefer `layout`. */
  structure?: InputMaybe<Scalars['String']['input']>;
  totalPlaces?: InputMaybe<Scalars['Float']['input']>;
  /** Website of the facility. */
  website?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateParkingLotInput = {
  /** The address of this parking lot for reference. */
  address?: InputMaybe<Scalars['String']['input']>;
  /** Macaron custom data */
  cityId: Scalars['String']['input'];
  /** @deprecated Ignored. Zone membership is determined by the parking lot geometry. */
  curbZoneIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The spatial extent of this curb area. */
  geometry?: InputMaybe<Scalars['GeoJSONPolygon']['input']>;
  /** Unique CurbZone ID, for Macaron usage only */
  id: Scalars['ID']['input'];
  /** The name of this parking lot for reference. */
  name?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateParkingMeterInput = {
  address?: InputMaybe<AddressInput>;
  /** Battery level of the parking meter if available */
  batteryLevel?: InputMaybe<Scalars['Float']['input']>;
  /** Brand of of the parking meter */
  brand?: InputMaybe<Scalars['String']['input']>;
  /** City id */
  cityId?: InputMaybe<Scalars['String']['input']>;
  /** External id */
  externalId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  /** Last maintenance date */
  lastMaintenanceDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Location */
  location?: InputMaybe<Scalars['GeoJSONPoint']['input']>;
  /** Model of the parking meter */
  model?: InputMaybe<Scalars['String']['input']>;
  /** Name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Operator of the parking meter */
  operator?: InputMaybe<Scalars['String']['input']>;
  /** Options */
  options?: InputMaybe<ParkingMeterOptionsInput>;
  /** Status */
  status?: InputMaybe<Scalars['String']['input']>;
  /** Zone the parking meter operates in */
  zone?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePermanentDecreeInput = {
  /** Comments of decree */
  comments?: InputMaybe<Scalars['String']['input']>;
  /** Decree's own reference number as written in the document */
  decreeNumber?: InputMaybe<Scalars['String']['input']>;
  /** Image associated to the city */
  done?: InputMaybe<Scalars['Boolean']['input']>;
  /** Unique city ID */
  id: Scalars['ID']['input'];
  /** Name of decree */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Date of decree publication */
  publishedDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Title of decree */
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePermitDecreeInput = {
  /** Comments of decree */
  comments?: InputMaybe<Scalars['String']['input']>;
  /** Decree's own reference number as written in the document */
  decreeNumber?: InputMaybe<Scalars['String']['input']>;
  /** Image associated to the city */
  done?: InputMaybe<Scalars['Boolean']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Unique city ID */
  id: Scalars['ID']['input'];
  locations?: InputMaybe<Array<PermitDecreeLocationInput>>;
  /** Name of decree */
  name?: InputMaybe<Scalars['String']['input']>;
  petitionnerName?: InputMaybe<Scalars['String']['input']>;
  /** Date of decree publication */
  publishedDate?: InputMaybe<Scalars['DateTime']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Title of decree */
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<PermitType>;
};

export type UpdatePolicyInput = {
  category: PolicyCategory;
  cityId?: InputMaybe<Scalars['String']['input']>;
  color?: InputMaybe<ColorInput>;
  /**
   * An array of Data Source Operator IDs that this policy only applies to.
   * IDs come from dataSourceOperators.csv file here in the CDS repo.
   * Read our How to Get a Data Source Operator ID guide.
   */
  dataSourceOperatorId?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** Unique CurbZone ID, for Macaron usage only */
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  /**
   * Specifies which other policies this one takes precedence over.
   * If two Policies on the same Curb Zone have overlapping Time Spans and apply to the same user class,
   * the one that applies at a given time is the one with the lowest priority.
   * E.g., a priority of 1 takes precedence over a priority of 3.
   * Two Policies that apply to the same Curb Zone with overlapping Time Spans and equivalent User Class enumerations MUST NOT have the same priority.
   */
  priority?: InputMaybe<Scalars['Float']['input']>;
  /** The rule(s) that this policy applies. If a Policy specifies multiple rules, each rule MUST specify disjoint lists of user classes. */
  rules?: InputMaybe<Array<UpdatePolicyRuleInput>>;
  state?: InputMaybe<Scalars['String']['input']>;
  /** If specified, this regulation only applies at the times defined within. */
  timeSpans?: InputMaybe<Array<TimeSpanInput>>;
};

export type UpdatePolicyRuleInput = {
  /**
   * The activity that is forbidden or permitted by this regulation. Value MUST be one of the activities.
   * Activities
   *
   * The following activities may be specified for rules within a policy.
   * The reason we have "positive" and "negative" versions of the same activities (like loading and no parking) is due to priorities:
   * a loading rule that is higher priority than a no loading rule, for instance, implies that the Curb Zone does allow loading at the time in question,
   * while a no parking rule would not. If "negative", rate array should be empty.
   *
   *     parking - implies that loading and stopping are also permitted
   *     no parking - may not stop and leave vehicle unattended
   *     loading - loading of goods; implies that stopping is also permitted
   *     no loading - no loading allowed; implies that parking is also prohibited
   *     unloading - unloading of goods; implies that stopping is also permitted
   *     no unloading - no unloading allowed; implies that parking is also prohibited
   *     stopping - stopping briefly to pick up or drop off passengers
   *     no stopping - stopping, loading, unloading, and parking are all prohibited; not a typical travel lane
   *     travel - represents curbside lanes typically intended for moving vehicles, like bus lanes, bike lanes, and rush-hour-only travel lanes; implies that parking, loading, unloading, and stopping are prohibited.
   *     no travel - no travel allowed; implies it could be used for other activities
   */
  activity?: InputMaybe<Activity>;
  /**
   * The length of time (in units of maxStayUnit) for which the curb may be used under this regulation.
   * If not specified, the curb may be used under this regulation indefinitely. May not be applicable for all activities.
   */
  maxStay?: InputMaybe<Scalars['Float']['input']>;
  /** The Unit of Time associated with the maxStay value. Defaults to "minute". */
  maxStayUnit?: InputMaybe<UnitOfTime>;
  /**
   * The length of time (in units of noReturnUnit) that a user must vacate a Curb Zone before being allowed to return for another stay.
   * Defaults to 0. May not be applicable for all activities.
   */
  noReturn?: InputMaybe<Scalars['Float']['input']>;
  /** The Unit of Time associated with the noReturn value. Defaults to "minute". */
  noReturnUnit?: InputMaybe<UnitOfTime>;
  /**
   * The cost of using this Curb Zone when this regulation applies.
   * Rates are repeated to allow for prices that change over time.
   * For instance, a regulation may have a price of $1 for the first hour but $2 for every subsequent hour.
   * The complete set of the Rates array must span from startMinutes = 0 or null to endMinutes = maxStay without overlap of effective minutes
   * (i.e. the range created by rate startMinutes and endMinutes).
   * If a "negative" activity is used, this array should be empty. May not be applicable for all activity.
   */
  rate?: InputMaybe<Array<UpdateRateInput>>;
  /**
   * If specified, this regulation only applies to users matching the user classes contained within.
   * If not specified, this regulation applies to everyone.
   * The order of userClasses is not relevant, but a vehicle using a curb with this rule must match all userClasses contained in the array.
   *
   * Well-known values:
   *
   * Vehicle types: bicycle, bus, cargoBicycle, car, moped, motorcycle, scooter, truck, van
   *
   * Vehicle properties: handicap-accessible, human, electricAssist, electric, combustion, autonomous
   *
   * Purpose: construction, delivery, emergencyUse, freight, parking, permit, rideshare, school, serviceVehicles, specialEvents, taxi, utilities, vending, wasteManagement
   */
  userClasses?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateRateInput = {
  /** The number of rateUnits after which the rate stops applying (exclusive, see Range Boundaries). If not specified, this rate ends when the vehicle departs. */
  endDuration?: InputMaybe<Scalars['Float']['input']>;
  /** If specified, the rate for this space is rounded up to the nearest increment of this amount, specified in the same currency units as rate. */
  incrementAmount?: InputMaybe<Scalars['Float']['input']>;
  /**
   * If specified, this is the smallest number of rateUnits a user can pay for
   * (e.g., if incrementDuration is 15 and rateUnit is minute, a user can pay for 15, 30, 45, etc. minutes).
   */
  incrementDuration?: InputMaybe<Scalars['Float']['input']>;
  /** The rate for this space in cents (or the smallest denomination of local currency) per rateUnit. */
  rate?: InputMaybe<Scalars['Float']['input']>;
  /** The unit of time associated with the rate. One of "second", "minute", "hour", "day", "week", "month", "quarter", "year". */
  rateUnit?: InputMaybe<UnitOfTime>;
  /**
   * The period of time that the rateUnit covers. One of "rolling" or "calendar". If not specified, defaults to "rolling".
   * When rolling, the rateUnit begins (inclusive) at the timestamp of the event and ends (exclusive) when one full rateUnit has elapsed.
   *
   * For example, with {"rateUnit": "month", "rateUnitPeriod": "rolling"} the rateUnit for an event starting at 2022-02-25 19:25:52
   * would be interpreted as ranging from the start of the event - 2022-02-25 19:25:52 (inclusive) -
   * to the timestamp when one "month" has elapsed: 2022-03-25 19:25:52 (exclusive).
   * E.g. from the 25th of one month to the 25th of the next month.
   *
   * When calendar, the rateUnit begins (inclusive) at the start of the rateUnit in question and ends (exclusive) when one full rateUnit has elapsed.
   * For example, with {"rateUnit": "month", "rateUnitPeriod": "calendar"} the rateUnit for an event starting at 2022-02-25 19:25:52
   * would be interpreted as ranging from the start of the "month" - 2022-02-01 00:00:00 (inclusive) -
   * to the end of the "month": 2022-03-01 00:00:00 (exclusive).
   * E.g. from the 25th of the month to the end of the current calendar month only.
   *
   * The "week" rateUnit is defined as starting on Monday, per the ISO 8601 standard.
   */
  rateUnitPeriod?: InputMaybe<RateUnitPeriod>;
  /**
   * The number of rateUnits the vehicle must have already been present in the Curb Zone before this rate starts applying (inclusive, see Range Boundaries).
   * If not specified, this rate starts when the vehicle arrives.
   */
  startDuration?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateRestrictionInput = {
  calculatedSpaces?: InputMaybe<Scalars['Float']['input']>;
  cityId?: InputMaybe<Scalars['String']['input']>;
  curbZoneId?: InputMaybe<Scalars['String']['input']>;
  decreeIds?: InputMaybe<Array<Scalars['String']['input']>>;
  description?: InputMaybe<Scalars['String']['input']>;
  editLine?: InputMaybe<Scalars['GeoJSONFeature']['input']>;
  geoPoint2d?: InputMaybe<Array<Scalars['Float']['input']>>;
  geometry?: InputMaybe<Scalars['GeoJSONPolygon']['input']>;
  /** Unique CurbZone ID, for Macaron usage only */
  id: Scalars['ID']['input'];
  /** The length of the restriction in meters. */
  length?: InputMaybe<Scalars['Float']['input']>;
  /** The name of the street that this restriction is on. */
  streetName?: InputMaybe<Scalars['String']['input']>;
  streetNumberEnd?: InputMaybe<Scalars['String']['input']>;
  streetNumberStart?: InputMaybe<Scalars['String']['input']>;
  timeSpans?: InputMaybe<Array<TimeSpanInput>>;
  type?: InputMaybe<RestrictionType>;
  /** The width, in meters, that the Curb Zone occupies from the curb to the roadway lane. */
  width?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateTemporaryDecreeInput = {
  /** Comments of decree */
  comments?: InputMaybe<Scalars['String']['input']>;
  /** Decree's own reference number as written in the document */
  decreeNumber?: InputMaybe<Scalars['String']['input']>;
  /** Image associated to the city */
  done?: InputMaybe<Scalars['Boolean']['input']>;
  extension?: InputMaybe<ExtensionInput>;
  /** Unique city ID */
  id: Scalars['ID']['input'];
  /** Name of decree */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Date of decree publication */
  publishedDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Title of decree */
  title?: InputMaybe<Scalars['String']['input']>;
  /** Type of decree, depends on category */
  type?: InputMaybe<TemporaryType>;
};

export type UpdateUrbanFeatureInput = {
  address?: InputMaybe<AddressInput>;
  cityId?: InputMaybe<Scalars['String']['input']>;
  editLine?: InputMaybe<Scalars['GeoJSONFeature']['input']>;
  geometry?: InputMaybe<Scalars['GeoJSONGeometry']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<UrbanFeatureType>;
  width?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateUserReportInput = {
  /** ID of the report */
  id: Scalars['ObjectID']['input'];
  /** has the report been treated */
  isDone: Scalars['Boolean']['input'];
};

export type UpdateWorkAreaInput = {
  /** Macaron custom data */
  cityId?: InputMaybe<Scalars['String']['input']>;
  done?: InputMaybe<Scalars['Boolean']['input']>;
  /** The spatial extent of this curb area. */
  geometry?: InputMaybe<Scalars['GeoJSONPolygon']['input']>;
  /** Unique Work Area ID, for Macaron usage only */
  id: Scalars['ID']['input'];
  /** The name of this curb area for reference. */
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UrbanFeature = {
  address: Address;
  cityId: Scalars['String']['output'];
  editLine?: Maybe<Scalars['GeoJSONFeature']['output']>;
  geoPoint2d: Array<Scalars['Float']['output']>;
  geometry: Scalars['GeoJSONGeometry']['output'];
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  type: UrbanFeatureType;
  width?: Maybe<Scalars['Float']['output']>;
};

export enum UrbanFeatureType {
  Crosswalk = 'crosswalk',
  SpeedBump = 'speedBump',
  TrafficLight = 'trafficLight'
}

export type UserReport = {
  /** Attached files relative URLs to storage */
  attachedFilesUrls?: Maybe<Array<Scalars['URL']['output']>>;
  /** City ID of the report */
  cityId: Scalars['ObjectID']['output'];
  /** Date of the creation of the report */
  createdAt: Scalars['DateTime']['output'];
  /** Polygons or points where the report is located */
  features: Scalars['GeoJSONFeatureCollection']['output'];
  id: Scalars['ID']['output'];
  /** Is the report treated */
  isDone: Scalars['Boolean']['output'];
  /** Notes to explain the report */
  note?: Maybe<Scalars['String']['output']>;
  /** Type of report: PUBLIC (anonymous) or ORGANIZATION (authenticated) */
  type: UserReportType;
};

export type UserReportPaginatedResult = {
  /** Available filters */
  filters?: Maybe<Scalars['JSON']['output']>;
  results: Array<UserReport>;
  /** Total number of items */
  totalCount: Scalars['Int']['output'];
  /** Total number of pages */
  totalPages: Scalars['Int']['output'];
};

/** Type of user report: PUBLIC (anonymous) or ORGANIZATION (authenticated) */
export enum UserReportType {
  Organization = 'ORGANIZATION',
  Public = 'PUBLIC'
}

export type Violation = {
  averageDurationInS?: Maybe<Scalars['Float']['output']>;
  date: Scalars['String']['output'];
  longstayVehicles: Scalars['Float']['output'];
  overstayVehicles: Scalars['Float']['output'];
};

export type WazeAlert = IWazeEvent & {
  alertSubtype?: Maybe<Scalars['String']['output']>;
  alertType: Scalars['String']['output'];
  alertUuid: Scalars['String']['output'];
  city?: Maybe<Scalars['String']['output']>;
  cityId: Scalars['String']['output'];
  cityName: Scalars['String']['output'];
  confidence?: Maybe<Scalars['Float']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  dataSource?: Maybe<Scalars['String']['output']>;
  eventType: WazeEventType;
  id: Scalars['ID']['output'];
  jamUuid?: Maybe<Scalars['String']['output']>;
  lastSeenAt: Scalars['DateTime']['output'];
  location: Scalars['GeoJSONPoint']['output'];
  magvar?: Maybe<Scalars['Float']['output']>;
  nComments?: Maybe<Scalars['Float']['output']>;
  nImages?: Maybe<Scalars['Float']['output']>;
  nThumbsUp?: Maybe<Scalars['Float']['output']>;
  pubDate: Scalars['DateTime']['output'];
  pubMillis: Scalars['Float']['output'];
  reliability?: Maybe<Scalars['Float']['output']>;
  reportBy?: Maybe<Scalars['String']['output']>;
  reportDescription?: Maybe<Scalars['String']['output']>;
  reportMood?: Maybe<Scalars['String']['output']>;
  reportRating?: Maybe<Scalars['Float']['output']>;
  roadType?: Maybe<Scalars['Float']['output']>;
  street?: Maybe<Scalars['String']['output']>;
};

/** The type of Waze event */
export enum WazeEventType {
  Alert = 'ALERT',
  Irregularity = 'IRREGULARITY',
  Jam = 'JAM'
}

export type WazeIrregularity = IWazeEvent & {
  alertsCount?: Maybe<Scalars['Float']['output']>;
  causeType?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  cityId: Scalars['String']['output'];
  cityName: Scalars['String']['output'];
  country?: Maybe<Scalars['String']['output']>;
  delaySeconds?: Maybe<Scalars['Float']['output']>;
  detectionDate?: Maybe<Scalars['String']['output']>;
  detectionDateMillis: Scalars['Float']['output'];
  detectionDateTime: Scalars['DateTime']['output'];
  drivers?: Maybe<Scalars['Float']['output']>;
  endNode?: Maybe<Scalars['String']['output']>;
  eventType: WazeEventType;
  id: Scalars['ID']['output'];
  irregularityId: Scalars['Float']['output'];
  irregularityLine?: Maybe<Scalars['GeoJSONLineString']['output']>;
  irregularityType?: Maybe<Scalars['String']['output']>;
  jamLevel?: Maybe<Scalars['Float']['output']>;
  lastSeenAt: Scalars['DateTime']['output'];
  length?: Maybe<Scalars['Float']['output']>;
  nComments?: Maybe<Scalars['Float']['output']>;
  nImages?: Maybe<Scalars['Float']['output']>;
  nThumbsUp?: Maybe<Scalars['Float']['output']>;
  regularSpeed?: Maybe<Scalars['Float']['output']>;
  seconds?: Maybe<Scalars['Float']['output']>;
  severity?: Maybe<Scalars['Float']['output']>;
  speed?: Maybe<Scalars['Float']['output']>;
  startNode?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  trend?: Maybe<Scalars['Float']['output']>;
  updateDate?: Maybe<Scalars['String']['output']>;
  updateDateMillis: Scalars['Float']['output'];
  updateDateTime: Scalars['DateTime']['output'];
};

export type WazeJam = IWazeEvent & {
  blockingAlertUuid?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  cityId: Scalars['String']['output'];
  cityName: Scalars['String']['output'];
  country?: Maybe<Scalars['String']['output']>;
  dataSource?: Maybe<Scalars['String']['output']>;
  delay?: Maybe<Scalars['Float']['output']>;
  endNode?: Maybe<Scalars['String']['output']>;
  eventType: WazeEventType;
  id: Scalars['ID']['output'];
  jamId: Scalars['Float']['output'];
  jamLine: Scalars['GeoJSONLineString']['output'];
  jamTurnLine?: Maybe<Scalars['GeoJSONLineString']['output']>;
  jamType?: Maybe<Scalars['String']['output']>;
  jamUuid: Scalars['Float']['output'];
  lastSeenAt: Scalars['DateTime']['output'];
  length?: Maybe<Scalars['Float']['output']>;
  level?: Maybe<Scalars['Float']['output']>;
  pubDate: Scalars['DateTime']['output'];
  pubMillis: Scalars['Float']['output'];
  roadType?: Maybe<Scalars['Float']['output']>;
  speed?: Maybe<Scalars['Float']['output']>;
  speedKMH?: Maybe<Scalars['Float']['output']>;
  startNode?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  turnType?: Maybe<Scalars['String']['output']>;
};

export type WorkArea = {
  /** Macaron custom data */
  cityId: Scalars['String']['output'];
  /** The name of this Work Area for reference. */
  done: Scalars['Boolean']['output'];
  /** The spatial extent of this Work Area. */
  geometry: Scalars['GeoJSONPolygon']['output'];
  id: Scalars['ID']['output'];
  /** The name of this Work Area for reference. */
  name: Scalars['String']['output'];
};

export type GetCityQueryVariables = Exact<{
  cityId: Scalars['String']['input'];
}>;


export type GetCityQuery = { city: { id: string, name: string, zipCode?: string | null, position?: Array<number> | null, image?: string | null, boundaries?: any | null, details?: { departement?: string | null, surfaceArea?: number | null, state?: string | null, country?: string | null, countryCode?: string | null, osmId?: number | null, dataProvider?: { name?: string | null, deviceIds?: Array<string> | null } | null, currency?: { code: string, symbol?: string | null } | null, timezone?: { iana: string } | null } | null } };

export type PaginatedCitiesQueryVariables = Exact<{
  filter?: InputMaybe<Array<FilterInput> | FilterInput>;
  pageIndex: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  sortOrder?: InputMaybe<SortOrder>;
  sortField?: InputMaybe<Scalars['String']['input']>;
}>;


export type PaginatedCitiesQuery = { paginatedCities: { totalPages: number, results: Array<{ id: string, name: string, zipCode?: string | null, position?: Array<number> | null, image?: string | null, boundaries?: any | null, details?: { departement?: string | null, surfaceArea?: number | null, state?: string | null, country?: string | null, countryCode?: string | null, osmId?: number | null, dataProvider?: { name?: string | null, deviceIds?: Array<string> | null } | null, options?: { live?: boolean | null, offstreet?: boolean | null, payment?: boolean | null, curbZones?: boolean | null, mapIntegration?: boolean | null, wazeFeedUrl?: string | null, mobileMap?: boolean | null, decreeAnalysis?: { enabled?: boolean | null, emailFrom?: string | null, emailTo?: string | null } | null } | null, currency?: { code: string, symbol?: string | null } | null, timezone?: { iana: string } | null } | null }> } };

export type GetSimplifiedCitiesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSimplifiedCitiesQuery = { cities: Array<{ id: string, name: string, position?: Array<number> | null }> };

export type AddCityMutationVariables = Exact<{
  city: CreateCityInput;
}>;


export type AddCityMutation = { createCity: { id: string } };

export type UpdateCityMutationVariables = Exact<{
  city: UpdateCityInput;
}>;


export type UpdateCityMutation = { updateCity: { id: string } };

export type RemoveCityMutationVariables = Exact<{
  cityId: Scalars['String']['input'];
}>;


export type RemoveCityMutation = { removeCity: { id: string } };

export type OffStreetParkingsQueryVariables = Exact<{
  cityId: Scalars['String']['input'];
  boundingBox?: InputMaybe<Array<Array<Scalars['Float']['input']> | Scalars['Float']['input']> | Array<Scalars['Float']['input']> | Scalars['Float']['input']>;
}>;


export type OffStreetParkingsQuery = { offStreetParkings: Array<{ id: string, name: string, address: string, location: any, totalPlaces?: number | null }> };

export type OffStreetParkingQueryVariables = Exact<{
  cityId: Scalars['String']['input'];
  id: Scalars['String']['input'];
}>;


export type OffStreetParkingQuery = { offStreetParking: { id: string, name: string, address: string, externalId?: string | null, cityId: string, location: any, totalPlaces?: number | null, pricePerHour?: number | null, otherAdresses?: Array<string> | null, maxHeight?: number | null, levels?: number | null, layout?: ParkingLayout | null, options?: { evChargers?: number | null, toilets?: boolean | null, disabledAccess?: boolean | null, disabledPlaces?: number | null, motorcycleAccess?: boolean | null, motorcyclePlaces?: number | null, bicycleAccess?: boolean | null, bicyclePlaces?: number | null } | null, openingHours?: Array<{ startDate?: any | null, endDate?: any | null, daysOfWeek?: Array<DaysOfWeek> | null, daysOfMonth?: Array<number> | null, months?: Array<number> | null, timeOfDayStart?: string | null, timeOfDayEnd?: string | null, designatedPeriod?: string | null, designatedPeriodExcept?: boolean | null }> | null } };

export type CreateOffStreetParkingMutationVariables = Exact<{
  input: CreateOffStreetParkingInput;
}>;


export type CreateOffStreetParkingMutation = { createOffStreetParking: { id: string, name: string, address: string, externalId?: string | null, cityId: string, location: any, totalPlaces?: number | null, pricePerHour?: number | null, otherAdresses?: Array<string> | null, maxHeight?: number | null, levels?: number | null, layout?: ParkingLayout | null, options?: { evChargers?: number | null, toilets?: boolean | null, disabledAccess?: boolean | null, disabledPlaces?: number | null, motorcycleAccess?: boolean | null, motorcyclePlaces?: number | null, bicycleAccess?: boolean | null, bicyclePlaces?: number | null } | null, openingHours?: Array<{ startDate?: any | null, endDate?: any | null, daysOfWeek?: Array<DaysOfWeek> | null, daysOfMonth?: Array<number> | null, months?: Array<number> | null, timeOfDayStart?: string | null, timeOfDayEnd?: string | null, designatedPeriod?: string | null, designatedPeriodExcept?: boolean | null }> | null } };

export type UpdateOffStreetParkingMutationVariables = Exact<{
  input: UpdateOffStreetParkingInput;
}>;


export type UpdateOffStreetParkingMutation = { updateOffStreetParking: { id: string, name: string, address: string, externalId?: string | null, cityId: string, location: any, totalPlaces?: number | null, pricePerHour?: number | null, otherAdresses?: Array<string> | null, maxHeight?: number | null, levels?: number | null, layout?: ParkingLayout | null, options?: { evChargers?: number | null, toilets?: boolean | null, disabledAccess?: boolean | null, disabledPlaces?: number | null, motorcycleAccess?: boolean | null, motorcyclePlaces?: number | null, bicycleAccess?: boolean | null, bicyclePlaces?: number | null } | null, openingHours?: Array<{ startDate?: any | null, endDate?: any | null, daysOfWeek?: Array<DaysOfWeek> | null, daysOfMonth?: Array<number> | null, months?: Array<number> | null, timeOfDayStart?: string | null, timeOfDayEnd?: string | null, designatedPeriod?: string | null, designatedPeriodExcept?: boolean | null }> | null } };

export type DeleteOffStreetParkingMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeleteOffStreetParkingMutation = { deleteOffStreetParking: { id: string } };

export type PublishCitiesTilesMutationVariables = Exact<{ [key: string]: never; }>;


export type PublishCitiesTilesMutation = { publishCitiesTiles: { citiesBoundariesTilesetId: string, citiesCurbZoneParkingTilesetId: string } };

export type CurbAreasQueryVariables = Exact<{
  cityId: Scalars['String']['input'];
}>;


export type CurbAreasQuery = { curbAreas: Array<{ id: string, name?: string | null, note?: string | null, geometry: any, publishedDate: any }> };

export type CreateCurbAreaMutationVariables = Exact<{
  input: CreateCurbAreaInput;
}>;


export type CreateCurbAreaMutation = { createCurbArea: { id: string, name?: string | null, note?: string | null, geometry: any, publishedDate: any, lastUpdatedDate: any } };

export type UpdateCurbAreaMutationVariables = Exact<{
  input: UpdateCurbAreaInput;
}>;


export type UpdateCurbAreaMutation = { updateCurbArea: { id: string, name?: string | null, note?: string | null, geometry: any, publishedDate: any, lastUpdatedDate: any } };

export type DeleteCurbAreaMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeleteCurbAreaMutation = { deleteCurbArea: { id: string } };

export type CurbZonesQueryVariables = Exact<{
  filterInput: SearchCurbZoneInput;
}>;


export type CurbZonesQuery = { curbZones: Array<{ calculatedArea: number, calculatedSpaces: number, cityId: string, curbPolicyIds: Array<any>, editLine: any, externalId?: string | null, geoPoint2d: Array<number>, geometry: any, id: string, curbZoneId: any, length?: number | null, name?: string | null, note?: string | null, parkingAngle?: ParkingAngle | null, publishedDate: any, startDate: any, streetName?: string | null, streetNumberStart?: string | null, streetNumberEnd?: string | null, width?: number | null, decreeIds?: Array<string> | null, curbPolicies: Array<{ id: string, curbPolicyId?: any | null, name: string, cityId: string, publishedDate: any, priority: number, rules: Array<{ maxStay?: number | null, maxStayUnit?: UnitOfTime | null, rate?: Array<{ rate: number, rateUnit: UnitOfTime }> | null }>, timeSpans?: Array<{ daysOfWeek?: Array<DaysOfWeek> | null, timeOfDayStart?: string | null, timeOfDayEnd?: string | null }> | null, color?: { dashed?: boolean | null, fillColor?: Array<number> | null, lineColor?: Array<number> | null } | null }>, decrees?: Array<{ name: string, id: string }> | null }> };

export type CreateCurbZoneMutationVariables = Exact<{
  curbZoneInput: CreateCurbZoneInput;
}>;


export type CreateCurbZoneMutation = { createCurbZone: { calculatedArea: number, calculatedSpaces: number, cityId: string, curbPolicyIds: Array<any>, editLine: any, externalId?: string | null, geoPoint2d: Array<number>, geometry: any, id: string, curbZoneId: any, length?: number | null, name?: string | null, note?: string | null, parkingAngle?: ParkingAngle | null, publishedDate: any, startDate: any, streetName?: string | null, streetNumberEnd?: string | null, streetNumberStart?: string | null, width?: number | null, decreeIds?: Array<string> | null, curbPolicies: Array<{ id: string, curbPolicyId?: any | null, name: string, priority: number, cityId: string, publishedDate: any, rules: Array<{ maxStay?: number | null, maxStayUnit?: UnitOfTime | null, activity: string, rate?: Array<{ rate: number, rateUnit: UnitOfTime }> | null }>, timeSpans?: Array<{ daysOfWeek?: Array<DaysOfWeek> | null, timeOfDayStart?: string | null, timeOfDayEnd?: string | null }> | null, color?: { dashed?: boolean | null, fillColor?: Array<number> | null, lineColor?: Array<number> | null } | null }>, decrees?: Array<{ name: string, id: string }> | null } };

export type UpdateCurbZoneMutationVariables = Exact<{
  curbZoneInput: UpdateCurbZoneInput;
}>;


export type UpdateCurbZoneMutation = { updateCurbZone: { calculatedArea: number, calculatedSpaces: number, cityId: string, curbPolicyIds: Array<any>, editLine: any, externalId?: string | null, geoPoint2d: Array<number>, geometry: any, id: string, curbZoneId: any, length?: number | null, name?: string | null, note?: string | null, parkingAngle?: ParkingAngle | null, publishedDate: any, startDate: any, streetName?: string | null, streetNumberEnd?: string | null, streetNumberStart?: string | null, width?: number | null, decreeIds?: Array<string> | null, curbPolicies: Array<{ id: string, curbPolicyId?: any | null, name: string, priority: number, cityId: string, publishedDate: any, rules: Array<{ maxStay?: number | null, maxStayUnit?: UnitOfTime | null, activity: string, rate?: Array<{ rate: number, rateUnit: UnitOfTime }> | null }>, timeSpans?: Array<{ daysOfWeek?: Array<DaysOfWeek> | null, timeOfDayStart?: string | null, timeOfDayEnd?: string | null }> | null, color?: { dashed?: boolean | null, fillColor?: Array<number> | null, lineColor?: Array<number> | null } | null }>, decrees?: Array<{ name: string, id: string }> | null } };

export type BulkUpdateCurbZoneMutationVariables = Exact<{
  bulkUpdateCurbZoneInputs: Array<UpdateCurbZoneInput> | UpdateCurbZoneInput;
}>;


export type BulkUpdateCurbZoneMutation = { bulkUpdateCurbZones: Array<{ calculatedArea: number, calculatedSpaces: number, cityId: string, curbPolicyIds: Array<any>, editLine: any, externalId?: string | null, geoPoint2d: Array<number>, geometry: any, id: string, curbZoneId: any, length?: number | null, name?: string | null, note?: string | null, parkingAngle?: ParkingAngle | null, publishedDate: any, startDate: any, streetName?: string | null, streetNumberEnd?: string | null, streetNumberStart?: string | null, width?: number | null, decreeIds?: Array<string> | null, curbPolicies: Array<{ id: string, curbPolicyId?: any | null, name: string, priority: number, cityId: string, publishedDate: any, rules: Array<{ maxStay?: number | null, maxStayUnit?: UnitOfTime | null, activity: string, rate?: Array<{ rate: number, rateUnit: UnitOfTime }> | null }>, timeSpans?: Array<{ daysOfWeek?: Array<DaysOfWeek> | null, timeOfDayStart?: string | null, timeOfDayEnd?: string | null }> | null, color?: { dashed?: boolean | null, fillColor?: Array<number> | null, lineColor?: Array<number> | null } | null }>, decrees?: Array<{ name: string, id: string }> | null }> };

export type DeleteCurbZoneMutationVariables = Exact<{
  curbZoneId: Scalars['String']['input'];
}>;


export type DeleteCurbZoneMutation = { deleteCurbZone: { id: string } };

export type BulkDeleteCurbZonesMutationVariables = Exact<{
  curbZoneIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type BulkDeleteCurbZonesMutation = { bulkDeleteCurbZones: Array<{ id: string }> };

export type TotalCalculatedSpacesQueryVariables = Exact<{
  filterInput: SearchCalculatedSpacesInput;
}>;


export type TotalCalculatedSpacesQuery = { getTotalCalculatedSpaces: number };

export type CurbZoneStatsQueryVariables = Exact<{
  filterInput: SearchCurbZoneInput;
}>;


export type CurbZoneStatsQuery = { curbZones: Array<{ streetName?: string | null, calculatedArea: number, calculatedSpaces: number, curbPolicies: Array<{ curbPolicyId?: any | null, name: string, color?: { lineColor?: Array<number> | null } | null }> }> };

export type CurbZonesByParkingLotQueryVariables = Exact<{
  filterInput: SearchCurbZoneInput;
}>;


export type CurbZonesByParkingLotQuery = { curbZones: Array<{ id: string, curbZoneId: any }> };

export type CurbZonesShortenQueryVariables = Exact<{
  filterInput: SearchCurbZoneInput;
}>;


export type CurbZonesShortenQuery = { curbZones: Array<{ editLine: any, geoPoint2d: Array<number>, geometry: any, id: string, curbZoneId: any, width?: number | null, curbPolicies: Array<{ id: string, name: string, color?: { dashed?: boolean | null, fillColor?: Array<number> | null, lineColor?: Array<number> | null } | null }> }> };

export type DecreesPaginatedQueryVariables = Exact<{
  cityId: Scalars['String']['input'];
  pageIndex: Scalars['Int']['input'];
  sortOrder?: InputMaybe<SortOrder>;
  sortField?: InputMaybe<Scalars['String']['input']>;
  pageSize: Scalars['Int']['input'];
  filter?: InputMaybe<Array<FilterInput> | FilterInput>;
}>;


export type DecreesPaginatedQuery = { decreesPaginated: { totalPages: number, totalCount: number, results: Array<
      | { __typename: 'Decree', id: string, name: string, createdAt: any, cityId: string, done: boolean, publicUrl?: string | null, analyzed?: boolean | null, category: DecreeCategory, comments?: string | null, publishedDate?: any | null, title?: string | null, decreeNumber?: string | null }
      | { __typename: 'PermanentDecree', id: string, name: string, createdAt: any, cityId: string, done: boolean, publicUrl?: string | null, analyzed?: boolean | null, category: DecreeCategory, comments?: string | null, publishedDate?: any | null, title?: string | null, decreeNumber?: string | null }
      | { __typename: 'PermitDecree', startDate: any, endDate: any, id: string, name: string, createdAt: any, cityId: string, done: boolean, publicUrl?: string | null, analyzed?: boolean | null, category: DecreeCategory, comments?: string | null, publishedDate?: any | null, title?: string | null, decreeNumber?: string | null, permitType?: PermitType | null }
      | { __typename: 'TemporaryDecree', restrictionsCount?: number | null, id: string, name: string, createdAt: any, cityId: string, done: boolean, publicUrl?: string | null, analyzed?: boolean | null, category: DecreeCategory, comments?: string | null, publishedDate?: any | null, title?: string | null, decreeNumber?: string | null, temporaryType?: TemporaryType | null, extension?: { originalDecreeReference?: string | null, originalDecreeNumber?: string | null } | null }
    > } };

export type TemporaryDecreesPaginatedQueryVariables = Exact<{
  cityId: Scalars['String']['input'];
  pageIndex: Scalars['Int']['input'];
  sortOrder?: InputMaybe<SortOrder>;
  sortField?: InputMaybe<Scalars['String']['input']>;
  pageSize: Scalars['Int']['input'];
  filter?: InputMaybe<Array<FilterInput> | FilterInput>;
}>;


export type TemporaryDecreesPaginatedQuery = { temporaryDecreesPaginated: { totalPages: number, totalCount: number, results: Array<{ __typename: 'TemporaryDecree', id: string, name: string, createdAt: any, cityId: string, done: boolean, publicUrl?: string | null, analyzed?: boolean | null, category: DecreeCategory, comments?: string | null, publishedDate?: any | null, title?: string | null, decreeNumber?: string | null, restrictionsCount?: number | null, temporaryType?: TemporaryType | null, extension?: { originalDecreeReference?: string | null, originalDecreeNumber?: string | null } | null }> } };

export type UpdateDecreeCategoryMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateDecreeCategoryInput;
}>;


export type UpdateDecreeCategoryMutation = { updateDecreeCategory: { id: string, category: DecreeCategory } };

export type RemoveDecreeMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type RemoveDecreeMutation = { removeDecree: { id: string } };

export type UpdatePermanentDecreeMutationVariables = Exact<{
  updateDecreeInput: UpdatePermanentDecreeInput;
}>;


export type UpdatePermanentDecreeMutation = { updatePermanentDecree: { id: string } };

export type UpdateTemporaryDecreeMutationVariables = Exact<{
  updateDecreeInput: UpdateTemporaryDecreeInput;
}>;


export type UpdateTemporaryDecreeMutation = { updateTemporaryDecree: { id: string } };

export type UpdatePermitDecreeMutationVariables = Exact<{
  updateDecreeInput: UpdatePermitDecreeInput;
}>;


export type UpdatePermitDecreeMutation = { updatePermitDecree: { id: string } };

export type TemporaryDecreeQueryVariables = Exact<{
  id: Scalars['String']['input'];
  cityId: Scalars['String']['input'];
}>;


export type TemporaryDecreeQuery = { temporaryDecree: { id: string, restrictions?: Array<{ id: string, decreeIds?: Array<string> | null, streetName?: string | null, streetNumberStart?: string | null, streetNumberEnd?: string | null, geometry: any, curbZoneId?: any | null, description?: string | null, editLine: any, geoPoint2d: Array<number>, type?: RestrictionType | null, cityId: string, width?: number | null, calculatedSpaces?: number | null, length?: number | null, timeSpans?: Array<{ startDate?: any | null, endDate?: any | null, daysOfWeek?: Array<DaysOfWeek> | null, daysOfMonth?: Array<number> | null, months?: Array<number> | null, timeOfDayStart?: string | null, timeOfDayEnd?: string | null }> | null }> | null } };

export type UpdateDecreeMutationVariables = Exact<{
  updateDecreeInput: UpdateDecreeInput;
}>;


export type UpdateDecreeMutation = { updateDecree: { id: string } };

export type ParkingLotsQueryVariables = Exact<{
  cityId: Scalars['String']['input'];
}>;


export type ParkingLotsQuery = { parkingLots: Array<{ id: string, geometry: any, position: Array<number>, name?: string | null, address?: string | null, note?: string | null, cityId: string, curbZoneIds: Array<any> }> };

export type CreateParkingLotMutationVariables = Exact<{
  input: CreateParkingLotInput;
}>;


export type CreateParkingLotMutation = { createParkingLot: { id: string, geometry: any, position: Array<number>, name?: string | null, address?: string | null, note?: string | null, cityId: string, curbZoneIds: Array<any> } };

export type UpdateParkingLotMutationVariables = Exact<{
  input: UpdateParkingLotInput;
}>;


export type UpdateParkingLotMutation = { updateParkingLot: { id: string, geometry: any, position: Array<number>, name?: string | null, address?: string | null, note?: string | null, cityId: string, curbZoneIds: Array<any> } };

export type DeleteParkingLotMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeleteParkingLotMutation = { deleteParkingLot: { id: string } };

export type GetParkingMetersQueryVariables = Exact<{
  cityId: Scalars['String']['input'];
}>;


export type GetParkingMetersQuery = { getParkingMeters: Array<{ id: string, name: string, status?: string | null, externalId?: string | null, location: any, cityId: string, batteryLevel?: number | null, lastMaintenanceDate?: any | null, operator: string, brand: string, model: string, zone?: string | null, address: { city: string, country: string, postalCode: string, province?: string | null, streetName: string, streetNumber: string }, options?: { cash?: boolean | null, creditCard?: boolean | null, contactless?: boolean | null } | null }> };

export type CreateParkingMeterMutationVariables = Exact<{
  createParkingMeterInput: CreateParkingMeterInput;
}>;


export type CreateParkingMeterMutation = { createParkingMeter: { id: string, name: string, status?: string | null, externalId?: string | null, location: any, cityId: string, batteryLevel?: number | null, lastMaintenanceDate?: any | null, operator: string, brand: string, model: string, zone?: string | null, address: { city: string, country: string, postalCode: string, province?: string | null, streetName: string, streetNumber: string }, options?: { cash?: boolean | null, creditCard?: boolean | null, contactless?: boolean | null } | null } };

export type UpdateParkingMeterMutationVariables = Exact<{
  updateParkingMeterInput: UpdateParkingMeterInput;
}>;


export type UpdateParkingMeterMutation = { updateParkingMeter: { id: string, name: string, status?: string | null, externalId?: string | null, location: any, cityId: string, batteryLevel?: number | null, lastMaintenanceDate?: any | null, operator: string, brand: string, model: string, zone?: string | null, address: { city: string, country: string, postalCode: string, province?: string | null, streetName: string, streetNumber: string }, options?: { cash?: boolean | null, creditCard?: boolean | null, contactless?: boolean | null } | null } };

export type RemoveParkingMeterMutationVariables = Exact<{
  meterId: Scalars['String']['input'];
}>;


export type RemoveParkingMeterMutation = { removeParkingMeter: { id: string } };

export type PermitDecreesQueryVariables = Exact<{
  permitDecreesInput: GetPermitDecreesInput;
}>;


export type PermitDecreesQuery = { permitDecrees: Array<{ id: string, name: string, done: boolean, locations: Array<{ id: string, position: any, address: { streetNumber: string, streetName: string, city: string, postalCode: string, province?: string | null, country: string } }> }> };

export type AddPermitDecreeLocationMutationVariables = Exact<{
  decreeId: Scalars['String']['input'];
  location: PermitDecreeLocationInput;
}>;


export type AddPermitDecreeLocationMutation = { addPermitDecreeLocation: { id: string } };

export type UpdatePermitDecreeLocationMutationVariables = Exact<{
  decreeId: Scalars['String']['input'];
  location: PermitDecreeLocationInput;
  locationId: Scalars['String']['input'];
}>;


export type UpdatePermitDecreeLocationMutation = { updatePermitDecreeLocation: { id: string } };

export type RemovePermitDecreeLocationMutationVariables = Exact<{
  decreeId: Scalars['String']['input'];
  locationId: Scalars['String']['input'];
}>;


export type RemovePermitDecreeLocationMutation = { removePermitDecreeLocation: { id: string, locations: Array<{ id: string, position: any, address: { streetNumber: string, streetName: string, city: string, postalCode: string, province?: string | null, country: string } }> } };

export type PoliciesByCityIdQueryVariables = Exact<{
  cityId: Scalars['String']['input'];
}>;


export type PoliciesByCityIdQuery = { policiesByCityId: Array<{ id: string, curbPolicyId?: any | null, cityId: string, name: string, priority: number, category?: PolicyCategory | null, publishedDate: any, rules: Array<{ activity: string, maxStay?: number | null, maxStayUnit?: UnitOfTime | null, noReturn?: number | null, noReturnUnit?: UnitOfTime | null, userClasses?: Array<string> | null, rate?: Array<{ rate: number, endDuration?: number | null, incrementAmount?: number | null, incrementDuration?: number | null, rateUnit: UnitOfTime, startDuration?: number | null, rateUnitPeriod?: RateUnitPeriod | null }> | null }>, timeSpans?: Array<{ startDate?: any | null, endDate?: any | null, daysOfWeek?: Array<DaysOfWeek> | null, daysOfMonth?: Array<number> | null, months?: Array<number> | null, timeOfDayStart?: string | null, timeOfDayEnd?: string | null, designatedPeriod?: string | null, designatedPeriodExcept?: boolean | null }> | null, color?: { dashed?: boolean | null, fillColor?: Array<number> | null, lineColor?: Array<number> | null, iconColor?: IconColor | null } | null }> };

export type CreatePolicyMutationVariables = Exact<{
  createPolicyInput: CreatePolicyInput;
}>;


export type CreatePolicyMutation = { createPolicy: { id: string, curbPolicyId?: any | null } };

export type UpdatePolicyMutationVariables = Exact<{
  updatePolicyInput: UpdatePolicyInput;
}>;


export type UpdatePolicyMutation = { updatePolicy: { id: string } };

export type DeletePolicyMutationVariables = Exact<{
  policyId: Scalars['String']['input'];
}>;


export type DeletePolicyMutation = { deletePolicy: { id: string } };

export type CurbZonesAndRestrictionsQueryVariables = Exact<{
  filterInputRestriction: SearchRestrictionInput;
  filterInputCurbZone: SearchCurbZoneInput;
}>;


export type CurbZonesAndRestrictionsQuery = { restrictionsByBounding: Array<{ id: string, curbZoneId?: any | null, geoPoint2d: Array<number>, editLine: any, description?: string | null, decreeIds?: Array<string> | null, geometry: any, streetName?: string | null, streetNumberStart?: string | null, streetNumberEnd?: string | null, cityId: string, type?: RestrictionType | null, width?: number | null, calculatedSpaces?: number | null, length?: number | null, timeSpans?: Array<{ startDate?: any | null, endDate?: any | null, daysOfWeek?: Array<DaysOfWeek> | null, daysOfMonth?: Array<number> | null, months?: Array<number> | null, timeOfDayStart?: string | null, timeOfDayEnd?: string | null }> | null, decrees?: Array<{ name: string, id: string }> | null }>, curbZones: Array<{ calculatedArea: number, calculatedSpaces: number, cityId: string, editLine: any, externalId?: string | null, geoPoint2d: Array<number>, geometry: any, id: string, curbZoneId: any, length?: number | null, name?: string | null, note?: string | null, parkingAngle?: ParkingAngle | null, publishedDate: any, startDate: any, streetName?: string | null, streetNumberStart?: string | null, streetNumberEnd?: string | null, width?: number | null, curbPolicies: Array<{ id: string, curbPolicyId?: any | null, name: string, rules: Array<{ rate?: Array<{ rate: number, rateUnit: UnitOfTime }> | null }>, color?: { dashed?: boolean | null, fillColor?: Array<number> | null, lineColor?: Array<number> | null } | null }> }> };

export type CreateRestrictionMutationVariables = Exact<{
  input: CreateRestrictionInput;
}>;


export type CreateRestrictionMutation = { createRestriction: { id: string } };

export type UpdateRestrictionMutationVariables = Exact<{
  input: UpdateRestrictionInput;
}>;


export type UpdateRestrictionMutation = { updateRestriction: { id: string } };

export type BulkUpdateRestrictionsMutationVariables = Exact<{
  input: BulkUpdateRestrictionsInput;
}>;


export type BulkUpdateRestrictionsMutation = { bulkUpdateRestrictions: Array<{ id: string }> };

export type DeleteRestrictionMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeleteRestrictionMutation = { deleteRestriction: { id: string, curbZoneId?: any | null } };

export type BulkDeleteRestrictionsMutationVariables = Exact<{
  ids: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type BulkDeleteRestrictionsMutation = { bulkDeleteRestrictions: boolean };

export type UrbanFeaturesByBoundingQueryVariables = Exact<{
  boundingbox?: InputMaybe<Array<Array<Scalars['Float']['input']> | Scalars['Float']['input']> | Array<Scalars['Float']['input']> | Scalars['Float']['input']>;
  cityId: Scalars['String']['input'];
  types?: InputMaybe<Array<UrbanFeatureType> | UrbanFeatureType>;
}>;


export type UrbanFeaturesByBoundingQuery = { urbanFeaturesByBounding: Array<{ name?: string | null, geometry: any, type: UrbanFeatureType, cityId: string, id: string, editLine?: any | null, width?: number | null, address: { city: string, country: string, postalCode: string, province?: string | null, streetName: string, streetNumber: string } }> };

export type AddUrbanFeatureToCityMutationVariables = Exact<{
  createUrbanFeaturesInput: CreateUrbanFeaturesInput;
}>;


export type AddUrbanFeatureToCityMutation = { addUrbanFeatureToCity: { name?: string | null, geometry: any, type: UrbanFeatureType, cityId: string, id: string, editLine?: any | null, width?: number | null, address: { city: string, country: string, postalCode: string, province?: string | null, streetName: string, streetNumber: string } } };

export type UpdateUrbanFeatureMutationVariables = Exact<{
  updateUrbanFeatureInput: UpdateUrbanFeatureInput;
}>;


export type UpdateUrbanFeatureMutation = { updateUrbanFeature: { name?: string | null, geometry: any, type: UrbanFeatureType, cityId: string, id: string, editLine?: any | null, width?: number | null, address: { city: string, country: string, postalCode: string, province?: string | null, streetName: string, streetNumber: string } } };

export type RemoveUrbanFeatureMutationVariables = Exact<{
  urbanFeatureId: Scalars['String']['input'];
}>;


export type RemoveUrbanFeatureMutation = { removeUrbanFeature: { id: string } };

export type GetUserReportByCityIdQueryVariables = Exact<{
  cityId: Scalars['String']['input'];
  pageIndex: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  filter?: InputMaybe<Array<FilterInput> | FilterInput>;
  sortOrder?: InputMaybe<SortOrder>;
  sortField?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetUserReportByCityIdQuery = { getUserReportsByCityId: { totalPages: number, results: Array<{ id: string, cityId: any, attachedFilesUrls?: Array<any> | null, features: any, note?: string | null, isDone: boolean }> } };

export type UpdateUserReportMutationVariables = Exact<{
  reportInput: UpdateUserReportInput;
}>;


export type UpdateUserReportMutation = { updateUserReport: { id: string, isDone: boolean } };

export type FindWorkAreasQueryVariables = Exact<{
  cityId: Scalars['String']['input'];
}>;


export type FindWorkAreasQuery = { workAreas: Array<{ id: string, name: string, done: boolean, geometry: any, cityId: string }> };

export type CreateWorkAreaMutationVariables = Exact<{
  workAreaInput: CreateWorkAreaInput;
}>;


export type CreateWorkAreaMutation = { createWorkArea: { id: string, name: string, done: boolean, geometry: any, cityId: string } };

export type UpdateWorkAreaMutationVariables = Exact<{
  workAreaInput: UpdateWorkAreaInput;
}>;


export type UpdateWorkAreaMutation = { updateWorkArea: { id: string, name: string, done: boolean, geometry: any, cityId: string } };

export type DeleteWorkAreaMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeleteWorkAreaMutation = { deleteWorkArea: { id: string } };


export const GetCityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCity"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cityId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"city"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cityId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"zipCode"}},{"kind":"Field","name":{"kind":"Name","value":"details"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"departement"}},{"kind":"Field","name":{"kind":"Name","value":"surfaceArea"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"osmId"}},{"kind":"Field","name":{"kind":"Name","value":"dataProvider"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"deviceIds"}}]}},{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"symbol"}}]}},{"kind":"Field","name":{"kind":"Name","value":"timezone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"iana"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"image"}},{"kind":"Field","name":{"kind":"Name","value":"boundaries"}}]}}]}}]} as unknown as DocumentNode<GetCityQuery, GetCityQueryVariables>;
export const PaginatedCitiesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PaginatedCities"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pageIndex"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pageSize"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sortOrder"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"SortOrder"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sortField"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paginatedCities"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"pageIndex"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pageIndex"}}},{"kind":"Argument","name":{"kind":"Name","value":"pageSize"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pageSize"}}},{"kind":"Argument","name":{"kind":"Name","value":"sortOrder"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sortOrder"}}},{"kind":"Argument","name":{"kind":"Name","value":"sortField"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sortField"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"results"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"zipCode"}},{"kind":"Field","name":{"kind":"Name","value":"details"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"departement"}},{"kind":"Field","name":{"kind":"Name","value":"surfaceArea"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"osmId"}},{"kind":"Field","name":{"kind":"Name","value":"dataProvider"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"deviceIds"}}]}},{"kind":"Field","name":{"kind":"Name","value":"options"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"live"}},{"kind":"Field","name":{"kind":"Name","value":"offstreet"}},{"kind":"Field","name":{"kind":"Name","value":"payment"}},{"kind":"Field","name":{"kind":"Name","value":"curbZones"}},{"kind":"Field","name":{"kind":"Name","value":"mapIntegration"}},{"kind":"Field","name":{"kind":"Name","value":"decreeAnalysis"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enabled"}},{"kind":"Field","name":{"kind":"Name","value":"emailFrom"}},{"kind":"Field","name":{"kind":"Name","value":"emailTo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"wazeFeedUrl"}},{"kind":"Field","name":{"kind":"Name","value":"mobileMap"}}]}},{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"symbol"}}]}},{"kind":"Field","name":{"kind":"Name","value":"timezone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"iana"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"image"}},{"kind":"Field","name":{"kind":"Name","value":"boundaries"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalPages"}}]}}]}}]} as unknown as DocumentNode<PaginatedCitiesQuery, PaginatedCitiesQueryVariables>;
export const GetSimplifiedCitiesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetSimplifiedCities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"position"}}]}}]}}]} as unknown as DocumentNode<GetSimplifiedCitiesQuery, GetSimplifiedCitiesQueryVariables>;
export const AddCityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"addCity"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"city"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateCityInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createCity"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"createCityInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"city"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<AddCityMutation, AddCityMutationVariables>;
export const UpdateCityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateCity"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"city"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateCityInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateCity"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"updateCityInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"city"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdateCityMutation, UpdateCityMutationVariables>;
export const RemoveCityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"removeCity"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cityId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeCity"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cityId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<RemoveCityMutation, RemoveCityMutationVariables>;
export const OffStreetParkingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"OffStreetParkings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cityId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"boundingBox"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"offStreetParkings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"cityId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cityId"}}},{"kind":"Argument","name":{"kind":"Name","value":"boundingBox"},"value":{"kind":"Variable","name":{"kind":"Name","value":"boundingBox"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"location"}},{"kind":"Field","name":{"kind":"Name","value":"totalPlaces"}}]}}]}}]} as unknown as DocumentNode<OffStreetParkingsQuery, OffStreetParkingsQueryVariables>;
export const OffStreetParkingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"OffStreetParking"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cityId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"offStreetParking"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"cityId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cityId"}}},{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"cityId"}},{"kind":"Field","name":{"kind":"Name","value":"location"}},{"kind":"Field","name":{"kind":"Name","value":"totalPlaces"}},{"kind":"Field","name":{"kind":"Name","value":"pricePerHour"}},{"kind":"Field","name":{"kind":"Name","value":"otherAdresses"}},{"kind":"Field","name":{"kind":"Name","value":"maxHeight"}},{"kind":"Field","name":{"kind":"Name","value":"levels"}},{"kind":"Field","name":{"kind":"Name","value":"layout"}},{"kind":"Field","name":{"kind":"Name","value":"options"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"evChargers"}},{"kind":"Field","name":{"kind":"Name","value":"toilets"}},{"kind":"Field","name":{"kind":"Name","value":"disabledAccess"}},{"kind":"Field","name":{"kind":"Name","value":"disabledPlaces"}},{"kind":"Field","name":{"kind":"Name","value":"motorcycleAccess"}},{"kind":"Field","name":{"kind":"Name","value":"motorcyclePlaces"}},{"kind":"Field","name":{"kind":"Name","value":"bicycleAccess"}},{"kind":"Field","name":{"kind":"Name","value":"bicyclePlaces"}}]}},{"kind":"Field","name":{"kind":"Name","value":"openingHours"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"daysOfWeek"}},{"kind":"Field","name":{"kind":"Name","value":"daysOfMonth"}},{"kind":"Field","name":{"kind":"Name","value":"months"}},{"kind":"Field","name":{"kind":"Name","value":"timeOfDayStart"}},{"kind":"Field","name":{"kind":"Name","value":"timeOfDayEnd"}},{"kind":"Field","name":{"kind":"Name","value":"designatedPeriod"}},{"kind":"Field","name":{"kind":"Name","value":"designatedPeriodExcept"}}]}}]}}]}}]} as unknown as DocumentNode<OffStreetParkingQuery, OffStreetParkingQueryVariables>;
export const CreateOffStreetParkingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createOffStreetParking"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateOffStreetParkingInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createOffStreetParking"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"cityId"}},{"kind":"Field","name":{"kind":"Name","value":"location"}},{"kind":"Field","name":{"kind":"Name","value":"totalPlaces"}},{"kind":"Field","name":{"kind":"Name","value":"pricePerHour"}},{"kind":"Field","name":{"kind":"Name","value":"otherAdresses"}},{"kind":"Field","name":{"kind":"Name","value":"maxHeight"}},{"kind":"Field","name":{"kind":"Name","value":"levels"}},{"kind":"Field","name":{"kind":"Name","value":"layout"}},{"kind":"Field","name":{"kind":"Name","value":"options"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"evChargers"}},{"kind":"Field","name":{"kind":"Name","value":"toilets"}},{"kind":"Field","name":{"kind":"Name","value":"disabledAccess"}},{"kind":"Field","name":{"kind":"Name","value":"disabledPlaces"}},{"kind":"Field","name":{"kind":"Name","value":"motorcycleAccess"}},{"kind":"Field","name":{"kind":"Name","value":"motorcyclePlaces"}},{"kind":"Field","name":{"kind":"Name","value":"bicycleAccess"}},{"kind":"Field","name":{"kind":"Name","value":"bicyclePlaces"}}]}},{"kind":"Field","name":{"kind":"Name","value":"openingHours"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"daysOfWeek"}},{"kind":"Field","name":{"kind":"Name","value":"daysOfMonth"}},{"kind":"Field","name":{"kind":"Name","value":"months"}},{"kind":"Field","name":{"kind":"Name","value":"timeOfDayStart"}},{"kind":"Field","name":{"kind":"Name","value":"timeOfDayEnd"}},{"kind":"Field","name":{"kind":"Name","value":"designatedPeriod"}},{"kind":"Field","name":{"kind":"Name","value":"designatedPeriodExcept"}}]}}]}}]}}]} as unknown as DocumentNode<CreateOffStreetParkingMutation, CreateOffStreetParkingMutationVariables>;
export const UpdateOffStreetParkingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateOffStreetParking"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateOffStreetParkingInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateOffStreetParking"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"cityId"}},{"kind":"Field","name":{"kind":"Name","value":"location"}},{"kind":"Field","name":{"kind":"Name","value":"totalPlaces"}},{"kind":"Field","name":{"kind":"Name","value":"pricePerHour"}},{"kind":"Field","name":{"kind":"Name","value":"otherAdresses"}},{"kind":"Field","name":{"kind":"Name","value":"maxHeight"}},{"kind":"Field","name":{"kind":"Name","value":"levels"}},{"kind":"Field","name":{"kind":"Name","value":"layout"}},{"kind":"Field","name":{"kind":"Name","value":"options"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"evChargers"}},{"kind":"Field","name":{"kind":"Name","value":"toilets"}},{"kind":"Field","name":{"kind":"Name","value":"disabledAccess"}},{"kind":"Field","name":{"kind":"Name","value":"disabledPlaces"}},{"kind":"Field","name":{"kind":"Name","value":"motorcycleAccess"}},{"kind":"Field","name":{"kind":"Name","value":"motorcyclePlaces"}},{"kind":"Field","name":{"kind":"Name","value":"bicycleAccess"}},{"kind":"Field","name":{"kind":"Name","value":"bicyclePlaces"}}]}},{"kind":"Field","name":{"kind":"Name","value":"openingHours"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"daysOfWeek"}},{"kind":"Field","name":{"kind":"Name","value":"daysOfMonth"}},{"kind":"Field","name":{"kind":"Name","value":"months"}},{"kind":"Field","name":{"kind":"Name","value":"timeOfDayStart"}},{"kind":"Field","name":{"kind":"Name","value":"timeOfDayEnd"}},{"kind":"Field","name":{"kind":"Name","value":"designatedPeriod"}},{"kind":"Field","name":{"kind":"Name","value":"designatedPeriodExcept"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateOffStreetParkingMutation, UpdateOffStreetParkingMutationVariables>;
export const DeleteOffStreetParkingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteOffStreetParking"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteOffStreetParking"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<DeleteOffStreetParkingMutation, DeleteOffStreetParkingMutationVariables>;
export const PublishCitiesTilesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"PublishCitiesTiles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publishCitiesTiles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"citiesBoundariesTilesetId"}},{"kind":"Field","name":{"kind":"Name","value":"citiesCurbZoneParkingTilesetId"}}]}}]}}]} as unknown as DocumentNode<PublishCitiesTilesMutation, PublishCitiesTilesMutationVariables>;
export const CurbAreasDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"curbAreas"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cityId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"curbAreas"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"cityId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cityId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"geometry"}},{"kind":"Field","name":{"kind":"Name","value":"publishedDate"}}]}}]}}]} as unknown as DocumentNode<CurbAreasQuery, CurbAreasQueryVariables>;
export const CreateCurbAreaDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createCurbArea"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateCurbAreaInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createCurbArea"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"geometry"}},{"kind":"Field","name":{"kind":"Name","value":"publishedDate"}},{"kind":"Field","name":{"kind":"Name","value":"lastUpdatedDate"}}]}}]}}]} as unknown as DocumentNode<CreateCurbAreaMutation, CreateCurbAreaMutationVariables>;
export const UpdateCurbAreaDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateCurbArea"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateCurbAreaInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateCurbArea"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"geometry"}},{"kind":"Field","name":{"kind":"Name","value":"publishedDate"}},{"kind":"Field","name":{"kind":"Name","value":"lastUpdatedDate"}}]}}]}}]} as unknown as DocumentNode<UpdateCurbAreaMutation, UpdateCurbAreaMutationVariables>;
export const DeleteCurbAreaDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteCurbArea"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteCurbArea"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<DeleteCurbAreaMutation, DeleteCurbAreaMutationVariables>;
export const CurbZonesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CurbZones"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filterInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SearchCurbZoneInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"curbZones"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filterInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"calculatedArea"}},{"kind":"Field","name":{"kind":"Name","value":"calculatedSpaces"}},{"kind":"Field","name":{"kind":"Name","value":"cityId"}},{"kind":"Field","name":{"kind":"Name","value":"curbPolicies"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"curbPolicyId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"rules"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"maxStay"}},{"kind":"Field","name":{"kind":"Name","value":"maxStayUnit"}},{"kind":"Field","name":{"kind":"Name","value":"rate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rate"}},{"kind":"Field","name":{"kind":"Name","value":"rateUnit"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"timeSpans"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"daysOfWeek"}},{"kind":"Field","name":{"kind":"Name","value":"timeOfDayStart"}},{"kind":"Field","name":{"kind":"Name","value":"timeOfDayEnd"}}]}},{"kind":"Field","name":{"kind":"Name","value":"color"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dashed"}},{"kind":"Field","name":{"kind":"Name","value":"fillColor"}},{"kind":"Field","name":{"kind":"Name","value":"lineColor"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cityId"}},{"kind":"Field","name":{"kind":"Name","value":"publishedDate"}},{"kind":"Field","name":{"kind":"Name","value":"priority"}}]}},{"kind":"Field","name":{"kind":"Name","value":"curbPolicyIds"}},{"kind":"Field","name":{"kind":"Name","value":"editLine"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"geoPoint2d"}},{"kind":"Field","name":{"kind":"Name","value":"geometry"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"curbZoneId"}},{"kind":"Field","name":{"kind":"Name","value":"length"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"parkingAngle"}},{"kind":"Field","name":{"kind":"Name","value":"publishedDate"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"streetName"}},{"kind":"Field","name":{"kind":"Name","value":"streetNumberStart"}},{"kind":"Field","name":{"kind":"Name","value":"streetNumberEnd"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"decreeIds"}},{"kind":"Field","name":{"kind":"Name","value":"decrees"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<CurbZonesQuery, CurbZonesQueryVariables>;
export const CreateCurbZoneDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateCurbZone"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"curbZoneInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateCurbZoneInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createCurbZone"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"curbZoneInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"curbZoneInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"calculatedArea"}},{"kind":"Field","name":{"kind":"Name","value":"calculatedSpaces"}},{"kind":"Field","name":{"kind":"Name","value":"cityId"}},{"kind":"Field","name":{"kind":"Name","value":"curbPolicies"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"curbPolicyId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"rules"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"maxStay"}},{"kind":"Field","name":{"kind":"Name","value":"maxStayUnit"}},{"kind":"Field","name":{"kind":"Name","value":"rate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rate"}},{"kind":"Field","name":{"kind":"Name","value":"rateUnit"}}]}},{"kind":"Field","name":{"kind":"Name","value":"activity"}}]}},{"kind":"Field","name":{"kind":"Name","value":"timeSpans"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"daysOfWeek"}},{"kind":"Field","name":{"kind":"Name","value":"timeOfDayStart"}},{"kind":"Field","name":{"kind":"Name","value":"timeOfDayEnd"}}]}},{"kind":"Field","name":{"kind":"Name","value":"color"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dashed"}},{"kind":"Field","name":{"kind":"Name","value":"fillColor"}},{"kind":"Field","name":{"kind":"Name","value":"lineColor"}}]}},{"kind":"Field","name":{"kind":"Name","value":"priority"}},{"kind":"Field","name":{"kind":"Name","value":"cityId"}},{"kind":"Field","name":{"kind":"Name","value":"publishedDate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"curbPolicyIds"}},{"kind":"Field","name":{"kind":"Name","value":"editLine"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"geoPoint2d"}},{"kind":"Field","name":{"kind":"Name","value":"geometry"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"curbZoneId"}},{"kind":"Field","name":{"kind":"Name","value":"length"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"parkingAngle"}},{"kind":"Field","name":{"kind":"Name","value":"publishedDate"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"streetName"}},{"kind":"Field","name":{"kind":"Name","value":"streetNumberEnd"}},{"kind":"Field","name":{"kind":"Name","value":"streetNumberStart"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"decreeIds"}},{"kind":"Field","name":{"kind":"Name","value":"decrees"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<CreateCurbZoneMutation, CreateCurbZoneMutationVariables>;
export const UpdateCurbZoneDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateCurbZone"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"curbZoneInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateCurbZoneInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateCurbZone"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"curbZoneInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"curbZoneInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"calculatedArea"}},{"kind":"Field","name":{"kind":"Name","value":"calculatedSpaces"}},{"kind":"Field","name":{"kind":"Name","value":"cityId"}},{"kind":"Field","name":{"kind":"Name","value":"curbPolicies"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"curbPolicyId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"rules"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"maxStay"}},{"kind":"Field","name":{"kind":"Name","value":"maxStayUnit"}},{"kind":"Field","name":{"kind":"Name","value":"rate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rate"}},{"kind":"Field","name":{"kind":"Name","value":"rateUnit"}}]}},{"kind":"Field","name":{"kind":"Name","value":"activity"}}]}},{"kind":"Field","name":{"kind":"Name","value":"timeSpans"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"daysOfWeek"}},{"kind":"Field","name":{"kind":"Name","value":"timeOfDayStart"}},{"kind":"Field","name":{"kind":"Name","value":"timeOfDayEnd"}}]}},{"kind":"Field","name":{"kind":"Name","value":"color"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dashed"}},{"kind":"Field","name":{"kind":"Name","value":"fillColor"}},{"kind":"Field","name":{"kind":"Name","value":"lineColor"}}]}},{"kind":"Field","name":{"kind":"Name","value":"priority"}},{"kind":"Field","name":{"kind":"Name","value":"cityId"}},{"kind":"Field","name":{"kind":"Name","value":"publishedDate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"curbPolicyIds"}},{"kind":"Field","name":{"kind":"Name","value":"editLine"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"geoPoint2d"}},{"kind":"Field","name":{"kind":"Name","value":"geometry"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"curbZoneId"}},{"kind":"Field","name":{"kind":"Name","value":"length"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"parkingAngle"}},{"kind":"Field","name":{"kind":"Name","value":"publishedDate"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"streetName"}},{"kind":"Field","name":{"kind":"Name","value":"streetNumberEnd"}},{"kind":"Field","name":{"kind":"Name","value":"streetNumberStart"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"decreeIds"}},{"kind":"Field","name":{"kind":"Name","value":"decrees"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateCurbZoneMutation, UpdateCurbZoneMutationVariables>;
export const BulkUpdateCurbZoneDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"BulkUpdateCurbZone"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"bulkUpdateCurbZoneInputs"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateCurbZoneInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bulkUpdateCurbZones"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"curbZoneInputs"},"value":{"kind":"Variable","name":{"kind":"Name","value":"bulkUpdateCurbZoneInputs"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"calculatedArea"}},{"kind":"Field","name":{"kind":"Name","value":"calculatedSpaces"}},{"kind":"Field","name":{"kind":"Name","value":"cityId"}},{"kind":"Field","name":{"kind":"Name","value":"curbPolicies"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"curbPolicyId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"rules"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"maxStay"}},{"kind":"Field","name":{"kind":"Name","value":"maxStayUnit"}},{"kind":"Field","name":{"kind":"Name","value":"rate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rate"}},{"kind":"Field","name":{"kind":"Name","value":"rateUnit"}}]}},{"kind":"Field","name":{"kind":"Name","value":"activity"}}]}},{"kind":"Field","name":{"kind":"Name","value":"timeSpans"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"daysOfWeek"}},{"kind":"Field","name":{"kind":"Name","value":"timeOfDayStart"}},{"kind":"Field","name":{"kind":"Name","value":"timeOfDayEnd"}}]}},{"kind":"Field","name":{"kind":"Name","value":"color"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dashed"}},{"kind":"Field","name":{"kind":"Name","value":"fillColor"}},{"kind":"Field","name":{"kind":"Name","value":"lineColor"}}]}},{"kind":"Field","name":{"kind":"Name","value":"priority"}},{"kind":"Field","name":{"kind":"Name","value":"cityId"}},{"kind":"Field","name":{"kind":"Name","value":"publishedDate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"curbPolicyIds"}},{"kind":"Field","name":{"kind":"Name","value":"editLine"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"geoPoint2d"}},{"kind":"Field","name":{"kind":"Name","value":"geometry"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"curbZoneId"}},{"kind":"Field","name":{"kind":"Name","value":"length"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"parkingAngle"}},{"kind":"Field","name":{"kind":"Name","value":"publishedDate"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"streetName"}},{"kind":"Field","name":{"kind":"Name","value":"streetNumberEnd"}},{"kind":"Field","name":{"kind":"Name","value":"streetNumberStart"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"decreeIds"}},{"kind":"Field","name":{"kind":"Name","value":"decrees"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<BulkUpdateCurbZoneMutation, BulkUpdateCurbZoneMutationVariables>;
export const DeleteCurbZoneDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteCurbZone"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"curbZoneId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteCurbZone"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"curbZoneId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"curbZoneId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<DeleteCurbZoneMutation, DeleteCurbZoneMutationVariables>;
export const BulkDeleteCurbZonesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"BulkDeleteCurbZones"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"curbZoneIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bulkDeleteCurbZones"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"curbZoneIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"curbZoneIds"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<BulkDeleteCurbZonesMutation, BulkDeleteCurbZonesMutationVariables>;
export const TotalCalculatedSpacesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TotalCalculatedSpaces"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filterInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SearchCalculatedSpacesInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getTotalCalculatedSpaces"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filterInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filterInput"}}}]}]}}]} as unknown as DocumentNode<TotalCalculatedSpacesQuery, TotalCalculatedSpacesQueryVariables>;
export const CurbZoneStatsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CurbZoneStats"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filterInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SearchCurbZoneInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"curbZones"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filterInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"streetName"}},{"kind":"Field","name":{"kind":"Name","value":"calculatedArea"}},{"kind":"Field","name":{"kind":"Name","value":"calculatedSpaces"}},{"kind":"Field","name":{"kind":"Name","value":"curbPolicies"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"curbPolicyId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lineColor"}}]}}]}}]}}]}}]} as unknown as DocumentNode<CurbZoneStatsQuery, CurbZoneStatsQueryVariables>;
export const CurbZonesByParkingLotDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CurbZonesByParkingLot"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filterInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SearchCurbZoneInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"curbZones"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filterInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"curbZoneId"}}]}}]}}]} as unknown as DocumentNode<CurbZonesByParkingLotQuery, CurbZonesByParkingLotQueryVariables>;
export const CurbZonesShortenDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CurbZonesShorten"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filterInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SearchCurbZoneInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"curbZones"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filterInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"curbPolicies"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dashed"}},{"kind":"Field","name":{"kind":"Name","value":"fillColor"}},{"kind":"Field","name":{"kind":"Name","value":"lineColor"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"editLine"}},{"kind":"Field","name":{"kind":"Name","value":"geoPoint2d"}},{"kind":"Field","name":{"kind":"Name","value":"geometry"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"curbZoneId"}},{"kind":"Field","name":{"kind":"Name","value":"width"}}]}}]}}]} as unknown as DocumentNode<CurbZonesShortenQuery, CurbZonesShortenQueryVariables>;
export const DecreesPaginatedDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"DecreesPaginated"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cityId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pageIndex"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sortOrder"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"SortOrder"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sortField"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pageSize"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"decreesPaginated"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"cityId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cityId"}}},{"kind":"Argument","name":{"kind":"Name","value":"pageIndex"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pageIndex"}}},{"kind":"Argument","name":{"kind":"Name","value":"sortOrder"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sortOrder"}}},{"kind":"Argument","name":{"kind":"Name","value":"sortField"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sortField"}}},{"kind":"Argument","name":{"kind":"Name","value":"pageSize"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pageSize"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"results"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"cityId"}},{"kind":"Field","name":{"kind":"Name","value":"done"}},{"kind":"Field","name":{"kind":"Name","value":"publicUrl"}},{"kind":"Field","name":{"kind":"Name","value":"analyzed"}},{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"comments"}},{"kind":"Field","name":{"kind":"Name","value":"publishedDate"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"decreeNumber"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TemporaryDecree"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"temporaryType"},"name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"extension"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"originalDecreeReference"}},{"kind":"Field","name":{"kind":"Name","value":"originalDecreeNumber"}}]}},{"kind":"Field","name":{"kind":"Name","value":"restrictionsCount"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PermitDecree"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"permitType"},"name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalPages"}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<DecreesPaginatedQuery, DecreesPaginatedQueryVariables>;
export const TemporaryDecreesPaginatedDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TemporaryDecreesPaginated"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cityId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pageIndex"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sortOrder"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"SortOrder"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sortField"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pageSize"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"temporaryDecreesPaginated"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"cityId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cityId"}}},{"kind":"Argument","name":{"kind":"Name","value":"pageIndex"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pageIndex"}}},{"kind":"Argument","name":{"kind":"Name","value":"sortOrder"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sortOrder"}}},{"kind":"Argument","name":{"kind":"Name","value":"sortField"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sortField"}}},{"kind":"Argument","name":{"kind":"Name","value":"pageSize"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pageSize"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"results"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"cityId"}},{"kind":"Field","name":{"kind":"Name","value":"done"}},{"kind":"Field","name":{"kind":"Name","value":"publicUrl"}},{"kind":"Field","name":{"kind":"Name","value":"analyzed"}},{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"comments"}},{"kind":"Field","name":{"kind":"Name","value":"publishedDate"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"decreeNumber"}},{"kind":"Field","alias":{"kind":"Name","value":"temporaryType"},"name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"extension"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"originalDecreeReference"}},{"kind":"Field","name":{"kind":"Name","value":"originalDecreeNumber"}}]}},{"kind":"Field","name":{"kind":"Name","value":"restrictionsCount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalPages"}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<TemporaryDecreesPaginatedQuery, TemporaryDecreesPaginatedQueryVariables>;
export const UpdateDecreeCategoryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateDecreeCategory"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateDecreeCategoryInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateDecreeCategory"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"category"}}]}}]}}]} as unknown as DocumentNode<UpdateDecreeCategoryMutation, UpdateDecreeCategoryMutationVariables>;
export const RemoveDecreeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RemoveDecree"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeDecree"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<RemoveDecreeMutation, RemoveDecreeMutationVariables>;
export const UpdatePermanentDecreeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdatePermanentDecree"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"updateDecreeInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdatePermanentDecreeInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updatePermanentDecree"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"updateDecreeInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"updateDecreeInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdatePermanentDecreeMutation, UpdatePermanentDecreeMutationVariables>;
export const UpdateTemporaryDecreeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateTemporaryDecree"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"updateDecreeInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateTemporaryDecreeInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateTemporaryDecree"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"updateDecreeInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"updateDecreeInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdateTemporaryDecreeMutation, UpdateTemporaryDecreeMutationVariables>;
export const UpdatePermitDecreeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdatePermitDecree"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"updateDecreeInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdatePermitDecreeInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updatePermitDecree"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"updateDecreeInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"updateDecreeInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdatePermitDecreeMutation, UpdatePermitDecreeMutationVariables>;
export const TemporaryDecreeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TemporaryDecree"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cityId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"temporaryDecree"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"cityId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cityId"}}},{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"restrictions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"timeSpans"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"daysOfWeek"}},{"kind":"Field","name":{"kind":"Name","value":"daysOfMonth"}},{"kind":"Field","name":{"kind":"Name","value":"months"}},{"kind":"Field","name":{"kind":"Name","value":"timeOfDayStart"}},{"kind":"Field","name":{"kind":"Name","value":"timeOfDayEnd"}}]}},{"kind":"Field","name":{"kind":"Name","value":"decreeIds"}},{"kind":"Field","name":{"kind":"Name","value":"streetName"}},{"kind":"Field","name":{"kind":"Name","value":"streetNumberStart"}},{"kind":"Field","name":{"kind":"Name","value":"streetNumberEnd"}},{"kind":"Field","name":{"kind":"Name","value":"geometry"}},{"kind":"Field","name":{"kind":"Name","value":"curbZoneId"}},{"kind":"Field","name":{"kind":"Name","value":"decreeIds"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"editLine"}},{"kind":"Field","name":{"kind":"Name","value":"geoPoint2d"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"cityId"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"calculatedSpaces"}},{"kind":"Field","name":{"kind":"Name","value":"length"}}]}}]}}]}}]} as unknown as DocumentNode<TemporaryDecreeQuery, TemporaryDecreeQueryVariables>;
export const UpdateDecreeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateDecree"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"updateDecreeInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateDecreeInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateDecree"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"updateDecreeInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdateDecreeMutation, UpdateDecreeMutationVariables>;
export const ParkingLotsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"parkingLots"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cityId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"parkingLots"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"cityId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cityId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"geometry"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"cityId"}},{"kind":"Field","name":{"kind":"Name","value":"curbZoneIds"}}]}}]}}]} as unknown as DocumentNode<ParkingLotsQuery, ParkingLotsQueryVariables>;
export const CreateParkingLotDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createParkingLot"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateParkingLotInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createParkingLot"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"geometry"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"cityId"}},{"kind":"Field","name":{"kind":"Name","value":"curbZoneIds"}}]}}]}}]} as unknown as DocumentNode<CreateParkingLotMutation, CreateParkingLotMutationVariables>;
export const UpdateParkingLotDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateParkingLot"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateParkingLotInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateParkingLot"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"geometry"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"cityId"}},{"kind":"Field","name":{"kind":"Name","value":"curbZoneIds"}}]}}]}}]} as unknown as DocumentNode<UpdateParkingLotMutation, UpdateParkingLotMutationVariables>;
export const DeleteParkingLotDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteParkingLot"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteParkingLot"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<DeleteParkingLotMutation, DeleteParkingLotMutationVariables>;
export const GetParkingMetersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetParkingMeters"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cityId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getParkingMeters"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"cityId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cityId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"province"}},{"kind":"Field","name":{"kind":"Name","value":"streetName"}},{"kind":"Field","name":{"kind":"Name","value":"streetNumber"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"location"}},{"kind":"Field","name":{"kind":"Name","value":"cityId"}},{"kind":"Field","name":{"kind":"Name","value":"batteryLevel"}},{"kind":"Field","name":{"kind":"Name","value":"lastMaintenanceDate"}},{"kind":"Field","name":{"kind":"Name","value":"operator"}},{"kind":"Field","name":{"kind":"Name","value":"brand"}},{"kind":"Field","name":{"kind":"Name","value":"model"}},{"kind":"Field","name":{"kind":"Name","value":"zone"}},{"kind":"Field","name":{"kind":"Name","value":"options"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cash"}},{"kind":"Field","name":{"kind":"Name","value":"creditCard"}},{"kind":"Field","name":{"kind":"Name","value":"contactless"}}]}}]}}]}}]} as unknown as DocumentNode<GetParkingMetersQuery, GetParkingMetersQueryVariables>;
export const CreateParkingMeterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createParkingMeter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"createParkingMeterInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateParkingMeterInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createParkingMeter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"createParkingMeterInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"createParkingMeterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"province"}},{"kind":"Field","name":{"kind":"Name","value":"streetName"}},{"kind":"Field","name":{"kind":"Name","value":"streetNumber"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"location"}},{"kind":"Field","name":{"kind":"Name","value":"cityId"}},{"kind":"Field","name":{"kind":"Name","value":"batteryLevel"}},{"kind":"Field","name":{"kind":"Name","value":"lastMaintenanceDate"}},{"kind":"Field","name":{"kind":"Name","value":"operator"}},{"kind":"Field","name":{"kind":"Name","value":"brand"}},{"kind":"Field","name":{"kind":"Name","value":"model"}},{"kind":"Field","name":{"kind":"Name","value":"zone"}},{"kind":"Field","name":{"kind":"Name","value":"options"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cash"}},{"kind":"Field","name":{"kind":"Name","value":"creditCard"}},{"kind":"Field","name":{"kind":"Name","value":"contactless"}}]}}]}}]}}]} as unknown as DocumentNode<CreateParkingMeterMutation, CreateParkingMeterMutationVariables>;
export const UpdateParkingMeterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateParkingMeter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"updateParkingMeterInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateParkingMeterInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateParkingMeter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"updateParkingMeterInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"updateParkingMeterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"province"}},{"kind":"Field","name":{"kind":"Name","value":"streetName"}},{"kind":"Field","name":{"kind":"Name","value":"streetNumber"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"location"}},{"kind":"Field","name":{"kind":"Name","value":"cityId"}},{"kind":"Field","name":{"kind":"Name","value":"batteryLevel"}},{"kind":"Field","name":{"kind":"Name","value":"lastMaintenanceDate"}},{"kind":"Field","name":{"kind":"Name","value":"operator"}},{"kind":"Field","name":{"kind":"Name","value":"brand"}},{"kind":"Field","name":{"kind":"Name","value":"model"}},{"kind":"Field","name":{"kind":"Name","value":"zone"}},{"kind":"Field","name":{"kind":"Name","value":"options"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cash"}},{"kind":"Field","name":{"kind":"Name","value":"creditCard"}},{"kind":"Field","name":{"kind":"Name","value":"contactless"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateParkingMeterMutation, UpdateParkingMeterMutationVariables>;
export const RemoveParkingMeterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"removeParkingMeter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"meterId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeParkingMeter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"meterId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"meterId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<RemoveParkingMeterMutation, RemoveParkingMeterMutationVariables>;
export const PermitDecreesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PermitDecrees"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"permitDecreesInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"GetPermitDecreesInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"permitDecrees"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"permitDecreesInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"permitDecreesInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"done"}},{"kind":"Field","name":{"kind":"Name","value":"locations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"streetNumber"}},{"kind":"Field","name":{"kind":"Name","value":"streetName"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"province"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}},{"kind":"Field","name":{"kind":"Name","value":"position"}}]}}]}}]}}]} as unknown as DocumentNode<PermitDecreesQuery, PermitDecreesQueryVariables>;
export const AddPermitDecreeLocationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AddPermitDecreeLocation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"decreeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"location"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PermitDecreeLocationInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addPermitDecreeLocation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"decreeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"decreeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"location"},"value":{"kind":"Variable","name":{"kind":"Name","value":"location"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<AddPermitDecreeLocationMutation, AddPermitDecreeLocationMutationVariables>;
export const UpdatePermitDecreeLocationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdatePermitDecreeLocation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"decreeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"location"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PermitDecreeLocationInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updatePermitDecreeLocation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"decreeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"decreeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"location"},"value":{"kind":"Variable","name":{"kind":"Name","value":"location"}}},{"kind":"Argument","name":{"kind":"Name","value":"locationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdatePermitDecreeLocationMutation, UpdatePermitDecreeLocationMutationVariables>;
export const RemovePermitDecreeLocationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RemovePermitDecreeLocation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"decreeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removePermitDecreeLocation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"decreeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"decreeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"locationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"locations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"streetNumber"}},{"kind":"Field","name":{"kind":"Name","value":"streetName"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"province"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}},{"kind":"Field","name":{"kind":"Name","value":"position"}}]}}]}}]}}]} as unknown as DocumentNode<RemovePermitDecreeLocationMutation, RemovePermitDecreeLocationMutationVariables>;
export const PoliciesByCityIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"policiesByCityId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cityId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"policiesByCityId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"cityId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cityId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"curbPolicyId"}},{"kind":"Field","name":{"kind":"Name","value":"cityId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"priority"}},{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"rules"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"activity"}},{"kind":"Field","name":{"kind":"Name","value":"maxStay"}},{"kind":"Field","name":{"kind":"Name","value":"maxStayUnit"}},{"kind":"Field","name":{"kind":"Name","value":"noReturn"}},{"kind":"Field","name":{"kind":"Name","value":"noReturnUnit"}},{"kind":"Field","name":{"kind":"Name","value":"rate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rate"}},{"kind":"Field","name":{"kind":"Name","value":"endDuration"}},{"kind":"Field","name":{"kind":"Name","value":"incrementAmount"}},{"kind":"Field","name":{"kind":"Name","value":"incrementDuration"}},{"kind":"Field","name":{"kind":"Name","value":"rateUnit"}},{"kind":"Field","name":{"kind":"Name","value":"startDuration"}},{"kind":"Field","name":{"kind":"Name","value":"rateUnitPeriod"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userClasses"}}]}},{"kind":"Field","name":{"kind":"Name","value":"timeSpans"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"daysOfWeek"}},{"kind":"Field","name":{"kind":"Name","value":"daysOfMonth"}},{"kind":"Field","name":{"kind":"Name","value":"months"}},{"kind":"Field","name":{"kind":"Name","value":"timeOfDayStart"}},{"kind":"Field","name":{"kind":"Name","value":"timeOfDayEnd"}},{"kind":"Field","name":{"kind":"Name","value":"designatedPeriod"}},{"kind":"Field","name":{"kind":"Name","value":"designatedPeriodExcept"}}]}},{"kind":"Field","name":{"kind":"Name","value":"color"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dashed"}},{"kind":"Field","name":{"kind":"Name","value":"fillColor"}},{"kind":"Field","name":{"kind":"Name","value":"lineColor"}},{"kind":"Field","name":{"kind":"Name","value":"iconColor"}}]}},{"kind":"Field","name":{"kind":"Name","value":"publishedDate"}}]}}]}}]} as unknown as DocumentNode<PoliciesByCityIdQuery, PoliciesByCityIdQueryVariables>;
export const CreatePolicyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createPolicy"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"createPolicyInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreatePolicyInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createPolicy"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"createPolicyInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"createPolicyInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"curbPolicyId"}}]}}]}}]} as unknown as DocumentNode<CreatePolicyMutation, CreatePolicyMutationVariables>;
export const UpdatePolicyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updatePolicy"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"updatePolicyInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdatePolicyInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updatePolicy"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"updatePolicyInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"updatePolicyInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdatePolicyMutation, UpdatePolicyMutationVariables>;
export const DeletePolicyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deletePolicy"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"policyId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deletePolicy"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"policyId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"policyId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<DeletePolicyMutation, DeletePolicyMutationVariables>;
export const CurbZonesAndRestrictionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"curbZonesAndRestrictions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filterInputRestriction"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SearchRestrictionInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filterInputCurbZone"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SearchCurbZoneInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"restrictionsByBounding"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filterInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filterInputRestriction"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"curbZoneId"}},{"kind":"Field","name":{"kind":"Name","value":"geoPoint2d"}},{"kind":"Field","name":{"kind":"Name","value":"editLine"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"decreeIds"}},{"kind":"Field","name":{"kind":"Name","value":"geometry"}},{"kind":"Field","name":{"kind":"Name","value":"timeSpans"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"daysOfWeek"}},{"kind":"Field","name":{"kind":"Name","value":"daysOfMonth"}},{"kind":"Field","name":{"kind":"Name","value":"months"}},{"kind":"Field","name":{"kind":"Name","value":"timeOfDayStart"}},{"kind":"Field","name":{"kind":"Name","value":"timeOfDayEnd"}}]}},{"kind":"Field","name":{"kind":"Name","value":"decrees"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"streetName"}},{"kind":"Field","name":{"kind":"Name","value":"streetNumberStart"}},{"kind":"Field","name":{"kind":"Name","value":"streetNumberEnd"}},{"kind":"Field","name":{"kind":"Name","value":"cityId"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"calculatedSpaces"}},{"kind":"Field","name":{"kind":"Name","value":"length"}}]}},{"kind":"Field","name":{"kind":"Name","value":"curbZones"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filterInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filterInputCurbZone"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"calculatedArea"}},{"kind":"Field","name":{"kind":"Name","value":"calculatedSpaces"}},{"kind":"Field","name":{"kind":"Name","value":"cityId"}},{"kind":"Field","name":{"kind":"Name","value":"curbPolicies"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"curbPolicyId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"rules"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rate"}},{"kind":"Field","name":{"kind":"Name","value":"rateUnit"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"color"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dashed"}},{"kind":"Field","name":{"kind":"Name","value":"fillColor"}},{"kind":"Field","name":{"kind":"Name","value":"lineColor"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"editLine"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"geoPoint2d"}},{"kind":"Field","name":{"kind":"Name","value":"geometry"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"curbZoneId"}},{"kind":"Field","name":{"kind":"Name","value":"length"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"parkingAngle"}},{"kind":"Field","name":{"kind":"Name","value":"publishedDate"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"streetName"}},{"kind":"Field","name":{"kind":"Name","value":"streetNumberStart"}},{"kind":"Field","name":{"kind":"Name","value":"streetNumberEnd"}},{"kind":"Field","name":{"kind":"Name","value":"width"}}]}}]}}]} as unknown as DocumentNode<CurbZonesAndRestrictionsQuery, CurbZonesAndRestrictionsQueryVariables>;
export const CreateRestrictionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateRestriction"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateRestrictionInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createRestriction"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CreateRestrictionMutation, CreateRestrictionMutationVariables>;
export const UpdateRestrictionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateRestriction"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateRestrictionInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateRestriction"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdateRestrictionMutation, UpdateRestrictionMutationVariables>;
export const BulkUpdateRestrictionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"BulkUpdateRestrictions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BulkUpdateRestrictionsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bulkUpdateRestrictions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<BulkUpdateRestrictionsMutation, BulkUpdateRestrictionsMutationVariables>;
export const DeleteRestrictionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteRestriction"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteRestriction"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"curbZoneId"}}]}}]}}]} as unknown as DocumentNode<DeleteRestrictionMutation, DeleteRestrictionMutationVariables>;
export const BulkDeleteRestrictionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"BulkDeleteRestrictions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bulkDeleteRestrictions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}}]}]}}]} as unknown as DocumentNode<BulkDeleteRestrictionsMutation, BulkDeleteRestrictionsMutationVariables>;
export const UrbanFeaturesByBoundingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UrbanFeaturesByBounding"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"boundingbox"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cityId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"types"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UrbanFeatureType"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"urbanFeaturesByBounding"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"cityId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cityId"}}},{"kind":"Argument","name":{"kind":"Name","value":"boundingbox"},"value":{"kind":"Variable","name":{"kind":"Name","value":"boundingbox"}}},{"kind":"Argument","name":{"kind":"Name","value":"types"},"value":{"kind":"Variable","name":{"kind":"Name","value":"types"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"province"}},{"kind":"Field","name":{"kind":"Name","value":"streetName"}},{"kind":"Field","name":{"kind":"Name","value":"streetNumber"}}]}},{"kind":"Field","name":{"kind":"Name","value":"geometry"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"cityId"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"editLine"}},{"kind":"Field","name":{"kind":"Name","value":"width"}}]}}]}}]} as unknown as DocumentNode<UrbanFeaturesByBoundingQuery, UrbanFeaturesByBoundingQueryVariables>;
export const AddUrbanFeatureToCityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"addUrbanFeatureToCity"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"createUrbanFeaturesInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateUrbanFeaturesInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addUrbanFeatureToCity"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"createUrbanFeaturesInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"createUrbanFeaturesInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"province"}},{"kind":"Field","name":{"kind":"Name","value":"streetName"}},{"kind":"Field","name":{"kind":"Name","value":"streetNumber"}}]}},{"kind":"Field","name":{"kind":"Name","value":"geometry"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"cityId"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"editLine"}},{"kind":"Field","name":{"kind":"Name","value":"width"}}]}}]}}]} as unknown as DocumentNode<AddUrbanFeatureToCityMutation, AddUrbanFeatureToCityMutationVariables>;
export const UpdateUrbanFeatureDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateUrbanFeature"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"updateUrbanFeatureInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateUrbanFeatureInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateUrbanFeature"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"updateUrbanFeatureInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"updateUrbanFeatureInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"province"}},{"kind":"Field","name":{"kind":"Name","value":"streetName"}},{"kind":"Field","name":{"kind":"Name","value":"streetNumber"}}]}},{"kind":"Field","name":{"kind":"Name","value":"geometry"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"cityId"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"editLine"}},{"kind":"Field","name":{"kind":"Name","value":"width"}}]}}]}}]} as unknown as DocumentNode<UpdateUrbanFeatureMutation, UpdateUrbanFeatureMutationVariables>;
export const RemoveUrbanFeatureDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"removeUrbanFeature"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"urbanFeatureId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeUrbanFeature"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"urbanFeatureId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"urbanFeatureId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<RemoveUrbanFeatureMutation, RemoveUrbanFeatureMutationVariables>;
export const GetUserReportByCityIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUserReportByCityId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cityId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pageIndex"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pageSize"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sortOrder"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"SortOrder"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sortField"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getUserReportsByCityId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"cityId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cityId"}}},{"kind":"Argument","name":{"kind":"Name","value":"pageIndex"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pageIndex"}}},{"kind":"Argument","name":{"kind":"Name","value":"pageSize"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pageSize"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"sortOrder"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sortOrder"}}},{"kind":"Argument","name":{"kind":"Name","value":"sortField"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sortField"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"results"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"cityId"}},{"kind":"Field","name":{"kind":"Name","value":"attachedFilesUrls"}},{"kind":"Field","name":{"kind":"Name","value":"features"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"isDone"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalPages"}}]}}]}}]} as unknown as DocumentNode<GetUserReportByCityIdQuery, GetUserReportByCityIdQueryVariables>;
export const UpdateUserReportDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateUserReport"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"reportInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateUserReportInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateUserReport"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"reportInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"reportInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isDone"}}]}}]}}]} as unknown as DocumentNode<UpdateUserReportMutation, UpdateUserReportMutationVariables>;
export const FindWorkAreasDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"findWorkAreas"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cityId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"workAreas"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"cityId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cityId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"done"}},{"kind":"Field","name":{"kind":"Name","value":"geometry"}},{"kind":"Field","name":{"kind":"Name","value":"cityId"}}]}}]}}]} as unknown as DocumentNode<FindWorkAreasQuery, FindWorkAreasQueryVariables>;
export const CreateWorkAreaDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createWorkArea"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workAreaInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateWorkAreaInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createWorkArea"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workAreaInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workAreaInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"done"}},{"kind":"Field","name":{"kind":"Name","value":"geometry"}},{"kind":"Field","name":{"kind":"Name","value":"cityId"}}]}}]}}]} as unknown as DocumentNode<CreateWorkAreaMutation, CreateWorkAreaMutationVariables>;
export const UpdateWorkAreaDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateWorkArea"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workAreaInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateWorkAreaInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateWorkArea"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workAreaInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workAreaInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"done"}},{"kind":"Field","name":{"kind":"Name","value":"geometry"}},{"kind":"Field","name":{"kind":"Name","value":"cityId"}}]}}]}}]} as unknown as DocumentNode<UpdateWorkAreaMutation, UpdateWorkAreaMutationVariables>;
export const DeleteWorkAreaDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteWorkArea"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteWorkArea"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<DeleteWorkAreaMutation, DeleteWorkAreaMutationVariables>;